/* PETCHEFY Onboarding v2 — TFD-inspo re-skin.
 * Look & feel ported 1:1 from the petchefy-main design zip (Figtree/Caveat, cream/ink/coral);
 * state machine, calorie calc and Recharge trial checkout carried over from the previous
 * build. (Delivery pricing engine parked 2026-07-02 — see archive/delivery-pricing/.) */
(function () {
  'use strict';

  var root = document.querySelector('[data-onb2-root]');
  var cfgEl = document.querySelector('[data-onb2-config]');
  if (!root || !cfgEl) return;

  var CFG = JSON.parse(cfgEl.textContent);
  var A = CFG.assets;
  var PROMO = (CFG.settings && CFG.settings.promoText) || '🎉 Limited time: free shipping on your 6-day fresh trial';
  var RX_TO = (CFG.settings && CFG.settings.referralEmail) || 'hello@petchefy.com';
  var PHONE_DISPLAY = '(954) 459-3168', PHONE_SMS = 'sms:+19544593168';
  var SINK_URL = (CFG.settings && CFG.settings.funnelSinkUrl) || ''; // BigQuery funnel sink (empty = capture off)
  var SOCIAL = { instagram: 'https://instagram.com/petchefy', facebook: 'https://facebook.com/petchefy', tiktok: 'https://tiktok.com/@petchefy' };
  // Full FAQ page (swap to /pages/faq once that page handle is wired on the live theme).
  var FAQ_URL = '/pages/dog-food-plan?view=faq-v2';
  // Klaviyo newsletter list (footer signup). Client-side public subscribe — needs the PUBLIC
  // company id + newsletter list id (both non-secret). Empty = fall back to funnel capture only.
  var KLAVIYO_CID = (CFG.settings && CFG.settings.klaviyoCompanyId) || '';
  var KLAVIYO_LIST = (CFG.settings && CFG.settings.klaviyoNewsletterListId) || '';
  // ?debug=1 shipped a working "jump to any screen" menu to every visitor on the published
  // theme — including a buyable plan page for a dog nobody described (resolveVariant falls
  // back to 30 lbs when weight is missing). Keep the tool, but only where it belongs: the
  // theme editor, or a preview of a non-published theme.
  var DEBUG = /[?&]debug=1/.test(window.location.search) &&
    !!(window.Shopify && (window.Shopify.designMode || (window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')));
  var LS_KEY = 'petchefy_onboarding_v3'; // bumped: v3 flow merges count+names and weight+body

  /* ---------- commerce / checkout wiring (staged) ----------
   * Activates only once the section's `trialPlans` setting is filled with the real
   * trial selling-plan IDs. Until then, checkout falls back to the demo "Order started"
   * so the QA preview keeps working. No Recharge/Shopify writes happen here. */
  var COMMERCE = CFG.commerce || {};
  function parseJSON(v, fb) { try { return (typeof v === 'string' ? (JSON.parse(v || 'null') || fb) : (v || fb)); } catch (e) { return fb; } }
  var TRIAL_PLANS = parseJSON(COMMERCE.trialPlans, {});      // { "14": sellingPlanId, "28": ..., ... }
  var RECUR_DISCOUNTS = parseJSON(COMMERCE.recurDiscounts, {}); // { "14": 15, "28": 17, ... } (percent)
  // 2026-08-07: the first-box offer moved from 25% off the food to FREE SHIPPING, so this is
  // now 0 and the food shows at full price. The % is kept (not ripped out) because it's still
  // the only lever that keeps DISPLAYED trial prices equal to what Shopify actually charges —
  // if a % offer ever comes back, set it here AND on the TRIAL_CODE discount, or the plan page
  // lies about the total. Free shipping needs no math here: it's applied at checkout, and the
  // funnel never quoted a shipping figure to begin with.
  var TRIAL_DISC_PCT = (function () { var p = parseFloat(COMMERCE.trialDiscount); return Number.isFinite(p) ? p : 0; })();
  // Shopify code auto-applied on the way to checkout — free shipping, appliesOnSubscription=true
  // (REQUIRED: funnel carts are subscription lines and checkout silently drops the code without
  // it), and deliberately no recurring cycle limit so checkout's "Recurring shipments" line
  // doesn't quote "$8.99 every 6 days" — a cadence nobody keeps; the portal sets the real one.
  // Trade-off: renewals ride free until the portal/converter flow strips or supersedes the code.
  var TRIAL_CODE = (COMMERCE.trialCode || '').trim(); // empty = no discount hop
  var RECIPE_PROP_NAME = { turkey: 'Turkey & Sweet Potato', beef: 'Beef & Rice', chicken: 'Chicken & Oats', pork: 'Pork & Quinoa' };
  var PORTION_VARIANT = { full: 'Full Bowl', half: 'Half Bowl', topper: 'Topper Bowl' };

  function commerceReady() {
    return Array.isArray(COMMERCE.variants) && COMMERCE.variants.length > 0 && Object.keys(TRIAL_PLANS).length > 0;
  }

  // parse variant titles ("3 lbs / Full Bowl", "20 - 24 lbs / Half Bowl") into weight bands once
  var VARIANT_INDEX = (COMMERCE.variants || []).map(function (v) {
    var parts = String(v.title).split('/');
    if (parts.length < 2) return null;
    var nums = (parts[0].match(/\d+(\.\d+)?/g) || []).map(Number);
    if (!nums.length) return null;
    return { id: v.id, price: v.price, portion: parts[1].trim(), lo: nums[0], hi: nums.length > 1 ? nums[1] : nums[0] };
  }).filter(Boolean);

  function resolveVariant(weightLbs, portionKey) {
    var portion = PORTION_VARIANT[portionKey] || 'Full Bowl';
    var cands = VARIANT_INDEX.filter(function (x) { return x.portion === portion; });
    if (!cands.length) return null;
    var w = parseFloat(weightLbs); if (!Number.isFinite(w)) w = 30;
    var hit = cands.filter(function (x) { return w >= x.lo && w <= x.hi; });
    if (hit.length) return hit[0];
    var best = cands[0], bestD = Infinity;
    cands.forEach(function (x) { var d = Math.abs((x.lo + x.hi) / 2 - w); if (d < bestD) { bestD = d; best = x; } });
    return best;
  }

  // The weight range we actually make plans for, derived from the variant table itself
  // (never hardcoded — it moves if the bands do). Full Bowl is the reference: every
  // portion shares the same 30 bands, and Full is the one always offered.
  function variantRange() {
    var c = VARIANT_INDEX.filter(function (x) { return x.portion === 'Full Bowl'; });
    if (!c.length) return null;
    return {
      lo: Math.min.apply(null, c.map(function (x) { return x.lo; })),
      hi: Math.max.apply(null, c.map(function (x) { return x.hi; }))
    };
  }

  // How the weight a plan would be sized to sits against that range.
  // null = fine (or not enough info to judge yet); 'below' = we don't make a plan this
  // small (hard stop); 'above' = biggest plan we make, sell it but say so.
  function rangeState(d) {
    var r = variantRange();
    if (!r) return null;
    var w = parseFloat(guideWeight(d));
    if (!Number.isFinite(w) || !(w > 0)) return null;
    if (w < r.lo) return { side: 'below', lo: r.lo, hi: r.hi, w: w };
    if (w > r.hi) return { side: 'above', lo: r.lo, hi: r.hi, w: w };
    return null;
  }

  // Real per-day price ($) at a portion, summed across all dogs, from the SAME variants we charge.
  // Returns null when not wired (no variants / no resolve) so callers fall back to the kcal estimate.
  function variantDayPrice(portionKey) {
    if (!VARIANT_INDEX.length || !S.dogs || !S.dogs.length) return null;
    var total = 0;
    for (var i = 0; i < S.dogs.length; i++) {
      var d = S.dogs[i], v = resolveVariant(d.idealWeight || d.weight, portionKey);
      if (!v) return null;
      total += v.price / 100;
    }
    return total;
  }
  // First-box food total ($) = Σ over dogs of [ (unit¢ − floor(unit¢ × disc%)) × qty ].
  // At today's discPct of 0 (free-shipping offer) this is just unit × qty. The truncation
  // branch is kept because it mirrors EXACTLY how Shopify applies a *percentage* TRIAL_CODE
  // at checkout (verified live 2026-07-20, qa/trial-rounding-live-check.js): the per-UNIT
  // discount is TRUNCATED to the cent, then × quantity — e.g. at 25%, $3.83 → floor(95.75¢)
  // = 95¢ off → $2.88 × 8 = $23.04 (per-unit half-up gave $22.96, line-level $22.98 — both
  // wrong on the 60/90 bands). Delete it only if a % first-box offer is ruled out for good.
  // The RECURRING line needs no discount math: the selling plan carries no discount, so
  // checkout shows unit price × qty exactly. Null when not wired.
  function boxTotal(portionKey, discPct, qty) {
    if (!VARIANT_INDEX.length || !S.dogs || !S.dogs.length) return null;
    var totalCents = 0;
    for (var i = 0; i < S.dogs.length; i++) {
      var d = S.dogs[i], v = resolveVariant(d.idealWeight || d.weight, portionKey);
      if (!v) return null;
      totalCents += (v.price - Math.floor(v.price * discPct / 100)) * qty;
    }
    return totalCents / 100;
  }

  // even split, remainder to first recipe(s) — Decision D
  function splitRecipes(keys, totalUnits) {
    var k = keys.length; if (!k) return [];
    var base = Math.floor(totalUnits / k), rem = totalUnits - base * k;
    return keys.map(function (key) { var q = base + (rem > 0 ? 1 : 0); if (rem > 0) rem--; return { key: key, qty: q }; });
  }

  // build one /cart/add line per dog; returns null if not wired yet (-> demo fallback)
  function buildTrialCartItems() {
    if (!commerceReady()) return null;
    var tp = TRIAL_PLANS, recurD = RECUR_DISCOUNTS;
    var cadence = String(S.cadence), planId = tp[cadence];
    if (!planId) return null;
    var trialUnits = COMMERCE.trialUnits || 6, recurQty = parseInt(cadence, 10);
    var recipeKeys = (S.recipeSel || []).slice();
    if (!recipeKeys.length) return null;
    var portionKey = S.p2Portion || 'full';
    var items = [];
    for (var i = 0; i < S.dogs.length; i++) {
      var d = S.dogs[i], weight = d.idealWeight || d.weight;
      var v = resolveVariant(weight, portionKey);
      if (!v) return null;
      var disc = parseFloat(recurD[cadence]); if (!Number.isFinite(disc)) disc = 0;
      var split = splitRecipes(recipeKeys, trialUnits);
      var props = {
        _trial: 'true', _cadence_days: cadence, _recur_qty: String(recurQty),
        _recur_price: ((v.price / 100) * (1 - disc / 100)).toFixed(2),
        _dog_name: d.name || ('Pup ' + (i + 1)), _dog_weight: String(weight || '')
      };
      // bulk is a manual lead-gen handoff (wholesale pricing set by the team) — flag only, no auto %
      if (S.consolidate && S.dogCount > 1) props._bulk_pack = 'true';
      try { var k = kcalFor(d); if (k && k.kcal) props._target_calories = String(k.kcal); } catch (e) {}
      split.forEach(function (r) { props['Recipe: ' + (RECIPE_PROP_NAME[r.key] || r.key)] = String(r.qty); });
      items.push({ id: v.id, selling_plan: planId, quantity: trialUnits, properties: props });
    }
    return items;
  }

  function postTrialCheckout(items, btn, source) {
    // Restore the CTA so a failed attempt is retryable instead of a dead button.
    function releaseCta() {
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = 'Checkout';
    }
    // Re-running the funnel must REPLACE the trial box, never stack another one:
    // drop any existing _trial lines (leaves unrelated store items alone) before adding.
    // The cleanup is best-effort: if /cart.js is throttled (429) or /cart/change.js fails,
    // we still add. Losing the dedupe is a stacked trial box; letting it throw lost the sale.
    fetch('/cart.js')
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var stale = (cart.items || []).filter(function (it) { return it.properties && it.properties._trial === 'true'; });
        return stale.reduce(function (p, it) {
          return p.then(function () {
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
          });
        }, Promise.resolve()).catch(function () {});
      })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (r) { if (!r.ok) throw new Error('cart/add ' + r.status); return r.json(); })
      // Stamp the quiz session + ad onto the order (cart attributes become order
      // customAttributes): the deterministic join from every order to its quiz session
      // and the ad that drove it. FAIL-OPEN, non-negotiable: capped at 1.2s and every error
      // swallowed, so checkout never waits on or fails from this write. Rewritten on every
      // checkout click, so the most recent session wins. Restored 2026-09-26 (first shipped
      // 2026-08-29, lost when the 9/20 bulk-bags push overwrote the live file).
      .then(function () {
        try {
          var a = S.attr || {};
          var write = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { quiz_session_id: S.sid || '', quiz_ad_id: a.utm_content || '' } }) })
            .catch(function () {});
          return Promise.race([write, new Promise(function (res) { setTimeout(res, 1200); })]).catch(function () {});
        } catch (e) { return null; }
      })
      .then(function () { try { if (window.dataLayer) window.dataLayer.push({ event: 'add_to_cart', source: source || 'bowl_builder_trial' }); } catch (e) {} window.location.href = TRIAL_CODE ? '/discount/' + encodeURIComponent(TRIAL_CODE) + '?redirect=%2Fcheckout' : '/checkout'; })
      .catch(function (e) { console.error('[onb2 checkout]', e); releaseCta(); alert('Sorry — we couldn’t start checkout. Please try again.'); });
  }

  var BREEDS = ['Labrador Retriever', 'Golden Retriever', 'German Shepherd', 'French Bulldog', 'Bulldog', 'Standard Poodle', 'Miniature Poodle', 'Toy Poodle', 'Goldendoodle', 'Labradoodle', 'Bernedoodle', 'Schnoodle', 'Aussiedoodle', 'Cavapoo', 'Cockapoo', 'Maltipoo', 'Beagle', 'Rottweiler', 'Dachshund', 'Yorkshire Terrier', 'Boxer', 'Siberian Husky', 'Pembroke Welsh Corgi', 'Australian Shepherd', 'Border Collie', 'Shih Tzu', 'Chihuahua', 'Pomeranian', 'Great Dane', 'Doberman Pinscher', 'Bernese Mountain Dog', 'Cane Corso', 'English Mastiff', 'Belgian Malinois', 'Cavalier King Charles Spaniel', 'Boston Terrier', 'Bichon Frise', 'Havanese', 'Maltese', 'Pug', 'Shiba Inu', 'Akita', 'Samoyed', 'Dalmatian', 'Weimaraner', 'Vizsla', 'Rhodesian Ridgeback', 'Bloodhound', 'Basset Hound', 'Whippet', 'Greyhound', 'Pit Bull Terrier', 'American Staffordshire Terrier', 'Jack Russell Terrier', 'Miniature Schnauzer', 'West Highland White Terrier', 'Scottish Terrier', 'Cocker Spaniel', 'English Springer Spaniel', 'Brittany', 'German Shorthaired Pointer', 'Chow Chow', 'Newfoundland', 'Saint Bernard', 'Portuguese Water Dog', 'Unknown Mix'];

  var ISSUES = ['Seasonal allergies', 'Food sensitivities', 'Itchy skin & coat', 'Ear infections', 'Digestive issues', 'Joint pain or stiffness', 'Weight management', 'Dental / bad breath', 'Anxiety', 'Low energy', 'Pancreatitis', 'Kidney support', 'Heart condition', 'Diabetes', 'Cancer', 'Other'];

  var BODY_CARDS = [
    { title: 'Too skinny', desc: 'Ribs are easy to see', img: A.bodySkinny },
    { title: 'Just right', desc: 'Tucked waist, ribs easy to feel', img: A.bodyRight },
    { title: 'Rounded', desc: 'Waist is getting hard to spot', img: A.bodyRound },
    { title: 'Chunk', desc: 'We’ll work on it together', img: A.bodyChunky }
  ];
  var ACTIVITY_CARDS = [
    { emoji: '😴', title: 'Couch cuddler', desc: 'Short strolls & serious naps' },
    { emoji: '🦮', title: 'Daily walker', desc: 'Regular walks, mellow energy' },
    { emoji: '🏃', title: 'Zoomies regular', desc: 'Runs, fetch and park days' },
    { emoji: '🏅', title: 'Pro athlete', desc: 'Working dog or training partner' }
  ];
  var EATING_CARDS = [
    { emoji: '🙅', title: 'Very picky', desc: 'Often walks away from the bowl' },
    { emoji: '🤔', title: 'Can be picky', desc: 'Depends on the day' },
    { emoji: '😋', title: 'Good eater', desc: 'Finishes most meals' },
    { emoji: '🌪️', title: 'Vacuum mode', desc: 'Inhales anything edible' }
  ];

  /* Ingredients from the AAFCO adult formula reports; GA values from the Eurofins
   * analytical reports (as-received basis, Mar 2025) — chicken pending lab verification. */
  var RECIPE_BOOK = [
    {
      key: 'turkey', name: 'Turkey', full: 'Turkey & Sweet Potato',
      img: A.bagTurkey || A.bowlHero,
      desc: 'Lean, lighter poultry recipe for turkey lovers with sweet potato, gentle carbs, antioxidant-rich cranberries, and balanced fats for energy and flavor.',
      ing: 'Turkey, white rice, sweet potato, carrots, peas, celery, beef liver, spinach, cranberries, salmon oil, chia seeds, sunflower oil, and the PETCHEFY specialized vitamin & mineral blend.',
      ga: [['Crude Protein', 'min', '11.6%'], ['Crude Fat', 'min', '5.1%'], ['Crude Fiber', 'max', '1.0%'], ['Moisture', 'max', '69.6%']],
      kcalKg: '1,224 kcal/kg', lab: 'Lab-verified by Eurofins (ISO 17025), March 2025'
    },
    {
      key: 'beef', name: 'Beef', full: 'Beef & Rice',
      img: A.bagBeef || A.bowlBeef,
      desc: 'Hearty, protein-rich bowl best for active and picky dogs with classic beef flavor, steady energy, and omega-rich fats for everyday wellness.',
      ing: 'USDA beef, white rice, beef liver, apples, green beans, carrots, beets, spinach, salmon oil, sunflower oil, chia seeds, and the PETCHEFY specialized vitamin & mineral blend.',
      ga: [['Crude Protein', 'min', '11.3%'], ['Crude Fat', 'min', '9.6%'], ['Crude Fiber', 'max', '0.7%'], ['Moisture', 'max', '63.0%']],
      kcalKg: '1,706 kcal/kg', lab: 'Lab-verified by Eurofins (ISO 17025), March 2025'
    },
    {
      key: 'chicken', name: 'Chicken', full: 'Chicken & Oats',
      img: A.bagChicken || A.bowlHero,
      desc: 'Simple, lean, familiar recipe with chicken, oats, pumpkin, and healthy fats for balanced daily nutrition.',
      ing: 'Chicken, oats, pumpkin, green beans, carrots, spinach, sunflower oil, and the PETCHEFY specialized vitamin & mineral blend.',
      ga: [['Crude Protein', 'min', '10.2%'], ['Crude Fat', 'min', '4.6%'], ['Crude Fiber', 'max', '1.2%'], ['Moisture', 'max', '71.0%']],
      kcalKg: '', lab: ''
    },
    {
      key: 'pork', name: 'Pork', full: 'Pork & Quinoa',
      img: A.bagPork || A.bowlPork,
      desc: 'Rich, nutrient-dense recipe with healthy fats, colorful vegetables, blueberries, quinoa, and salmon oil.',
      ing: 'USDA pork, potato, quinoa, cucumber, zucchini, Brussels sprouts, green beans, beef liver, blueberries, flaxseeds, salmon oil, chia seeds, and the PETCHEFY specialized vitamin & mineral blend.',
      ga: [['Crude Protein', 'min', '8.8%'], ['Crude Fat', 'min', '6.2%'], ['Crude Fiber', 'max', '0.9%'], ['Moisture', 'max', '74.4%']],
      kcalKg: '1,121 kcal/kg', lab: 'Lab-verified by Eurofins (ISO 17025), March 2025'
    }
  ];

  var STEP_LABELS = {
    landing: 'Landing', intro: 'Welcome', me: 'Your pack', owner: 'About you',
    contact: 'Zip & email', calc: 'Calculating', plan: 'Your plan',
    profile: 'Profile', weightbody: 'Weight & body', activity: 'Activity',
    eating: 'Eating style', food: 'Current food', health: 'Health', feeding: 'Feeding style'
  };

  var DOG_STEPS = ['profile', 'weightbody', 'activity', 'eating', 'food', 'health'];
  var QUIZ_STEPS = ['me', 'owner', 'contact'].concat(DOG_STEPS).concat(['feeding']);

  /* shared inline SVGs (from the design zip) */
  var SVG_BACK = '<svg viewBox="8.5 5.5 7 13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var SVG_CHK = '<svg class="onb2-chk" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';
  var SVG_CHK_S = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>';

  /* landing section illustrations — single-ink line-art (same family as the credential seals),
   * sit to the right of each "how we make pet food healthy" list item. */
  /* "Why PETCHEFY?" line-art icons — 64×64, stroke 2.2, currentColor (same family as before) */
  var SVG_ART_POT = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M27 7c-1.4 1.9 1 3.3 1 5.4"/><path d="M36 7c-1.4 1.9 1 3.3 1 5.4"/><path d="M29 17h6"/><path d="M20 26c0-4.6 5.4-7.5 12-7.5s12 2.9 12 7.5"/><path d="M16 26h32v13c0 8-6.5 12.5-16 12.5S16 47 16 39z"/><path d="M16 31h-5M48 31h5"/></svg>';
  var SVG_ART_TRACK = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="20" y="6" width="24" height="52" rx="5"/><path d="M28 11h8"/><path d="M25 36l5.5-7 4 3.5L40 24"/><circle cx="40" cy="24" r="1.8"/><path d="M25 44h9M25 49h14"/></svg>';
  var SVG_ART_VET = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 7v13c0 8 5.5 13 12.5 13S44 28 44 20V7"/><path d="M19 7l-2.5-3M44 7l2.5-3"/><path d="M31.5 33v6c0 7 4 10 9 10h2"/><circle cx="48.5" cy="49" r="6"/><circle cx="48.5" cy="49" r="2"/></svg>';
  var SVG_ART_PORTION = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 20h34"/><path d="M18 20l3.5 12h21L46 20"/><rect x="13" y="36" width="38" height="14" rx="3"/><circle cx="32" cy="43" r="4"/><path d="M32 43l2.8-2.8"/><path d="M19 50v3M45 50v3"/></svg>';
  var SVG_ART_BASKET = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M24 26l8-14 8 14"/><path d="M10 26h44l-5.5 22a4 4 0 0 1-4 3H19.5a4 4 0 0 1-4-3z"/><path d="M24 34v9M32 34v9M40 34v9"/></svg>';
  var SVG_ART_PORTAL = '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="12" y="12" width="40" height="40" rx="8"/><path d="M20 24h24M20 32h24M20 40h24"/><circle cx="28" cy="24" r="2.6"/><circle cx="38" cy="32" r="2.6"/><circle cx="24" cy="40" r="2.6"/></svg>';

  /* ---------- state ---------- */

  function newDog() {
    return {
      name: '', sex: 'she', age: '', ageUnit: 'years', fixed: 'is', adj: 'cutest',
      breeds: [], weight: '', idealWeight: '', body: -1, activity: -1, eating: -1,
      foodType: 'dry kibble', brand: '', treats: 'some',
      hasIssues: 'doesn’t have', issues: [], rx: 'doesn’t', referralSent: false
    };
  }

  function funnelId() {
    return 'ob-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function freshState() {
    return {
      sid: funnelId(), seq: 0, capturedEmail: '', quizStartSent: false,
      stepIdx: 0, dogCount: 1, dogs: [newDog()],
      ownerFirst: '', belief: '', zip: '', email: '',
      breedQuery: '', breedAdding: false, calcPct: 0, calcMsg: 0,
      plan: 'full', // vestigial (superseded by p2Portion); kept for funnel-snapshot compat
      cadence: 28, p2Portion: 'full', consolidate: false, bulkModal: false, bulkSeen: false,
      bulkLeadModal: false, bulkLeadSent: false, bulkPhone: '', recipeSel: [], recipeModal: '', recipePicker: false,
      // bulk bags (phase 2). Pre-portioned is the recommended default since 2026-10-03; formatPicked
      // records an explicit choice (feeding step card or a plan-page switch). freezer/freezerInterest
      // are no longer asked — kept so an answer saved before that date still rides on the order.
      freezer: -1, freezerInterest: false, bulkFormat: 'pre', formatPicked: false, bulkMix: null, bulkMixModal: false,
      attr: null,
      started: false, jumpOpen: false, rxModal: false, rxEmail: '', waitlistModal: false, waitlistEmail: '', waitlistPhone: '', waitlistSent: false, infoModal: false, infoRecipe: '', whyModal: false, footerModal: '', nutritionModal: false, portionModal: false
    };
  }

  var S = freshState();
  try {
    var saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
    if (saved && typeof saved.stepIdx === 'number' && Array.isArray(saved.dogs) && saved.dogs.length) {
      // whitelist merge: only keys freshState() knows survive (stale keys from older builds drop),
      // and every saved dog is normalized onto newDog() so later-added fields always exist.
      Object.keys(S).forEach(function (k) { if (k in saved) S[k] = saved[k]; });
      S.dogs = saved.dogs.map(function (d) {
        var nd = Object.assign(newDog(), d);
        // repair sessions saved before the ideal-weight cleanup below: "just right" never
        // asks for an ideal, so any ideal stored against it is stale and must not size the plan
        if (nd.body === 1) nd.idealWeight = '';
        return nd;
      });
      // transient UI flags never resume open (bulkLeadSent persists: it gates duplicate leads)
      Object.assign(S, { calcPct: 0, calcMsg: 0, breedQuery: '', breedAdding: false, jumpOpen: false, started: false, rxModal: false, waitlistModal: false, recipeModal: '', recipePicker: false, infoModal: false, infoRecipe: '', whyModal: false, footerModal: '', bulkModal: false, bulkLeadModal: false, nutritionModal: false, portionModal: false, bulkMixModal: false });
      if (!Array.isArray(S.recipeSel)) S.recipeSel = [];
      // Sessions saved while bulk was the default carry bulkFormat 'bulk' nobody chose. Only an
      // explicit pick survives a reload; everyone else gets the recommended pre-portioned plan.
      if (S.formatPicked !== true || S.bulkFormat !== 'bulk') { S.bulkFormat = 'pre'; }
      if (commerceReady() && !TRIAL_PLANS[String(S.cadence)]) S.cadence = 28; // stale cadence from older builds
      if (!S.sid) S.sid = funnelId();
      if (!Number.isFinite(S.seq)) S.seq = 0;
      if (typeof S.capturedEmail !== 'string') S.capturedEmail = '';
      persist(); // re-save the normalized state so stale keys leave storage immediately
    }
  } catch (e) {}

  /* Record the campaign that brought them here. A fresh click carrying campaign params
   * always overwrites — the newest paid click is the one the spend belongs to. A visit
   * with no params (direct, organic, or a returning visitor) leaves the stored value
   * alone, so attribution is not wiped by someone reopening the funnel later. The very
   * first visit still records landing + referrer even with no params. */
  try {
    var attrNow = readAttribution();
    if (attrNow && (attrNow.hasCampaign || !S.attr)) { S.attr = attrNow; persist(); }
  } catch (e) {}

  var calcTimer = null;
  var lastAdvanceAt = 0; // debounce for the Continue action — see case 'next'

  function persist() {
    try {
      var copy = Object.assign({}, S);
      delete copy.calcPct; delete copy.calcMsg; delete copy.breedQuery; delete copy.breedAdding;
      delete copy.jumpOpen; delete copy.rxModal; delete copy.waitlistModal; delete copy.recipeModal; delete copy.recipePicker; delete copy.infoModal; delete copy.infoRecipe; delete copy.whyModal; delete copy.footerModal; delete copy.bulkModal; delete copy.bulkLeadModal; delete copy.nutritionModal; delete copy.portionModal; delete copy.bulkMixModal;
      localStorage.setItem(LS_KEY, JSON.stringify(copy));
    } catch (e) {}
  }

  function set(patch) { Object.assign(S, patch); persist(); }

  function updateDog(i, patch) {
    S.dogs = S.dogs.map(function (d, j) { return j === i ? Object.assign({}, d, patch) : d; });
    persist();
  }

  /* ---------- funnel capture (browser -> Cloud Function -> BigQuery) ----------
   * Starts the moment the email validates; every event carries the FULL snapshot so a
   * lost event is harmless. Fire-and-forget (no-cors + keepalive) — never blocks the UI. */

  /* ---------- campaign attribution ----------
   * The sink only ever sent window.location.host, so there was no way to join ad spend to
   * funnel drop-off. The SPA never rewrites the URL, so the ad click's params are still in
   * the address bar for the whole funnel — we capture them once at boot and carry them on
   * EVERY event (same principle as snapshot(): a lost event is then harmless).
   * Deliberately nested inside state rather than added as a new top-level payload key, so a
   * sink with a fixed top-level schema cannot reject the write. */
  function readAttribution() {
    // Declared INSIDE the function on purpose: this runs during boot, above the point where
    // a module-level `var` would have been assigned — hoisting would leave it undefined and
    // the caller's try/catch would swallow the TypeError, silently capturing nothing.
    var ATTR_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'utm_id', 'fbclid', 'gclid', 'ttclid', 'msclkid', 'twclid', 'epik', 'irclickid'];
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { return null; }
    var out = { hasCampaign: false };
    ATTR_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v) { out[k] = String(v).slice(0, 200); out.hasCampaign = true; }
    });
    try {
      out.landing = (window.location.pathname + window.location.search).slice(0, 500);
      out.referrer = String(document.referrer || '').slice(0, 300);
    } catch (e) {}
    out.ts = new Date().toISOString();
    return out;
  }

  function snapshot() {
    return {
      sid: S.sid, stepIdx: S.stepIdx, dogCount: S.dogCount, dogs: S.dogs,
      ownerFirst: S.ownerFirst, belief: S.belief, zip: S.zip, email: S.email, rxEmail: S.rxEmail, waitlistEmail: S.waitlistEmail, waitlistPhone: S.waitlistPhone, waitlistSent: S.waitlistSent,
      plan: S.plan, cadence: S.cadence, p2Portion: S.p2Portion,
      recipeSel: S.recipeSel, started: S.started,
      consolidate: S.consolidate, bulkPhone: S.bulkPhone,
      freezer: S.freezer, freezerInterest: S.freezerInterest, bulkFormat: S.bulkFormat, formatPicked: S.formatPicked, bulkMix: S.bulkMix, bulk: bulkSummary(),
      attr: S.attr
    };
  }

  function sendFunnel(step) {
    if (!SINK_URL) return;
    var email = trim(S.email);
    if (!emailOk(email)) return;
    S.seq += 1; persist();
    var payload = JSON.stringify({
      sessionId: S.sid, seq: S.seq, ts: new Date().toISOString(),
      step: step, email: email, host: window.location.host, state: snapshot()
    });
    try {
      fetch(SINK_URL, {
        method: 'POST', mode: 'no-cors', keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: payload
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- Quiz Start (top-of-funnel) ----------
   * Deliberately NOT sendFunnel(): its email gate (emailOk above) discards every
   * pre-email event, which is why completed:intro reads ~2 while email submits
   * read ~40 (docs/BRIEF-quiz-start-event.md). Quiz Start is the one signal that
   * must fire before an email can exist, so it gets its own path.
   *
   * Shopify.analytics.publish is the ONLY channel, on purpose. The GA4 custom
   * pixel and the Meta app pixel each subscribe to 'quiz_started' and forward to
   * their own destination. Nothing is pushed to dataLayer: GTM was removed from
   * event tracking after the triple-counting incident (GTM + sales-channel
   * config + theme code all firing the same events), and keeping GTM blind to
   * this event is what makes a repeat structurally impossible. */
  function publishQuizStart() {
    if (S.quizStartSent) return; // once per funnel session; back-nav to intro can't re-fire
    set({ quizStartSent: true });
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('quiz_started', { session_id: S.sid, quiz: 'onboarding-v2' });
      }
    } catch (e) {}
  }

  // Footer newsletter -> PETCHEFY Klaviyo list (client-side public subscribe; CORS-enabled).
  // Consent/double opt-in is handled by the list's setting in Klaviyo. No-op until configured.
  function klaviyoSubscribe(email) {
    if (!KLAVIYO_CID || !KLAVIYO_LIST || !emailOk(email)) return;
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_CID), {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Onboarding footer — Free Health & Nutrition Tips',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
          }
        })
      }).catch(function () {});
    } catch (e) {}
  }

  var emailCapTimer = null;
  function scheduleEmailCapture() {
    clearTimeout(emailCapTimer);
    var email = trim(S.email);
    if (!emailOk(email) || email === S.capturedEmail) return;
    emailCapTimer = setTimeout(function () {
      var now = trim(S.email);
      if (!emailOk(now) || now === S.capturedEmail) return;
      set({ capturedEmail: now });
      sendFunnel('email-captured');
    }, 900); // settle window: don't capture "a@b.co" while they're still typing "a@b.com"
  }

  /* ---------- flow ---------- */

  function flow() {
    var f = [{ t: 'landing' }, { t: 'intro' }, { t: 'me' }, { t: 'owner' }, { t: 'contact' }];
    for (var i = 0; i < S.dogCount; i++) {
      DOG_STEPS.forEach(function (t) { f.push({ t: t, dog: i }); });
    }
    // Household question, only when bulk bags are on: pre-portioned or bulk. Always in the flow
    // (never conditional on the pack) — stepIdx is a plain index, so a step that came and went
    // as the plan-page portion changed would shift every screen after it.
    if (BULK_ON) f.push({ t: 'feeding' });
    f.push({ t: 'calc' }, { t: 'plan' });
    return f;
  }

  function cur() {
    var f = flow();
    return f[Math.min(S.stepIdx, f.length - 1)];
  }

  function curDog() {
    var c = cur();
    var di = c.dog != null ? c.dog : 0;
    return S.dogs[di] || newDog();
  }

  function go(idx) {
    var f = flow();
    idx = Math.max(0, Math.min(f.length - 1, idx));
    var prevIdx = S.stepIdx;
    var changed = idx !== S.stepIdx;
    set({ stepIdx: idx, breedQuery: '', breedAdding: false });
    render();
    if (changed) { try { window.scrollTo({ top: 0 }); } catch (e) {} }
    // natural forward advance -> log the step just completed (only once email is captured)
    if (idx === prevIdx + 1 && f[prevIdx]) {
      var pst = f[prevIdx];
      // Leaving intro forward = Quiz Start. Own path — sendFunnel would drop it pre-email.
      if (pst.t === 'intro') publishQuizStart();
      sendFunnel('completed:' + pst.t + (pst.dog != null ? '-dog' + (pst.dog + 1) : ''));
    }
    if (f[idx].t === 'calc') startCalc();
  }

  function stepIndexOf(t) {
    var f = flow();
    for (var i = 0; i < f.length; i++) { if (f[i].t === t) return i; }
    return 0;
  }

  function startCalc() {
    clearInterval(calcTimer);
    S.calcPct = 0; S.calcMsg = 0;
    calcTimer = setInterval(function () {
      S.calcPct = Math.min(100, S.calcPct + 1.25);
      S.calcMsg = Math.min(4, Math.floor(S.calcPct / 21));
      var fill = root.querySelector('[data-calc-fill]');
      var msg = root.querySelector('[data-calc-msg]');
      if (fill) fill.style.width = Math.round(S.calcPct) + '%';
      if (msg) msg.textContent = calcMsgs()[S.calcMsg];
      if (S.calcPct >= 100) {
        clearInterval(calcTimer);
        calcTimer = null;
        setTimeout(function () { go(stepIndexOf('plan')); }, 400);
      }
    }, 55);
  }

  /* ---------- derived ---------- */

  function trim(s) { return (s || '').trim(); }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function fmt(v) { return '$' + v.toFixed(2); }

  function dogName(d) { return trim(d.name) || 'your dog'; }
  function dogPoss(d) { return trim(d.name) ? dogName(d) + '’s' : 'your dog’s'; }
  function pronSub(d) { return d.sex === 'he' ? 'He' : (d.sex === 'they' ? 'They' : 'She'); }
  function pronPos(d) { return d.sex === 'he' ? 'his' : (d.sex === 'they' ? 'their' : 'her'); }
  function spayWord(d) { return d.sex === 'he' ? 'neutered' : 'spayed'; }

  function emailOk(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trim(v)); }
  function zipOk() { return /^\d{5}$/.test(S.zip); }

  /* Delivery footprint. We only serve Florida today, so a well-formed ZIP is not the same
   * as a servable one — everything outside FL goes to the waitlist instead of being sold a
   * plan we cannot ship. Florida ZIPs run 32003-34997, i.e. the first three digits are
   * 320-349, and that block is exclusively Florida. */
  function flZip(z) {
    var s = trim(z);
    if (!/^\d{5}$/.test(s)) return false;
    var p = parseInt(s.slice(0, 3), 10);
    return p >= 320 && p <= 349;
  }
  function zipServed() { return flZip(S.zip); }
  function waitlistEmailVal() { return S.waitlistEmail || S.email; }
  function waitlistValid() { return emailOk(trim(waitlistEmailVal())); }

  // out-of-area callout — single source for initial render AND typing sync (see syncZip)
  function zipMsgHtml() {
    if (!zipOk() || zipServed()) return '';
    return '<div class="onb2-callout">' +
      'We deliver fresh food across <b>Florida</b> today, and we’re not in your area yet. ' +
      'Add your details on the next step and we’ll tell you the moment we reach you.' +
      '</div>';
  }

  /* email typo guard: "did you mean gmail.com?" for near-miss domains (non-blocking) */
  var MAIL_DOMAINS = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'icloud.com', 'aol.com', 'live.com', 'msn.com', 'comcast.net', 'me.com', 'mail.com', 'ymail.com', 'protonmail.com'];
  function dlDist(a, b, cap) {
    // Damerau-Levenshtein (with transposition), early-exit above cap
    var al = a.length, bl = b.length;
    if (Math.abs(al - bl) > cap) return cap + 1;
    var d = [];
    for (var i = 0; i <= al; i++) { d[i] = [i]; }
    for (var j = 0; j <= bl; j++) { d[0][j] = j; }
    for (i = 1; i <= al; i++) {
      var rowMin = Infinity;
      for (j = 1; j <= bl; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
        if (d[i][j] < rowMin) rowMin = d[i][j];
      }
      if (rowMin > cap) return cap + 1;
    }
    return d[al][bl];
  }
  function suggestEmail(v) {
    var e = trim(v).toLowerCase();
    var at = e.indexOf('@');
    if (at <= 0 || at === e.length - 1) return null;
    var local = e.slice(0, at), domain = e.slice(at + 1);
    if (domain.indexOf('.') < 0) return null;
    if (MAIL_DOMAINS.indexOf(domain) >= 0) return null;
    var best = null, bestD = 99;
    for (var i = 0; i < MAIL_DOMAINS.length; i++) {
      var cand = MAIL_DOMAINS[i];
      var cap = cand.length >= 9 ? 2 : 1;
      var dd = dlDist(domain, cand, cap);
      if (dd <= cap && dd < bestD) { bestD = dd; best = cand; }
    }
    return best ? (local + '@' + best) : null;
  }
  function emailHintHtml() {
    var fix = suggestEmail(S.email);
    if (!fix) return '';
    var at = fix.indexOf('@');
    return 'Did you mean <button type="button" class="onb2-hint-btn" data-act="email-fix" data-fix="' + esc(fix) + '">' +
      esc(fix.slice(0, at + 1)) + '<b>' + esc(fix.slice(at + 1)) + '</b></button>?';
  }

  // ideal-weight direction rule: skinny -> ideal must be ABOVE current; round/chunky -> BELOW.
  function idealRule(d) {
    var w = parseFloat(d.weight), iw = parseFloat(d.idealWeight);
    if (!(w > 0) || !(iw > 0)) return { filled: false, ok: false };
    if (d.body === 0) return { filled: true, ok: iw > w, dir: 'higher' };
    if (d.body === 2 || d.body === 3) return { filled: true, ok: iw < w, dir: 'lower' };
    return { filled: true, ok: true };
  }

  function canNext(c, d) {
    switch (c.t) {
      case 'me': return S.dogCount >= 1 && S.dogs.slice(0, S.dogCount).every(function (x) { return trim(x.name).length > 0; });
      case 'owner': return trim(S.ownerFirst).length > 0 && trim(S.belief).length > 0;
      case 'contact': return zipOk() && emailOk(S.email);
      case 'profile': return d.breeds.length > 0 && parseFloat(d.age) > 0;
      case 'weightbody': {
        if (!(parseFloat(d.weight) > 0) || d.body < 0) return false;
        // below the smallest band there is no plan to sell — stop here (rangeMsgHtml says why).
        // Above the largest we DO continue: biggest box + a follow-up, stated on-screen.
        var rs = rangeState(d);
        if (rs && rs.side === 'below') return false;
        if (d.body === 1) return true;
        var r = idealRule(d);
        return r.filled && r.ok;
      }
      case 'activity': return d.activity >= 0;
      case 'eating': return d.eating >= 0;
      default: return true; // includes 'feeding': pre-portioned is pre-selected, so there is nothing to wait for
    }
  }

  function kcalFor(d) {
    var w = parseFloat(d.idealWeight) || parseFloat(d.weight) || 30;
    var kg = w / 2.2046;
    var rer = 70 * Math.pow(kg, 0.75);
    var ageY = parseFloat(d.age) || 3;
    if (d.ageUnit === 'months') ageY /= 12;
    if (d.ageUnit === 'weeks') ageY /= 52;
    var life = ageY < 1 ? 2.0 : (ageY >= 8 ? 1.4 : (d.fixed === 'isn’t' ? 1.8 : 1.6));
    var act = [0.9, 1, 1.12, 1.24][d.activity >= 0 ? d.activity : 1];
    var body = [1.1, 1, 0.92, 0.85][d.body >= 0 ? d.body : 1];
    return { w: w, ageY: ageY, rer: Math.round(rer), life: life, act: act, body: body, kcal: Math.round(rer * life * act * body) };
  }

  /* Vet-team MER guideline (kcal/day) by adult body weight. 1–9 lb are exact; from 10 lb up each
   * listed weight covers a band until the next row (10→10-14, 15→15-19, … 100→100-109, 110→110-119),
   * so we match by the highest row whose weight ≤ the dog's weight. Source: PETCHEFY vet team. */
  var MER_GUIDE = [[1, 47], [2, 78], [3, 106], [4, 132], [5, 155], [6, 178], [7, 200], [8, 221], [9, 242], [10, 261], [15, 354], [20, 440], [25, 520], [30, 596], [35, 669], [40, 740], [45, 808], [50, 874], [55, 939], [60, 1002], [65, 1065], [70, 1125], [75, 1185], [80, 1244], [85, 1302], [90, 1359], [95, 1415], [100, 1470], [110, 1579], [120, 1686], [130, 1790], [140, 1893], [150, 1993], [175, 2237], [200, 2473]];
  function merFor(weightLbs) {
    var w = parseFloat(weightLbs);
    if (!(w > 0)) return null;
    var kcal = MER_GUIDE[0][1];
    for (var i = 0; i < MER_GUIDE.length; i++) { if (MER_GUIDE[i][0] <= w) kcal = MER_GUIDE[i][1]; else break; }
    return kcal;
  }
  // the weight a dog's plan is sized to: current weight if body's "just right", else their target
  function guideWeight(d) {
    var w = (d.body === 1) ? d.weight : (d.idealWeight || d.weight);
    var n = parseFloat(w); if (!(n > 0)) n = parseFloat(d.weight);
    return (n > 0) ? n : null;
  }
  function commas(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function pricePerDay(d) {
    return Math.min(12, Math.max(2, kcalFor(d).kcal * 0.00587));
  }

  /* delivery pricing engine parked 2026-07-02 — see archive/delivery-pricing/ to revisit */

  function calcMsgs() {
    var firstName = trim(S.dogs[0].name) || 'your pup';
    return [
      'Reading ' + firstName + '’s profile…',
      'Balancing protein, fat & calories…',
      'PETCHEFY AI is matching recipes…',
      bulkActive() ? 'Sizing bulk bags for the pack…' : 'Portioning every meal to the gram…',
      'Plating it up… 🍽️'
    ];
  }

  function rxEmailVal() { return S.rxEmail || S.email; }
  function rxEmailValid() { return emailOk(rxEmailVal()); }

  /* ---------- shared render helpers ---------- */

  // 'A, B & C' style list join — one core for joinNamesBold / planModel / bulkNamesPhrase
  function joinList(arr, lastSep) {
    if (!arr.length) return '';
    if (arr.length === 1) return arr[0];
    return arr.slice(0, -1).join(', ') + lastSep + arr[arr.length - 1];
  }

  function joinNamesBold() {
    var names = S.dogs.slice(0, Math.max(1, S.dogCount)).map(function (d) { return trim(d.name); }).filter(Boolean);
    if (!names.length) return '<b>' + (S.dogCount > 1 ? 'your dogs' : 'your dog') + '</b>';
    return joinList(names.map(function (n) { return '<b>' + esc(n) + '</b>'; }), ' and ');
  }

  // out-of-range callout — single source for initial render AND typing sync.
  // Below the smallest band we stop (we genuinely can't portion it); above the largest
  // we still sell, but we say plainly that it's our biggest box and we'll follow up.
  function rangeMsgHtml(d) {
    var r = rangeState(d);
    if (!r) return '';
    var msg = r.side === 'below'
      ? 'We don’t make a plan for dogs under <b>' + r.lo + ' lbs</b> yet. Email <a href="mailto:' + esc(RX_TO) + '">' + esc(RX_TO) + '</a> and we’ll sort out something that fits ' + esc(dogName(d)) + '.'
      : '<b>' + r.hi + ' lbs</b> is the largest plan we make, so ' + esc(dogName(d)) + ' will get our biggest box. We’ll follow up after your first order to get the portions right.';
    return '<div class="onb2-callout">' + msg + '</div>';
  }

  // ideal-weight direction callout — single source for initial render AND typing sync
  function idealMsgHtml(d) {
    var r = idealRule(d);
    if (!r.filled || r.ok) return '';
    var w = parseFloat(d.weight);
    var msg = d.body === 0
      ? esc(dogName(d)) + ' looks too skinny, so ' + pronPos(d) + ' ideal weight should be <b>higher</b> than ' + w + ' lbs.'
      : esc(dogName(d)) + ' looks a little rounder, so ' + pronPos(d) + ' ideal weight should be <b>lower</b> than ' + w + ' lbs.';
    return '<div class="onb2-callout">' + msg + '</div>';
  }

  // `aria` names the control for screen readers. The madlib sentence gives sighted users the
  // question; without this a screen reader announces only the VALUE — "She", "years",
  // "doesn't" — with no question attached, including on the prescription-diet gate.
  function selHtml(name, value, options, extraCls, aria) {
    // options: array of strings, or [value, label] pairs
    return '<select class="onb2-sel' + (extraCls ? ' ' + extraCls : '') + '" data-sel="' + name + '"' +
      (aria ? ' aria-label="' + esc(aria) + '"' : '') + '>' +
      options.map(function (o) {
        var v = Array.isArray(o) ? o[0] : o, l = Array.isArray(o) ? o[1] : o;
        return '<option value="' + esc(v) + '"' + (v === value ? ' selected' : '') + '>' + esc(l) + '</option>';
      }).join('') + '</select>';
  }

  function cardGrid(defs, field, d, withImg) {
    return '<div class="onb2-cards">' + defs.map(function (o, i) {
      var on = d[field] === i;
      return '<button type="button" class="onb2-card' + (on ? ' is-on' : '') + '" data-act="card" data-field="' + field + '" data-idx="' + i + '">' +
        (withImg
          ? '<div role="img" aria-label="' + esc(o.title) + '" class="onb2-card-img" style="background-image:url(\'' + o.img + '\')"></div>'
          : '<div class="onb2-card-emoji">' + o.emoji + '</div>') +
        '<div class="onb2-card-title">' + esc(o.title) + '</div>' +
        '<div class="onb2-card-desc">' + esc(o.desc) + '</div>' +
        '</button>';
    }).join('') + '</div>';
  }

  function imgSlot(label, height) {
    return '<div class="onb2-imgslot" style="height:' + height + ';">' +
      '<span>📷 ' + esc(label) + '</span></div>';
  }

  /* ---------- landing (content kept from previous build, re-skinned) ---------- */

  var VETQUOTES = [
    ['What sold me on PETCHEFY is the team behind it — board-certified nutritionists formulating human-grade recipes, not marketing. My patients show firmer stools and steadier energy within weeks.', 'Dr. Samantha Williams, DVM'],
    ['Freshly cooked and delivered every week — that consistency matters. Families actually stick with it, and their dogs’ coats and digestion show it. It’s the easiest fresh-food switch I recommend.', 'Dr. John Sweeney, DVM'],
    ['Portioning each meal to a dog’s real calorie needs is where most diets fall apart. PETCHEFY gets it right, which makes keeping a healthy weight so much simpler for the families I work with.', 'Dr. Sarah Alvarez, DVM']
  ];
  var vetIdx = 0;
  var heroUnmuted = false; // hero autoplays muted (browser requirement); tap the speaker to unmute
  var TEAM_ROWS = ['Board-certified veterinary nutritionists', 'PhDs in animal nutrition', 'Published, peer-reviewed research'];

  /* Credential seals for the landing trust strip. Rendered as single-ink line-art (no boxes,
   * no color) so they blend into the cream partner band the way the press row does. Each is a
   * consistent circular-seal family with a unique inner glyph; recognition rides on the label. */
  var CERTS = [
    ['WSAVA', '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><circle cx="20" cy="20" r="16.5"/><ellipse cx="20" cy="20" rx="7" ry="16.5"/><path d="M4 20h32M6.5 12.5h27M6.5 27.5h27"/></svg>', 'https://wsava.org'],
    ['USDA', '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="20" cy="20" r="16.5"/><path d="M20 29V15"/><path d="M20 19.5c-1.6-4-5.2-5.2-8.4-5.2 0 4.2 2.8 6.8 8.4 6.8"/><path d="M20 22.5c1.6-3.6 5.2-4.6 8.4-4.6 0 3.6-2.8 5.6-8.4 5.6"/></svg>', 'https://www.usda.gov'],
    ['AAFCO', '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 4.5l13.5 4.2v8.8c0 8.2-5.7 14.2-13.5 16.2C12.2 31.7 6.5 25.7 6.5 17.5V8.7z"/><path d="M14 20l4.4 4.4L27 15.8"/></svg>', 'https://www.aafco.org'],
    ['FL Dept. of Ag.', '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="20" cy="20" r="16.5"/><circle cx="20" cy="16.5" r="3.6"/><path d="M20 8.6V6.8M12.8 11.9l-1.2-1.2M27.2 11.9l1.2-1.2"/><path d="M6.5 24.5c4.2-3 8.4-3 13.5 0s9.3 3 13.5 0"/><path d="M6.5 28.6c4.2-3 8.4-3 13.5 0s9.3 3 13.5 0"/></svg>', 'https://www.fdacs.gov'],
    ['Association for Pet Obesity Prevention', '<svg viewBox="0 0 40 40" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 32.5C9.8 25.3 5 19.2 5 13.8 5 9.3 8.5 6.2 12.6 6.2c2.8 0 5.3 1.6 7.4 4.6 2.1-3 4.6-4.6 7.4-4.6 4.1 0 7.6 3.1 7.6 7.6 0 5.4-4.8 11.5-15 18.7z"/><path d="M10.5 18.5h5l2-3 3 6 2-3h6.5"/></svg>', 'https://www.petobesityprevention.org']
  ];
  // dup=true renders the seamless-marquee clone: clickable by mouse but kept out of the tab order
  // and the a11y tree (the group is aria-hidden) so keyboard users don't hit each link twice.
  function certItems(dup) {
    return CERTS.map(function (c) {
      return '<a class="onb2-cert" href="' + c[2] + '" target="_blank" rel="noopener"' +
        (dup ? ' tabindex="-1" aria-hidden="true"' : ' aria-label="' + esc(c[0]) + ' — opens in a new tab"') + '>' +
        '<span class="onb2-cert-mark">' + c[1] + '</span><span class="onb2-cert-l">' + esc(c[0]) + '</span></a>';
    }).join('');
  }
  function certMarquee() {
    return '<div class="onb2-certs" role="group" aria-label="Backed by WSAVA, USDA, AAFCO, the Florida Department of Agriculture, and the Association for Pet Obesity Prevention">' +
      '<div class="onb2-certs-track">' +
      '<div class="onb2-certs-group">' + certItems(false) + '</div>' +
      '<div class="onb2-certs-group" aria-hidden="true">' + certItems(true) + '</div>' +
      '</div></div>';
  }

  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M22 9l-6 6M16 9l6 6"/></svg>';
  var ICON_UNMUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>';
  function heroMuteIcon() { return heroUnmuted ? ICON_UNMUTED : ICON_MUTED; }

  function pressRow() {
    return '<div class="onb2-press-row">' +
      '<div style="font-weight:800;font-size:19px;letter-spacing:.02em;">NBC<span style="font-weight:400;">6</span> <span style="font-size:13px;font-weight:600;letter-spacing:.1em;">NEWS</span></div>' +
      '<div style="font-weight:600;font-size:18px;letter-spacing:.05em;">CBS NEWS MIAMI</div>' +
      '<div style="font-weight:800;font-style:italic;font-size:19px;">WSVN <span style="font-weight:400;">7</span>NEWS</div>' +
      '<div style="font-weight:800;font-size:19px;letter-spacing:.02em;">LOCAL <span style="font-weight:400;">10</span></div>' +
      '<div style="font-weight:600;font-size:16px;letter-spacing:.12em;">TELEMUNDO 51</div>' +
      '</div>';
  }

  function viewLanding() {
    var heroMedia;
    if (A.heroVideo) {
      // muted+playsinline are required for iOS autoplay; poster paints instantly while the
      // 6s loop streams in (faststart mp4). render() nudges play() for injected-DOM quirks.
      heroMedia = '<video class="onb2-land-hero-photo" autoplay muted loop playsinline preload="metadata"' +
        (A.heroPoster ? ' poster="' + A.heroPoster + '"' : '') + ' aria-hidden="true">' +
        '<source src="' + A.heroVideo + '" type="video/mp4">' +
        (A.happy1 ? '<img class="onb2-land-hero-photo" src="' + A.happy1 + '" alt="">' : '') +
        '</video>' +
        '<button type="button" class="onb2-hero-mute" data-act="hero-mute" aria-label="Toggle sound">' + heroMuteIcon() + '</button>';
    } else if (A.happy1) {
      heroMedia = '<img class="onb2-land-hero-photo" src="' + A.happy1 + '" alt="A happy PETCHEFY pup">';
    } else {
      heroMedia = imgSlot('Drop hero photo — pup, bowl & human', '480px');
    }
    var hero =
      '<div class="onb2-land-hero">' +
      heroMedia +
      '<div class="onb2-land-hero-overlay">' +
      '<h1>Give your dog a longer life.</h1>' +
      '<p>Nearly two extra years — that’s how much longer lean dogs lived in a landmark 14-year study.<span class="onb2-cite-wrap"><a class="onb2-hero-cite" href="' + (A.studyPdf || '#') + '" target="_blank" rel="noopener" aria-label="Effects of diet restriction on life span and age-related changes in dogs; JAVMA, Vol 220, No. 9, May 1, 2002">[1]</a><span class="onb2-cite-tip">Effects of diet restriction on life span and age-related changes in dogs; JAVMA, Vol 220, No. 9, May 1, 2002</span></span></p>' +
      '<button type="button" class="onb2-land-cta-coral" data-act="begin">See plans &amp; pricing</button>' +
      '<a class="onb2-land-hero-call" href="' + PHONE_SMS + '">Text us any time ' + PHONE_DISPLAY + '</a>' +
      '</div></div>';

    var partner =
      '<div class="onb2-land-partner">' +
      '<div class="onb2-cert-kicker">Formulated &amp; manufactured using trusted standards</div>' +
      certMarquee() +
      '<p>Formulated by experts: board-certified veterinary nutritionists, academicians, and scientists in dog nutrition.</p>' +
      '<div class="onb2-land-learn" data-act="info-open">Learn more</div>' +
      '</div>';

    var BOWLS = [['blendBeef', 'beef'], ['blendTurkey', 'turkey'], ['blendPork', 'pork'], ['blendChicken', 'chicken']];
    var blendList = BOWLS.filter(function (b) { return A[b[0]]; });
    var bowlMedia = blendList.length
      ? '<div class="onb2-bowlcarousel" data-act="bowl-modal" role="button" tabindex="0" aria-label="Tap a bowl for ingredients & nutrition">' +
        blendList.map(function (b, i) {
          return '<img class="onb2-bowlslide" src="' + A[b[0]] + '" alt="Fresh PETCHEFY ' + b[1] + ' bowl" data-recipe="' + b[1] + '" style="animation-delay:' + (i * -3.5) + 's" loading="lazy" decoding="async">';
        }).join('') +
        '</div>'
      : '<img src="' + (A.bowl || A.bowlHero) + '" alt="A fresh PETCHEFY bowl" class="onb2-land-bowl" loading="lazy" decoding="async">';
    var mission =
      '<div class="onb2-land-pad onb2-land-mission">' +
      bowlMedia +
      '<h2 class="onb2-land-h2">Your dog deserves real food, too.</h2>' +
      '<p class="onb2-land-body">Like you, we love our pets and care about their health. That’s why we created PETCHEFY: fresh, weekly-made meals with balanced nutrition, guided by science, and made for people who are obsessed with their dogs.</p>' +
      '<button type="button" class="onb2-land-cta-dark" data-act="begin">Build personalized plan</button>' +
      '</div>';

    // "Why PETCHEFY?" — copy from Why PETCHEFY (1).pdf; line-art icons sit LEFT of each
    // text block, and each row picks up a coral glow as it scrolls through the viewport
    // (observeWhyRows). Lighter cream shade separates it from the mission band above.
    var healthy =
      '<div class="onb2-land-pad onb2-land-healthy">' +
      '<h2 class="onb2-land-h2">Why PETCHEFY?</h2>' +
      '<div class="onb2-land-list onb2-land-list--art">' +
      [['Cooked fresh every week', 'Every batch is gently cooked to maximize nutrient bioavailability and palatability. Meals are made from scratch weekly in a commercial kitchen built for serving humans and delivered within days — not left sitting in a bag for months.', SVG_ART_POT],
       ['Smart health tracking built in', 'Log in to the app for smart health tracking built around your dog. Monitor weight, calories, meals, and vet records in one place — then get clear next steps as their body changes.', SVG_ART_TRACK],
       ['Formulated by nutrition experts', 'Our recipes are developed with veterinary nutrition experts to support complete, balanced daily feeding — not just “clean” ingredients.', SVG_ART_VET],
       ['Portioned for your dog’s body', 'Take the quiz and we calculate meals around your dog’s weight, age, activity, body condition, and goals. No more scoop-and-guess feeding.', SVG_ART_PORTION],
       ['Real ingredients, humans can eat', 'We source from distributors trusted by restaurants and supermarkets, then prepare meals in kitchens used to make human food.', SVG_ART_BASKET],
       ['Client portal — you’re in control 24/7', 'Change recipes, adjust portions, reschedule deliveries, update payment, review past orders, and manage upcoming shipments from one simple portal.', SVG_ART_PORTAL]].map(function (x) {
        return '<div class="onb2-land-listrow">' +
          '<div class="onb2-land-listart" aria-hidden="true">' + x[2] + '</div>' +
          '<div class="onb2-land-listtext"><div class="onb2-land-list-t">' + x[0] + '</div><p class="onb2-land-list-d">' + x[1] + '</p></div>' +
          '</div>';
      }).join('') +
      '</div></div>';

    var fresh =
      '<div class="onb2-land-dark">' +
      '<h2>It’s time for a fresh approach to pet food</h2>' +
      '<p>“Fresh” should tell you where—and when. Ours does: Fresh, made every week. Real, human-grade ingredients, cooked by us and delivered straight to you. <button type="button" class="onb2-land-u onb2-land-ubtn" data-act="why-open">Learn more about the importance of real food.</button></p>' +
      '<div class="onb2-land-strike"><div class="onb2-land-strike-t"><s>“Meat Meal”</s></div><p>Powdered meat can hide the cut, quality, and source. We use real meat you can see.</p></div>' +
      '<div class="onb2-land-strike"><div class="onb2-land-strike-t"><s>“By-products”</s></div><p>No mystery parts. No label games. Just whole ingredients you can recognize.</p></div>' +
      '<div class="onb2-land-strike"><div class="onb2-land-strike-t"><s>“Outsourced Manufacturing”</s></div><p>Most national brands outsource production. We don’t. Made by us in Miami, every week. No mystery factory. No mystery ingredients. No mystery timeline.</p></div>' +
      '</div>';

    var easier =
      '<div class="onb2-land-pad">' +
      '<h2 class="onb2-land-h2">Feed them better. Think about it less.</h2>' +
      '<p class="onb2-land-body">We match your dog with a vet-developed plan and deliver every meal before you need to restock.</p>' +
      '<div class="onb2-land-kicker">Plan features</div>' +
      '<div class="onb2-land-features">' +
      ['Flexible delivery scheduling', 'Same-day delivery via Uber or Roadie', 'Live support by text', 'AI nutrition assistant for weight management', 'Collaborate with your vet on nutrition'].map(function (f) {
        return '<div class="onb2-land-feature-t">' + f + '</div>';
      }).join('') +
      '</div></div>';

    var steps =
      '<div class="onb2-land-pad">' +
      '<div class="onb2-land-steps" data-steps>' +
      '<div class="onb2-steps-line" data-steps-line aria-hidden="true"><div class="onb2-steps-fill" data-steps-fill></div></div>' +
      [['1', 'Tell us about your pup', 'Answer a few questions and PETCHEFY AI builds personalized portions to meet their unique nutritional and caloric needs.'],
       ['2', 'Try it out', 'To start, you’ll get your first box with a 6-day fresh trial — shipped free, perfect for your dog to get a taste.'],
       ['3', 'Fall in love', 'If you and your dog love it — we think you will! — you’ll start receiving boxes automatically whenever you’re running low.']].map(function (s) {
        return '<div class="onb2-land-step"><div class="onb2-land-step-n">' + s[0] + '</div><div><div class="onb2-land-step-t">' + s[1] + '</div><p class="onb2-land-step-d">' + s[2] + '</p></div></div>';
      }).join('') +
      '</div>' +
      '<div style="text-align:center;margin-top:28px;"><button type="button" class="onb2-land-cta-dark" data-act="begin">Build my plan</button></div>' +
      '</div>';

    var scienceBand =
      '<div class="onb2-land-tint">' +
      '<h2 class="onb2-land-h2">Driven by science</h2>' +
      '<p class="onb2-land-body" style="margin-bottom:0;">We combine decades of dog nutrition research with the clinical insights of experienced vet professionals — then let PETCHEFY AI fine-tune every bowl.</p>' +
      (window.PCFY_ASSISTANT_WIDGET ? '<div class="onb2-science-media">' + window.PCFY_ASSISTANT_WIDGET + '</div>' : '') +
      '</div>';

    var q = VETQUOTES[vetIdx % 3];
    var vetsBlock =
      '<div class="onb2-land-pad">' +
      '<h2 class="onb2-land-h2">Loved by vets</h2>' +
      '<p class="onb2-land-body" style="max-width:320px;">Veterinary professionals recommend fresh food — and feed it to their own dogs.</p>' +
      '<p class="onb2-land-vetquote" data-vet-quote>“' + esc(q[0]) + '”</p>' +
      '<div class="onb2-land-vetname" data-vet-name>' + esc(q[1]) + '</div>' +
      '<div class="onb2-land-vetnav">' +
      '<button type="button" class="onb2-land-vetbtn" data-act="vet-prev">‹</button>' +
      '<div class="onb2-land-vetcounter" data-vet-counter>' + ((vetIdx % 3) + 1) + ' / 3</div>' +
      '<button type="button" class="onb2-land-vetbtn" data-act="vet-next">›</button>' +
      '</div></div>';

    var outcomes =
      '<div class="onb2-land-pad">' +
      '<div class="onb2-land-outcomes">' +
      ['Increased vitality', 'Clear skin &amp; shiny coat', 'Less “dog odor”', 'Better #2'].map(function (o) {
        return '<div class="onb2-land-outcome"><div class="onb2-land-outcome-c">✓</div><div class="onb2-land-outcome-t">' + o + '</div></div>';
      }).join('') +
      '</div>' +
      '<div class="onb2-land-polaroid">' +
      ((A.polaroid || A.ofTesti1) ? '<img src="' + (A.polaroid || A.ofTesti1) + '" alt="Benji, a happy PETCHEFY dog with our Turkey & Sweet Potato recipe" loading="lazy" decoding="async">' : imgSlot('happy customer photo', '270px')) +
      '<div class="onb2-land-polaroid-cap">Benji</div></div>' +
      '<p class="onb2-land-pullquote">“My Benji was the pickiest eater. I tried every high-end food under the sun, often needing to hand feed him to eat. We switched to PETCHEFY and I’ve not had to supervise his eating since. He licks his bowl clean every meal, and has never looked healthier or been happier about his food. The subscription and delivery process is seamless — thank you for changing our lives!”</p>' +
      '<div class="onb2-land-pullby">— Benji’s mom, Miami FL</div>' +
      '</div>';

    var press =
      '<div class="onb2-press">' +
      '<div class="onb2-press-kicker">As seen on</div>' + pressRow() + '</div>';

    var footer =
      '<div class="onb2-land-footer">' +
      '<div class="onb2-land-footer-links">' +
      [['The Fresh Digest', 'digest-open'], ['FAQ', '', FAQ_URL], ['Affiliates', 'affiliates-open'], ['For Vet Professionals', 'vet-open']].map(function (l) {
        if (l[2]) return '<a href="' + l[2] + '">' + l[0] + '</a>';
        return l[1] ? '<div data-act="' + l[1] + '">' + l[0] + '</div>' : '<div>' + l[0] + '</div>';
      }).join('') +
      '</div>' +
      '<div class="onb2-land-footer-block"><div class="onb2-land-footer-h">Get Support <span class="onb2-land-footer-it">Available 24/7</span></div>' +
      '<div class="onb2-land-footer-line">' + esc(RX_TO) + '</div>' +
      '<div class="onb2-land-footer-line">' + PHONE_DISPLAY + ' – Call or Text</div></div>' +
      '<div class="onb2-land-footer-block"><div class="onb2-land-footer-h">Connect</div>' +
      '<div class="onb2-land-footer-line">Media Inquiries</div><div class="onb2-land-footer-line">Partnership Inquiries</div>' +
      '<div class="onb2-land-footer-social">' +
      '<a href="' + SOCIAL.instagram + '" target="_blank" rel="noopener">Instagram</a>' +
      '<a href="' + SOCIAL.facebook + '" target="_blank" rel="noopener">Facebook</a>' +
      '<a href="' + SOCIAL.tiktok + '" target="_blank" rel="noopener">TikTok</a>' +
      '</div></div>' +
      '<div class="onb2-land-footer-block"><div class="onb2-land-footer-h" style="margin-bottom:10px;">Free Health and Nutrition Tips</div>' +
      '<div class="onb2-land-news"><input type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="Email" aria-label="Email for health and nutrition tips" data-in="news-email" value="' + esc(S.email) + '"><button type="button" data-act="news-submit">Submit</button></div></div>' +
      '<p class="onb2-land-footer-note">Our food is cooked to an upbeat salsa playlist and shipped with ❤️ across South Florida</p>' +
      '<div class="onb2-land-footer-rule"></div>' +
      '<div class="onb2-land-footer-legal">© 2026 PETCHEFY, Inc.<div class="onb2-land-footer-tm">Give your pup a healthy life™</div>' +
      // Privacy and Terms are real links now — they were bare spans that looked clickable and
      // went nowhere, which is a bad look on an ad landing page and a problem for ad review.
      // "Do Not Sell My Personal Information" removed by request. Accessibility is still a
      // span (no page to point it at yet).
      '<div class="onb2-land-footer-legrow">' +
      '<a href="/policies/privacy-policy">Privacy</a>' +
      '<a href="/pages/terms-conditions">Terms</a>' +
      '<span>Accessibility</span>' +
      '</div></div>' +
      '</div>';

    // sticky start CTA — revealed by updateLandCta() once the hero button scrolls away
    var stickyCta =
      '<div class="onb2-land-stickycta" data-land-cta>' +
      '<button type="button" class="onb2-land-cta-coral" data-act="begin">See plans &amp; pricing</button>' +
      '</div>';
    return '<div class="onb2-land2">' + hero + partner + mission + healthy + fresh + easier + steps + scienceBand + vetsBlock + outcomes + press + footer + stickyCta + '</div>';
  }

  /* ---------- intro (zip index.html, replaces old welcome) ---------- */

  function viewIntro() {
    var feats =
      '<div class="onb2-feats">' +
      '<div class="onb2-feat">' +
      '<svg viewBox="0 0 48 48" fill="none" stroke="#231f20" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M8 25h32a16 16 0 0 1-32 0z"/><path d="M14 25c2.5-4.5 17.5-4.5 20 0"/>' +
      '<path d="M21 10c-1.6 2.2 1.6 3.8 0 6.2" stroke="#ff5757"/><path d="M27 10c-1.6 2.2 1.6 3.8 0 6.2" stroke="#ff5757"/></svg>' +
      '<span class="lbl">Human-grade food</span></div>' +
      '<div class="onb2-feat">' +
      '<svg viewBox="0 0 48 48" fill="none" stroke="#231f20" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
      '<rect x="11" y="12" width="26" height="26" rx="2"/><path d="M11 21h26"/>' +
      '<circle cx="24" cy="29" r="3.6" fill="#ff5757" stroke="none"/></svg>' +
      '<span class="lbl">Ready to serve</span></div>' +
      '<div class="onb2-feat">' +
      '<svg viewBox="0 0 48 48" fill="none" stroke="#231f20" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M16 10h16v28H16z"/><path d="M29 24h.5"/>' +
      '<rect x="30" y="30" width="9" height="8" rx="1"/><circle cx="34.5" cy="34" r="2.4" fill="#ff5757" stroke="none"/></svg>' +
      '<span class="lbl">Delivered fresh</span></div>' +
      '</div>';

    var foot =
      '<div class="onb2-darkfoot">' +
      '<div class="peyebrow">AS SEEN IN</div>' +
      '<div class="pressrow">' + pressRow() + '</div>' +
      // same fix as the landing footer — these were dead spans too
      '<div class="flinks"><a href="/pages/terms-conditions">Terms of Service</a><a href="/policies/privacy-policy">Privacy Policy</a></div>' +
      '<div class="copy">© 2026 PETCHEFY, Inc.</div>' +
      '</div>';

    return '<div class="onb2-intro">' +
      '<h1>Fresher food,<br>happier dogs</h1>' +
      '<p class="onb2-intro-sub">A few quick questions to get your dog’s fresh plan started.</p>' +
      '<button type="button" class="onb2-intro-cta" data-act="intro-next">Continue</button>' +
      '<p class="onb2-intro-note">Takes about 3 minutes per dog.</p>' +
      '<hr class="onb2-hr">' +
      feats +
      '</div>' + foot;
  }

  /* ---------- me (count + names, zip me.html) ---------- */

  function nameRowHtml(i, visible) {
    var d = S.dogs[i] || newDog();
    var filled = trim(d.name).length > 0;
    return '<div class="onb2-namerow' + (visible ? '' : ' is-hidden') + '" data-row-idx="' + i + '">' +
      (i >= 1 ? '<span class="onb2-amp">&amp;</span>' : '') +
      '<input class="onb2-namein' + (filled ? ' filled' : '') + '" data-in="name" data-idx="' + i + '" value="' + esc(d.name) + '" placeholder="enter pet’s name" autocapitalize="words" autocomplete="off">' +
      '</div>';
  }

  function nameRowsHtml() {
    var filled = 0;
    for (var i = 0; i < S.dogCount; i++) { if (trim((S.dogs[i] || {}).name)) filled++; else break; }
    var visibleCount = Math.min(S.dogCount, filled + 1);
    var out = '';
    for (var j = 0; j < S.dogCount; j++) out += nameRowHtml(j, j < visibleCount);
    return out;
  }

  function viewMe() {
    var n = S.dogCount;
    return '<div class="onb2-screen onb2-screen--tight">' +
      '<img class="onb2-me-illus" src="' + (A.dogs || A.bowlHero) + '" alt="PETCHEFY dogs">' +
      '<div class="onb2-sentence">' +
      '<span>I have</span>' +
      '<input class="onb2-numin' + (n > 0 ? ' set' : '') + '" data-in="dogcount" type="number" min="0" max="4" inputmode="numeric" value="' + n + '" aria-label="number of dogs">' +
      '<span data-dogword>' + (n === 1 ? 'dog' : 'dogs') + '</span>' +
      '<span data-named style="display:' + (n >= 1 ? 'inline' : 'none') + ';">named</span>' +
      '</div>' +
      '<div class="onb2-names" data-name-rows>' + nameRowsHtml() + '</div>' +
      '<div class="onb2-me-bulk" data-bulk-chip>' + bulkChipHtml() + '</div>' +
      (n >= 4 ? '<div class="onb2-me-max">Up to 4 dogs per plan for now.</div>' : '') +
      '</div>';
  }

  /* ---------- owner (zip name.html) ---------- */

  function viewOwner() {
    var filled = trim(S.ownerFirst).length > 0;
    return '<div class="onb2-screen">' +
      '<p class="onb2-line">My first name is</p>' +
      '<input class="onb2-blank onb2-blank--big' + (filled ? ' filled' : '') + '" data-in="owner" value="' + esc(S.ownerFirst) + '" type="text" autocomplete="given-name" autocapitalize="words" placeholder="enter name" aria-label="your first name">' +
      '<div class="onb2-rest' + (filled ? ' show' : '') + '" data-rest>' +
      '<p class="onb2-line onb2-l2">and I ' +
      '<select class="onb2-sel' + (S.belief ? '' : ' onb2-sel--unset') + '" data-sel="belief" aria-label="how strongly you agree">' +
      '<option value="" disabled' + (S.belief ? '' : ' selected') + '>select</option>' +
      ['agree', 'strongly agree', 'am not yet sure'].map(function (o) {
        return '<option value="' + o + '"' + (S.belief === o ? ' selected' : '') + '>' + o + '</option>';
      }).join('') +
      '</select>' +
      ' that</p>' +
      '<p class="onb2-line onb2-l3">fresh food is the healthiest for ' + joinNamesBold() + '</p>' +
      '</div></div>';
  }

  /* ---------- contact (zip zip.html) ---------- */

  function viewContact() {
    var zf = S.zip.length > 0;
    return '<div class="onb2-screen">' +
      '<p class="onb2-line">My zip code is</p>' +
      '<input class="onb2-blank onb2-blank--big' + (zf ? ' filled' : '') + '" data-in="zip" value="' + esc(S.zip) + '" type="text" inputmode="numeric" maxlength="5" autocomplete="postal-code" placeholder="enter zip code" aria-label="your zip code">' +
      '<div data-zip-check>' + zipMsgHtml() + '</div>' +
      // the email field still reveals for an out-of-area ZIP — we want the address so we can
      // tell them when we expand; the gate is on advancing, not on capturing.
      '<div class="onb2-rest' + (zipOk() ? ' show' : '') + '" data-rest>' +
      '<p class="onb2-line onb2-l2">My email address is</p>' +
      '<input class="onb2-blank onb2-blank--big' + (emailOk(S.email) ? ' filled' : '') + '" data-in="email" value="' + esc(S.email) + '" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="enter email" aria-label="your email">' +
      '<div class="onb2-email-hint" data-email-hint>' + emailHintHtml() + '</div>' +
      '<p class="onb2-helper">You can use your email to access your recommendations anytime</p>' +
      '</div></div>';
  }

  /* ---------- dog profile (zip dog.html) ---------- */

  function dogIntroLine(d, di) {
    if (S.dogCount > 1) {
      return 'Time to tell us about ' + esc(dogName(d)) + ' — dog ' + (di + 1) + ' of ' + S.dogCount + ' (the best part!)';
    }
    return 'Time to tell us about ' + esc(dogName(d)) + ' (the best part!) This will only take about 2 minutes.';
  }

  function breedListHtml(d, q) {
    if (!q) return '';
    var list = BREEDS.filter(function (b) {
      return b.toLowerCase().indexOf(q) >= 0 && d.breeds.indexOf(b) < 0;
    }).slice(0, 8);
    return list.map(function (b) {
      return '<button type="button" data-act="breed-add" data-name="' + esc(b) + '">' + esc(b) + '</button>';
    }).join('');
  }

  function viewProfile(d, di) {
    // > 0, not merely non-empty: "0" used to advance and kcalFor's `parseFloat(age)||3`
    // then modelled the dog as a 3-year-old adult. Mirrors the weight field's gate.
    var hasAge = parseFloat(d.age) > 0;
    var one = String(d.age).trim() === '1';
    var showSearch = !d.breeds.length || S.breedAdding;
    var q = trim(S.breedQuery).toLowerCase();
    var listHtml = breedListHtml(d, q);
    return '<div class="onb2-screen onb2-screen--tight">' +
      '<img class="onb2-dogimg" src="' + (A.dogIllus || A.bowlHero) + '" alt="Your dog">' +
      '<div class="onb2-dogname">' + esc(dogName(d)) + '</div>' +
      '<p class="onb2-dogintro">' + dogIntroLine(d, di) + '</p>' +
      '<div class="onb2-form">' +

      '<div class="onb2-clause">' +
      selHtml('gender', d.sex, [['she', 'She'], ['he', 'He'], ['they', 'They']], '', 'your dog’s pronoun') +
      '<span>is</span>' +
      '<input class="onb2-numin onb2-numin--age' + (hasAge ? ' filled' : '') + '" data-in="age" value="' + esc(d.age) + '" type="text" inputmode="numeric" maxlength="2" placeholder="0" aria-label="age">' +
      selHtml('age-unit', d.ageUnit, [['years', one ? 'year' : 'years'], ['months', one ? 'month' : 'months']], '', 'is that age in years or months?') +
      '</div>' +

      '<div class="onb2-rest' + (hasAge ? ' show' : '') + '" data-rest>' +
      '<div class="onb2-clause" style="margin-top:34px;">' +
      '<span data-gender-word>' + pronSub(d) + '</span>' +
      selHtml('spay', d.fixed, [['is', 'is'], ['isn’t', 'isn’t'], ['not sure', 'not sure if']], '', 'is your dog spayed or neutered?') +
      '<span data-spay-word>' + spayWord(d) + '</span>' +
      '</div>' +
      '<div class="onb2-clause">' +
      '<span>and is the</span>' +
      selHtml('adj', d.adj, ['cutest', 'goofiest', 'sweetest', 'smartest', 'silliest', 'best'], '', 'how would you describe your dog?') +
      '</div>' +
      '<div class="onb2-clause onb2-breedclause">' +
      (d.breeds.length ? '<div class="onb2-bchips">' + d.breeds.map(function (b) {
        return '<button type="button" class="onb2-bchip" data-act="breed-remove" data-name="' + esc(b) + '"><span class="x">×</span><span>' + esc(b) + '</span></button>';
      }).join('') + '</div>' : '') +
      (showSearch
        ? '<div class="onb2-breedrow">' +
          '<span class="onb2-searchwrap" data-searchwrap>' +
          '<input class="onb2-breedin" data-in="breed-query" value="' + esc(S.breedQuery) + '" type="text" autocomplete="off" placeholder="type and select breed" aria-label="breed">' +
          '<div class="onb2-breedlist' + (listHtml ? ' open' : '') + '" data-breed-list>' + listHtml + '</div>' +
          '</span>' +
          '<span>ever.</span></div>'
        : '<div class="onb2-breedrow"><span>ever.</span></div>') +
      '</div>' +
      (d.breeds.length && !S.breedAdding ? '<button type="button" class="onb2-addbreed" data-act="add-breed">Add another breed</button>' : '') +
      (!d.breeds.length
        ? '<p class="onb2-helper">If ' + esc(dogName(d)) + ' is a mix, you can pick multiple breeds, or <span class="onb2-ulink" data-act="breed-unknown">unknown mix-breed</span>.</p>'
        : '') +
      '</div>' +

      '</div></div>';
  }

  /* ---------- weight + body (merged, with ideal-weight direction rule) ---------- */

  function idealBlockHtml(d) {
    var showIdeal = d.body === 0 || d.body === 2 || d.body === 3;
    if (!showIdeal) return '';
    var iw = trim(d.idealWeight);
    return '<div class="onb2-ideal">' +
      '<p class="onb2-line" style="font-size:clamp(1.3rem,5.4vw,1.6rem);">' + esc(dogPoss(d)) + ' ideal weight is ' +
      '<input class="onb2-numin onb2-numin--weight' + (iw ? ' filled' : '') + '" data-in="ideal" value="' + esc(d.idealWeight) + '" type="text" inputmode="decimal" maxlength="5" placeholder="00" aria-label="ideal weight"> lbs.</p>' +
      '<div data-ideal-check>' + idealMsgHtml(d) + '</div>' +
      '<div class="onb2-ideal-note">Your dog’s ideal weight is used to calculate their recommended daily calories.</div>' +
      '</div>';
  }

  function viewWeightBody(d, di) {
    var hasW = parseFloat(d.weight) > 0;
    return '<div class="onb2-screen onb2-screen--wb">' +
      '<p class="onb2-line">' + esc(dogName(d)) + ' weighs ' +
      '<input class="onb2-numin onb2-numin--weight' + (trim(d.weight) ? ' filled' : '') + '" data-in="weight" value="' + esc(d.weight) + '" type="text" inputmode="decimal" maxlength="5" placeholder="00" aria-label="weight"> lbs' +
      '</p>' +
      '<p class="onb2-helper" style="margin-top:6px;">A best guess is fine — we fine-tune as we go.</p>' +
      '<div data-weight-check>' + rangeMsgHtml(d) + '</div>' +
      '<div class="onb2-rest' + (hasW ? ' show' : '') + '" data-rest>' +
      '<p class="onb2-line onb2-l2" style="font-size:clamp(1.3rem,5.4vw,1.6rem);">and ' + pronSub(d).toLowerCase() + ' looks…</p>' +
      cardGrid(BODY_CARDS, 'body', d, true) +
      idealBlockHtml(d) +
      '</div></div>';
  }

  /* ---------- activity / eating / food / health ---------- */

  function viewActivity(d, di) {
    return '<div class="onb2-screen">' +
      '<p class="onb2-line">How active is ' + esc(dogName(d)) + '?</p>' +
      '<p class="onb2-helper" style="margin-top:10px;">Energy burned = calories earned.</p>' +
      cardGrid(ACTIVITY_CARDS, 'activity', d, false) +
      '</div>';
  }

  function viewEating(d, di) {
    return '<div class="onb2-screen">' +
      '<p class="onb2-line">At mealtimes, ' + esc(dogName(d)) + ' is…</p>' +
      '<p class="onb2-helper" style="margin-top:10px;">Picky pups love fresh food — we see it every day.</p>' +
      cardGrid(EATING_CARDS, 'eating', d, false) +
      '</div>';
  }

  function viewFood(d, di) {
    return '<div class="onb2-screen">' +
      '<p class="onb2-line" style="margin-bottom:26px;">What’s in the bowl today?</p>' +
      '<div class="onb2-clause">' +
      '<span>' + esc(dogName(d)) + ' mainly eats</span>' +
      selHtml('food-type', d.foodType, ['dry kibble', 'wet or canned food', 'fresh food', 'raw food', 'dehydrated food', 'homemade meals'], '', 'what does your dog mainly eat now?') +
      '</div>' +
      '<div class="onb2-clause">' +
      '<span>by</span>' +
      '<input class="onb2-blank' + (trim(d.brand) ? ' filled' : '') + '" data-in="brand" value="' + esc(d.brand) + '" placeholder="enter brand" style="min-width:180px;" aria-label="brand">' +
      '</div>' +
      '<div class="onb2-clause">' +
      '<span>and gets</span>' +
      selHtml('treats', d.treats, ['no', 'some', 'lots of'], '', 'how many treats or scraps does your dog get?') +
      '<span>treats or scraps.</span>' +
      '</div></div>';
  }

  function viewHealth(d, di) {
    var showIssues = d.hasIssues === 'has';
    var showRx = d.rx === 'does';
    return '<div class="onb2-screen">' +
      '<p class="onb2-line" style="margin-bottom:26px;">Last one — ' + esc(dogPoss(d)) + ' health</p>' +
      '<div class="onb2-clause">' +
      '<span>' + esc(dogName(d)) + '</span>' +
      selHtml('has-issues', d.hasIssues, ['doesn’t have', 'has'], '', 'does your dog have health issues?') +
      '<span>health issues,</span>' +
      '</div>' +
      '<div class="onb2-clause">' +
      '<span>and</span>' +
      selHtml('rx', d.rx, ['doesn’t', 'does'], '', 'does your dog require a prescription diet?') +
      '<span>require a prescription diet.</span>' +
      '</div>' +
      (showRx
        ? '<div class="onb2-rx"><p class="onb2-rx-note">Prescription diets require professional guidance. PETCHEFY can help connect you with a board-certified veterinary nutritionist to review ' + esc(dogPoss(d)) + ' needs. PETCHEFY does not diagnose, prescribe, or replace care from your veterinarian.</p>' +
          (d.referralSent ? '<div class="onb2-rx-sent">✓ Referral request sent to ' + esc(RX_TO) + ' — we’ll follow up at ' + esc(rxEmailVal()) + '.<br>We can’t build a prescription plan online, so this is where ' + esc(dogName(d)) + '’s plan stops for now.</div>' : '') +
          '<p class="onb2-rx-contact">Any more questions? Email <a href="mailto:' + esc(RX_TO) + '">' + esc(RX_TO) + '</a> or text us at <a href="' + PHONE_SMS + '">' + PHONE_DISPLAY + '</a>.</p>' +
          '</div>'
        : '') +
      (showIssues
        ? '<div class="onb2-issues"><div class="onb2-issues-label">Select all that apply</div><div class="onb2-chips">' +
          ISSUES.map(function (l) {
            var on = d.issues.indexOf(l) >= 0;
            return '<button type="button" class="onb2-issue-chip' + (on ? ' is-on' : '') + '" data-act="issue" data-name="' + esc(l) + '">' + esc(l) + '</button>';
          }).join('') +
          '</div></div>'
        : '') +
      '</div>';
  }

  function viewCalc() {
    return '<div class="onb2-calc">' +
      '<div class="onb2-cmp">' +
      '<div class="onb2-cmp-bowl onb2-cmp-kibble" role="img" aria-label="A bowl of dry kibble" style="background-image:url(\'' + (A.kibble || '') + '\')"></div>' +
      '<div class="onb2-cmp-mid">' +
      '<div class="onb2-cmp-state onb2-cmp-bad"><span class="onb2-cmp-arrow"><svg viewBox="0 0 48 32" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M45 7C31 5 15 9 7 21"/><path d="M7 21l9-1M7 21l2-9"/></svg></span><div class="onb2-cmp-mark">✕</div><div class="onb2-cmp-label">Kibble junk food</div></div>' +
      '<div class="onb2-cmp-state onb2-cmp-good"><span class="onb2-cmp-arrow"><svg viewBox="0 0 48 32" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M45 7C31 5 15 9 7 21"/><path d="M7 21l9-1M7 21l2-9"/></svg></span><div class="onb2-cmp-mark">♥</div><div class="onb2-cmp-label">Yummy healthy fresh</div></div>' +
      '</div>' +
      '<div class="onb2-cmp-bowl onb2-cmp-fresh" role="img" aria-label="A bowl of fresh PETCHEFY food" style="background-image:url(\'' + (A.cmpFresh || A.bowl || A.bowlHero) + '\')"></div>' +
      '</div>' +
      '<h2 class="onb2-calc-h" data-calc-msg>' + esc(calcMsgs()[S.calcMsg]) + '</h2>' +
      '<p class="onb2-calc-sub">✨ PETCHEFY AI is balancing 40+ essential nutrients</p>' +
      '<div class="onb2-calc-track"><div class="onb2-calc-fill" data-calc-fill style="width:' + Math.round(S.calcPct) + '%"></div></div>' +
      '</div>';
  }

  /* ---------- plan screen — offer.html layout + delivery-engine pricing ---------- */

  function planModel() {
    var names = S.dogs.map(function (x) { return trim(x.name) || 'your pup'; });
    var planFor = joinList(names, ' & ');
    var planForPron = names.length > 1 ? 'their' : pronPos(S.dogs[0]);
    var k = kcalFor(S.dogs[0]);
    // household total, summed the same way baseFull sums price. Sum the raw kcal and round
    // ONCE at display: rounding per dog first drifts by up to n/2 kcal.
    var kTotal = S.dogs.reduce(function (a, x) { return a + kcalFor(x).kcal; }, 0);
    var baseFull = S.dogs.reduce(function (a, x) { return a + pricePerDay(x); }, 0);
    return { names: names, planFor: planFor, planForPron: planForPron, k: k, kTotal: kTotal, baseFull: baseFull, wRound: Math.round(k.w) };
  }

  function viewPlan() {
    var m = planModel();
    var k = m.k;
    // Seed default recipes if the user never opened the picker. Without this, the
    // default-path checkout (buildTrialCartItems, empty recipeSel -> null) silently
    // fails and no order is placed. Turkey + Beef is the chosen default pair.
    // With bulk bags on, the default follows the format being sold: pre-portioned keeps the chosen
    // pair, bulk gets the cheapest mix its saving is quoted on (see defaultRecipesFor / bulkOfferPlan).
    if (!Array.isArray(S.recipeSel) || S.recipeSel.length === 0) { set({ recipeSel: defaultRecipesFor(bulkActive() ? 'bulk' : 'pre') }); }
    var selCount = S.recipeSel.length;

    // Serving-size factors (kcal line + bowl-fill visual): literal portion of a Full Bowl.
    var p2Factors = { full: 1, half: 0.5, topper: 0.25 };
    // PRICE factors are NOT serving-size: fixed per-shipment/packaging cost doesn't shrink with
    // the portion, so Half/Topper variants are priced at 65%/40% of Full (2026-07-09 repricing).
    // Only the not-yet-wired fallback estimate uses these — when wired, price comes from the variant.
    var p2PriceFactors = { full: 1, half: 0.65, topper: 0.4 };
    // Topper is only offered when EVERY dog's target weight — the weight the plan
    // feeds toward, same rule as kcalFor: current weight if body is "just right",
    // else ideal — is over 15 lbs. At ≤15 lbs a quarter portion is too small to
    // pack/price sensibly (2026-07-09 decision).
    var topperOk = S.dogs.every(function (d) {
      var w = parseFloat((d.body === 1) ? d.weight : (d.idealWeight || d.weight));
      return Number.isFinite(w) && w > 15;
    });
    if (!topperOk && S.p2Portion === 'topper') { set({ p2Portion: 'full' }); }
    // Half starts at 6 lbs — same target-weight rule as the Topper gate: below
    // 6 lbs a half portion is too small to pack/price sensibly, so Full only
    // (2026-07-20 decision).
    var halfOk = S.dogs.every(function (d) {
      var w = parseFloat((d.body === 1) ? d.weight : (d.idealWeight || d.weight));
      return Number.isFinite(w) && w >= 6;
    });
    if (!halfOk && S.p2Portion === 'half') { set({ p2Portion: 'full' }); }
    var p2Portion = p2Factors[S.p2Portion] ? S.p2Portion : 'full';
    // Per-day price at a portion — REAL variant price when wired (so displayed = charged), else kcal estimate.
    var p2DayAt = function (pk) { var v = variantDayPrice(pk); return v == null ? m.baseFull * (p2PriceFactors[pk] || 1) : v; };
    var p2PortionBase = p2DayAt(p2Portion);
    var trialUnits = COMMERCE.trialUnits || 6;
    var trialKeep = 1 - TRIAL_DISC_PCT / 100;
    var p2RecipeNames = selCount
      ? RECIPE_BOOK.filter(function (r) { return S.recipeSel.indexOf(r.key) >= 0; }).map(function (r) { return RECIPE_PROP_NAME[r.key]; }).join(' &bull; ')
      : Object.keys(RECIPE_PROP_NAME).map(function (kk) { return RECIPE_PROP_NAME[kk]; }).join(' &bull; ');

    /* --- 1. hero --- */
    var hero =
      '<section class="onb2-of-hero cream center">' +
      '<h1>The best plan for<span class="bigname"><span class="onb2-u">' + esc(m.planFor) + '</span></span></h1>' +
      '<p class="onb2-of-lead"><b>Freshly cooked recipes</b> and <b>right-sized portions</b>, made to keep your ' + esc(m.planFor) + ' healthy, happy, and by your side for years.</p>' +
      '<img class="onb2-of-heroimg" src="' + (A.ofHero || A.bags || A.bowlHero) + '" alt="PETCHEFY meal packs">' +
      '</section>';

    /* --- 2. recipes + trial price + CTA --- */
    var p2TrialOrig = fmt(p2PortionBase);
    // First box at TRIAL_DISC_PCT off — 0 today, so this is just the variant price. Both the
    // /day and box figures go through boxTotal so they share its truncated-per-unit math and
    // /day always equals (box total ÷ trial days), whatever the percentage is.
    var p2TrialDiscV = boxTotal(p2Portion, TRIAL_DISC_PCT, 1);
    var p2TrialDisc = fmt(p2TrialDiscV == null ? p2PortionBase * trialKeep : p2TrialDiscV);
    var p2TrialBoxV = boxTotal(p2Portion, TRIAL_DISC_PCT, trialUnits);
    var p2TrialBoxTotal = fmt(p2TrialBoxV == null ? p2PortionBase * trialUnits * trialKeep : p2TrialBoxV); // first-box charge (food, pre tax; shipping is comped by TRIAL_CODE)
    // A % offer renders "was $X · now $Y/day (N% OFF)". The current offer is free shipping, not
    // money off the food, so at 0% the strikethrough is suppressed — $4.20 struck through next
    // to $4.20 reads as a broken discount — and the free-shipping promise takes that slot.
    var priceLine =
      '<div class="onb2-of-price"><b>Trial Box:</b> ' +
      (TRIAL_DISC_PCT > 0
        ? '<span class="was">' + p2TrialOrig + '</span> <span class="now">' + p2TrialDisc + '/day (' + TRIAL_DISC_PCT + '% OFF)</span>'
        : '<span class="now">' + p2TrialDisc + '/day</span> <span class="ship">+ FREE shipping</span>') +
      '</div>';
    var bulkLine = (S.dogCount > 1 && !BULK_ON)
      ? '<p class="onb2-of-bulk"><button type="button" class="onb2-altlink" style="font-size:1.02rem;" data-act="bulk-open">🎁 Feeding ' + S.dogCount + ' dogs? Save up to 35% with bulk packs</button></p>'
      : '';
    // Trial-box price + subnote intentionally omitted here — they already live in the sticky footer.
    var priceBlock =
      '<section class="cream center onb2-of-priceblock">' +
      // margin pulled in by the 4px vertical padding added in CSS (tap-target fix) so the
      // hero's vertical rhythm — and the "clears the fold on iPhone 13" tuning — is unchanged
      '<button type="button" class="onb2-altlink" style="margin:-2px auto 8px;" data-act="' + (bulkActive() ? 'bulk-mix-open' : 'recipe-picker') + '">Adjust Recipe Selection Here</button>' +
      '<p class="onb2-of-recipes"><span class="onb2-of-reclabel">Current Recommendation:</span> ' + p2RecipeNames + '</p>' +
      (bulkActive() ? bulkTrialMixLine() : '') +
      bulkLine +
      '</section>';

    /* --- 3. engine: portion + delivery frequency (real pricing) --- */
    var p2Defs = [
      { key: 'full', title: 'Full portion', f: 1 }
    ];
    if (halfOk) p2Defs.push({ key: 'half', title: 'Half portion', f: 0.5 });
    if (topperOk) p2Defs.push({ key: 'topper', title: 'Topper', f: 0.25 });
    var pCards = p2Defs.map(function (c) {
      var sel = p2Portion === c.key;
      var size = sel ? 58 : 40;
      return '<button type="button" class="onb2-pcard' + (sel ? ' is-on' : '') + '" data-act="p2-portion" data-key="' + c.key + '">' +
        '<div class="onb2-pcard-img" style="width:' + size + 'px;height:' + size + 'px;background-image:url(\'' + (A.bowl || A.bowlHero) + '\');">' +
        '<div class="onb2-pcard-cover" style="height:' + Math.round((1 - c.f) * 100) + '%;"></div></div>' +
        '<div class="onb2-pcard-t" style="font-size:' + (sel ? '1rem' : '.78rem') + ';">' + c.title + '</div>' +
        '<div class="onb2-pcard-p" style="font-size:' + (sel ? '.88rem' : '.7rem') + ';">' + fmt(p2DayAt(c.key)) + '/day</div>' +
        '</button>';
    }).join('');
    var p2BadgeText = p2Portion === 'topper' ? 'A fresh boost on top' : (p2Portion === 'half' ? 'Half fresh, half current' : 'Best for your dog');
    var p2KcalLine = 'Total daily calories · ≈' + commas(Math.round(m.kTotal * p2Factors[p2Portion])) + ' kcal';
    // Dogs bigger than our largest band are still sold (biggest box) — but the plan page has
    // to repeat what the weight step said, or the price looks like a plan that fits.
    var overDogs = S.dogs.filter(function (x) { var r = rangeState(x); return r && r.side === 'above'; });
    var p2RangeNote = overDogs.length
      ? '<div class="onb2-callout" style="margin:10px 0 0;">' +
        joinList(overDogs.map(function (x) { return '<b>' + esc(dogName(x)) + '</b>'; }), ' and ') +
        (overDogs.length > 1 ? ' are' : ' is') + ' above the ' + variantRange().hi +
        ' lbs our largest plan covers, so they’ll get our biggest box.' +
        ' We’ll follow up after your first order to get the portions right.' +
        '</div>'
      : '';
    var p2BenefitMap = {
      full: ['One source for complete, balanced nutrition', 'Supports hydration, coat, and digestion', 'Designed to support healthy aging'],
      half: ['Half fresh food, half their current diet', 'An easy, budget-friendly way to upgrade the bowl', 'Adds real hydration and whole-food nutrients'],
      topper: ['A fresh, tasty boost mixed into current food', 'The most affordable way to start fresh', 'Great for picky eaters and first-timers']
    };
    var p2Benefits = p2BenefitMap[p2Portion].map(function (t) {
      return '<div class="b">' + SVG_CHK_S.replace('<svg ', '<svg style="width:16px;height:16px;color:var(--coral);flex:none;margin-top:2px;" ') + '<span>' + t + '</span></div>';
    }).join('');

    /* delivery-frequency picker parked 2026-07-02 (archive/delivery-pricing/) —
     * checkout uses the default cadence (S.cadence = 28). */
    var engine =
      '<section class="cream" style="padding-top:10px;">' +
      '<h3 class="onb2-eng-h">Choose your amount</h3>' +
      '<div class="onb2-eng-card">' +
      '<div class="onb2-eng-badge onb2-eng-badge--coral">' + p2BadgeText + '</div>' +
      '<div class="onb2-eng-row">' + pCards + '</div>' +
      '<div class="onb2-kcal-line">' + p2KcalLine + '</div>' +
      p2RangeNote +
      '<div class="onb2-eng-benefits">' + p2Benefits + '</div>' +
      '</div>' +
      '</section>';

    /* --- 4. fresh approach --- */
    var freshApproach =
      '<section class="center">' +
      '<h2>A <span class="onb2-u">fresh</span> approach to feeding ' + esc(m.planFor) + '</h2>' +
      '<ul class="onb2-of-benefits">' +
      '<li>' + SVG_CHK + '<span>Gently cooked for <b>easy digestion, a shinier coat, and more energy</b>.</span></li>' +
      '<li>' + SVG_CHK + '<span><b>Complete and balanced</b> adult-maintenance nutrition, built to AAFCO standards.</span></li>' +
      '<li>' + SVG_CHK + '<span>Made in kitchens that meet <b>human food-safety</b> standards.</span></li>' +
      '</ul>' +
      (A.freshVideo
        ? '<video class="onb2-fresh-video" autoplay muted loop playsinline preload="metadata"' +
          (A.freshPoster ? ' poster="' + A.freshPoster + '"' : '') + ' aria-label="Dogs enjoying fresh PETCHEFY meals">' +
          '<source src="' + A.freshVideo + '" type="video/mp4"></video>'
        : '<div class="onb2-collage">' +
          '<img class="tall" src="' + (A.ofLife1 || A.eat) + '" alt="Dog being fed PETCHEFY" loading="lazy" decoding="async">' +
          '<img src="' + (A.eat || A.bowlHero) + '" alt="Dog eating PETCHEFY" loading="lazy" decoding="async">' +
          '<img src="' + (A.ofLife2 || A.eat) + '" alt="Dog enjoying PETCHEFY" loading="lazy" decoding="async">' +
          '</div>') +
      '</section>';

    /* --- 5. a plan you'll both love --- */
    var loveIcons = [
      '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9h18"/><path d="M9 14l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M2 12h20M5 5l14 14M19 5L5 19"/></svg>',
      '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 14v-2a8 8 0 0116 0v2"/><rect x="3" y="14" width="4" height="6" rx="1"/><rect x="17" y="14" width="4" height="6" rx="1"/></svg>',
      '<svg class="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 11-3-6.7M21 3v5h-5"/></svg>'
    ];
    var loveTexts = ['Orders delivered on your schedule', 'Arrives frozen, fresh, and easy to store', 'Support whenever you need it', 'Adjust your plan right in your account'];
    var love =
      '<img class="onb2-bleed" src="' + (A.ofBox || A.bags) + '" alt="PETCHEFY delivery box" loading="lazy" decoding="async">' +
      '<section class="cream center">' +
      '<h2>A plan you’ll both love</h2>' +
      '<p class="onb2-of-lead">Get a trial box so ' + esc(m.planFor) + ' can try PETCHEFY. You can change or pause anytime.</p>' +
      '<div class="onb2-reassure">' +
      loveTexts.map(function (t, i) { return '<div class="it">' + loveIcons[i] + '<p>' + t + '</p></div>'; }).join('') +
      '</div></section>';

    /* --- 6. vet-approved recipes + bowl callouts --- */
    var recN = selCount || 3;
    var bowlSec =
      '<section class="center">' +
      '<h2>' + esc(m.planFor) + '’s box includes<br><span class="onb2-u">' + recN + ' vet-approved</span> recipes</h2>' +
      '<p class="onb2-of-lead">Developed with veterinary nutritionists and gently cooked from whole ingredients, with all the vitamins and minerals your dog needs.</p>' +
      '<div class="onb2-bowlwrap">' +
      '<span class="onb2-callout-hand l">Real &amp; human-grade <span class="onb2-heart">&hearts;</span><span class="arw"><svg viewBox="0 0 96 84" fill="none" stroke="currentColor" stroke-width="6.5" stroke-linecap="round" stroke-linejoin="round"><path d="M42 8C14 26 14 58 46 64L82 60"/><path d="M82 60L66 52M82 60L70 74"/></svg></span></span>' +
      '<img src="' + (A.bowlPhoto || A.bowl || A.bowlHero) + '" alt="A bowl of PETCHEFY fresh food" loading="lazy" decoding="async">' +
      '<span class="onb2-callout-hand r">Fresh, whole<br>vegetables<span class="arw"><svg viewBox="0 0 96 84" fill="none" stroke="currentColor" stroke-width="6.5" stroke-linecap="round" stroke-linejoin="round"><path d="M42 8C14 26 14 58 46 64L82 60"/><path d="M82 60L66 52M82 60L70 74"/></svg></span></span>' +
      '</div>' +
      '<button type="button" class="onb2-nutri" data-act="p2-nutrition">Nutrition Facts</button>' +
      '</section>';

    /* --- 7. portions --- */
    var portions =
      '<img class="onb2-bleed" style="height:300px;" src="' + (A.ofHand || A.bags) + '" alt="PETCHEFY pack" loading="lazy" decoding="async">' +
      '<section class="cream center">' +
      '<h2>' + esc(m.planFor) + '’s portions, packed just right</h2>' +
      '<p class="onb2-of-lead">' + esc(m.planFor) + '’s packs arrive pre-portioned to size and needs, so it’s easy to keep them <b>lean and feeling their best.</b></p>' +
      '<button type="button" class="onb2-ghostbtn" data-act="portion-details">' + esc(m.planFor) + '’s portion details</button>' +
      '</section>';

    /* --- 8. reviews --- */
    var reviews = [
      ['“My Benji was the pickiest eater. I tried every high-end food under the sun, often needing to hand feed him to eat. We switched to PETCHEFY and I’ve not had to supervise his eating since. He licks his bowl clean every meal, and has never looked healthier or been happier about his food. The subscription and delivery process is seamless — thank you for changing our lives!”', '— Benji’s mom, Miami FL', (A.polaroid || A.ofTesti1)],
      ['“Switched from a pricey bag and the difference in his coat and energy is unreal. Easy to store and even easier to serve.”', '— Cooper’s dad', A.ofTesti2],
      ['“My picky eater finally finishes every meal. I wish we’d started PETCHEFY years ago.”', '— Daisy’s human', A.eat]
    ];
    var reviewsSec =
      '<section class="center">' +
      '<h2>' + esc(m.planFor) + '’s in good company</h2>' +
      '<div class="onb2-stars">&starf;&starf;&starf;&starf;&starf;</div>' +
      '<p class="onb2-revsub">Thousands of fresh, healthy meals served across South Florida. Meet a few of our happy pups.</p>' +
      // tabindex makes the scroller reachable by keyboard per spec. Chromium/Firefox make
      // scrollable divs focusable natively; Safari does not, so without this its users
      // cannot scroll the reviews at all.
      '<div class="onb2-carou" tabindex="0" role="group" aria-label="Customer reviews">' +
      reviews.map(function (r) {
        return '<div class="onb2-revcard">' +
          (r[2] ? '<img src="' + r[2] + '" alt="Happy dog" loading="lazy" decoding="async">' : '') +
          '<p class="q">' + r[0] + '</p>' +
          '<p class="who">' + r[1] + '</p></div>';
      }).join('') +
      '</div>' +
      '<div class="onb2-dots"><span class="on"></span><span></span><span></span></div>' +
      '</section>';

    /* --- 9. peace of mind --- */
    var vetSvg = '<svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3v6a4 4 0 008 0V3"/><path d="M6 3H4M12 3h2M14 13a4 4 0 01-8 0"/><circle cx="18" cy="16" r="3"/><path d="M18 13v-1"/></svg>';
    var peace =
      '<section class="dark center">' +
      '<h2>Also included:<br>peace of mind</h2>' +
      '<p class="onb2-of-lead">PETCHEFY is made to exceed pet-food industry standards for safety, quality, and nutrition.</p>' +
      '<div class="onb2-badges">' +
      '<div class="onb2-badge"><div class="bi">USDA</div><p>All proteins are USDA inspected</p></div>' +
      '<div class="onb2-badge"><div class="bi">AAFCO</div><p>Exceeds standards for dog food nutrition</p></div>' +
      '<div class="onb2-badge"><div class="bi">' + vetSvg + '</div><p>Formulated by board certified vet nutritionists</p></div>' +
      '<div class="onb2-badge"><div class="bi">WSAVA</div><p>Meets or exceeds WSAVA’s pet food guidelines</p></div>' +
      '</div></section>';

    /* --- 10. faq --- */
    // Short answers only; f[2] = slug on the full FAQ page for the "Read more →" deep link.
    var faqs = [
      ['Can I skip, pause, or cancel anytime?', 'Yes — skip, pause, or cancel anytime in your account. No lock-in, no cancellation fees.', 'skip-pause-cancel'],
      ['What if ' + m.planFor + ' doesn’t like the food?', 'It’s rare, but if your dog isn’t a fan we’ll help you switch recipes or make it right — your trial box is risk-free.', 'can-i-try-it-first'],
      ['Why should I feed fresh?', 'Fresh, gently cooked food keeps more of its natural nutrients than highly processed kibble — easier digestion, more energy, and a healthier coat.'],
      ['Do I need to cook the food?', 'Nope — PETCHEFY is fully cooked and ready to serve. Just thaw, open, and pour into the bowl.', 'raw-or-cooked'],
      ['How do I store the food?', 'Your packs arrive frozen: keep them in the freezer and move a few to the fridge as you go. Thawed food stays fresh in the fridge for several days.', 'storage-freezer-fridge'],
      ['How do you determine portions?', 'We use the details you shared — age, weight, breed, and activity — to portion each pack to your dog’s ideal daily calories.', 'how-much-per-day'],
      ['What if I’m traveling?', 'Your plan flexes around your life — pause, skip, or reschedule deliveries anytime in your account.', 'travel-skip'],
      ['How do I transition ' + m.planFor + ' to fresh food?', 'We include a simple day-by-day guide — most dogs switch over about a week by mixing in a little more PETCHEFY each day.', 'transition']
    ];
    var faqSec =
      '<section>' +
      '<h2 class="center" style="margin-bottom:8px;">Still have questions?</h2>' +
      '<div class="onb2-faq">' +
      faqs.map(function (f) {
        var more = f[2] ? ' <a class="more" href="' + FAQ_URL + '#' + f[2] + '" target="_blank" rel="noopener">Read more →</a>' : '';
        return '<details><summary><span class="q">' + esc(f[0]) + '</span><span class="pm"></span></summary><div class="ans">' + esc(f[1]) + more + '</div></details>';
      }).join('') +
      '</div>' +
      '<p class="onb2-faq-all">Have another question? <a href="' + FAQ_URL + '" target="_blank" rel="noopener">See all FAQs →</a></p>' +
      '</section>';

    /* --- sticky checkout ---
     * The site footer that used to sit here (brand mark, nav word-list, Terms/Privacy,
     * copyright, "Start over") was removed 2026-07-22 by request. Nothing functional went
     * with it except the restart control: every "link" in it was a plain <span> with no
     * href, so none of them navigated anywhere. See case 'restart' if it needs to come back. */

    var bkFoot = BULK_ON ? bulkFootbar() : null;
    var sticky =
      '<div class="onb2-of-footbar"><div class="onb2-of-footinner">' +
      (bkFoot ? bkFoot.priceLine : priceLine) +
      '<div class="onb2-of-footnote">' + (bkFoot ? bkFoot.note : 'Trial box (' + trialUnits + ' days) ≈' + p2TrialBoxTotal + ' · pre tax · shipping free on your first order') + '</div>' +
      '<button type="button" class="onb2-of-cta' + (S.started ? ' is-started' : '') + '" data-act="p2-checkout">' + (S.started ? '✓ Order started' : 'Checkout') + '</button>' +
      '</div></div>';

    return '<div class="onb2-of">' +
      hero + priceBlock + engine + (BULK_ON ? bulkBlockHtml(m) : '') + freshApproach + love + bowlSec + portions + reviewsSec + peace + faqSec +
      '<div class="onb2-of-spacer"></div>' + sticky +
      '</div>';
  }

  /* ---------- bottom-sheet scaffold + shared recipe nutrition blocks ----------
   * One scaffold for all 5 sheets (picker / info / why / footer / nutrition) and one
   * per-recipe <details> builder shared by the info + nutrition modals — edit once. */

  function sheetHtml(o) {
    // Real dialog semantics. Without role/aria-modal the recipe picker was invisible to AT:
    // focus never entered it, Tab walked the page BEHIND the overlay, and Escape did nothing —
    // on the only control that changes which recipes ship. Only one sheet is open at a time
    // (modalsHtml short-circuits), so a single fixed id is safe.
    return '<div class="onb2-sheet-overlay" ' + o.overlayAttr + '>' +
      '<div class="onb2-sheet" role="dialog" aria-modal="true" aria-labelledby="onb2-sheet-title" tabindex="-1" data-onb2-dialog>' +
      '<div class="onb2-sheet-head">' +
      '<div><div class="onb2-sheet-kicker" id="onb2-sheet-title">' + o.kicker + '</div>' +
      '<div class="onb2-sheet-count">' + o.count + '</div></div>' +
      '<button type="button" class="onb2-sheet-x" data-act="' + o.closeAct + '"' + (o.closeDisabled ? ' disabled' : '') + ' aria-label="Close">✕</button></div>' +
      '<div class="onb2-sheet-body">' + o.bodyHtml + '</div>' +
      '<div class="onb2-sheet-foot">' + o.footHtml + '</div>' +
      '</div></div>';
  }

  function gaRowsHtml(r) {
    var rows = r.ga.map(function (g) {
      return '<div class="onb2-ga-row"><span class="n">' + esc(g[0]) + ' <span>(' + esc(g[1]) + ')</span></span><span class="v">' + esc(g[2]) + '</span></div>';
    }).join('');
    if (r.kcalKg) rows += '<div class="onb2-ga-row"><span class="n">Calories (ME)</span><span class="v">' + r.kcalKg + '</span></div>';
    return rows;
  }

  function labNoteHtml(r) {
    return '<div class="onb2-lab-note">' + (r.lab ? 'As-fed values · ' + r.lab + '.' : 'As-fed estimates · lab verification in progress.') + '</div>';
  }

  function recipeDetailsHtml(r, extraAttr) {
    return '<details' + (extraAttr || '') + '>' +
      '<summary><span class="onb2-info-thumb" style="background-image:url(\'' + r.img + '\');"></span>' +
      '<span class="q">' + esc(r.full) +
      '<span class="onb2-info-badge' + (r.lab ? '' : ' pending') + '">' + (r.lab ? '🔬 Eurofins lab-verified' : 'Lab results coming') + '</span></span>' +
      '<span class="pm"></span></summary>' +
      '<div class="ans">' +
      '<p style="margin:0 0 10px;">' + esc(r.desc) + '</p>' +
      '<div class="onb2-modal-label">Ingredients</div>' +
      '<p style="margin:0 0 12px;color:var(--ink);">' + esc(r.ing) + '</p>' +
      '<div class="onb2-modal-label">Guaranteed analysis</div>' +
      '<div class="onb2-ga-table">' + gaRowsHtml(r) + '</div>' +
      labNoteHtml(r) +
      '</div></details>';
  }

  function recipeAccordionHtml(openKey) {
    return '<div class="onb2-faq onb2-info-faq">' +
      RECIPE_BOOK.map(function (r) {
        return recipeDetailsHtml(r, openKey === r.key ? ' open data-info-jump' : '');
      }).join('') + '</div>';
  }

  /* ---------- recipe picker sheet + nutrition modal ---------- */

  function viewRecipePicker() {
    if (!S.recipePicker) return '';
    var selCount = S.recipeSel.length;
    var cards = RECIPE_BOOK.map(function (r) {
      var sel = S.recipeSel.indexOf(r.key) >= 0;
      var lockedOut = selCount >= 3 && !sel;
      return '<div class="onb2-rcard' + (sel ? ' is-on' : '') + (lockedOut ? ' is-locked' : '') + '">' +
        '<div role="img" aria-label="' + esc(r.name) + '" class="onb2-rcard-img" style="background-image:url(\'' + r.img + '\');"></div>' +
        '<div class="onb2-rcard-name">' + esc(r.name) + '</div>' +
        '<div class="onb2-rcard-desc">' + esc(r.desc) + '</div>' +
        '<button type="button" class="onb2-rcard-link" data-act="recipe-facts" data-key="' + r.key + '"' + (lockedOut ? ' disabled' : '') + '>Full Ingredient List</button>' +
        '<button type="button" class="onb2-rcard-add' + (sel ? ' is-on' : '') + '" data-act="recipe-toggle" data-key="' + r.key + '"' + (lockedOut ? ' disabled' : '') + '>' +
        '<span class="onb2-rcard-check' + (sel ? ' on' : '') + '">' + (sel ? '✓' : '') + '</span>' +
        '<span style="font-size:.88rem;font-weight:700;color:' + (sel ? 'var(--coral)' : 'var(--ink)') + ';">' + (sel ? 'Added' : 'Add') + '</span></button>' +
        '</div>';
    }).join('');
    return sheetHtml({
      overlayAttr: 'data-act-pickeroverlay',
      kicker: 'Recipes',
      count: selCount + ' of 3 selected',
      closeAct: 'recipe-picker-close',
      closeDisabled: selCount === 0,
      bodyHtml:
        '<p style="font-size:.85rem;color:var(--muted);margin:0 0 14px;line-height:1.5;">Choose up to 3. Rotate them across deliveries.</p>' +
        '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' + cards + '</div>' +
        (selCount === 0 ? '<div style="text-align:center;font-style:italic;font-size:.85rem;color:var(--muted);margin-top:12px;">Select at least one recipe to continue</div>' : ''),
      footHtml: '<button type="button" class="onb2-sheet-cta" data-act="recipe-picker-close"' + (selCount === 0 ? ' disabled' : '') + '>' + (selCount > 0 ? 'Update my recipes (' + selCount + ')' : 'Select at least one recipe') + '</button>'
    });
  }

  function viewRecipeModal() {
    if (!S.recipeModal) return '';
    var rm = RECIPE_BOOK.filter(function (r) { return r.key === S.recipeModal; })[0];
    if (!rm) return '';
    return '<div class="onb2-overlay" data-act-overlay>' +
      '<div class="onb2-modal" style="position:relative;">' +
      '<button type="button" class="onb2-bulk-x" data-act="recipe-close" aria-label="Close">✕</button>' +
      '<div style="display:flex;align-items:center;gap:14px;">' +
      '<div style="width:56px;height:56px;background:url(\'' + rm.img + '\') center / contain no-repeat;flex-shrink:0;"></div>' +
      '<h3 style="margin:0;">' + esc(rm.name) + '</h3></div>' +
      '<p class="onb2-modal-sub" style="margin-top:14px;">' + esc(rm.desc) + '</p>' +
      '<div class="onb2-modal-label">Ingredients</div>' +
      '<p style="font-size:.88rem;color:var(--ink);line-height:1.6;margin:0 0 16px;">' + esc(rm.ing) + '</p>' +
      '<div class="onb2-modal-label">Guaranteed analysis</div>' +
      '<div class="onb2-ga-table">' + gaRowsHtml(rm) + '</div>' +
      labNoteHtml(rm) +
      '</div></div>';
  }

  /* ---------- "Learn more" info modal (our food / our team) ---------- */

  function viewInfoModal() {
    if (!S.infoModal) return '';
    var team =
      '<div class="onb2-info-team">' +
      '<div class="onb2-info-team-h">The full combo behind every recipe</div>' +
      TEAM_ROWS.map(function (r) {
        return '<div class="onb2-info-team-row"><span class="ck">' + SVG_CHK_S + '</span><span>' + r + '</span></div>';
      }).join('') +
      '<div class="onb2-info-team-note">That’s the team you want formulating your dog’s food — and it’s exactly the one we have.</div>' +
      '</div>';

    var points = [
      ['🥩', '<b>Human-grade ingredients</b> from the same distributors that supply restaurants and grocery stores. We’ve eaten it ourselves.'],
      ['👨‍🍳', '<b>Made fresh every week</b> in our Miami kitchen — never sitting in a warehouse.'],
      ['🧪', '<b>Formulated by experts</b> to AAFCO adult-maintenance standards, with ingredients studied for supporting healthy adult dogs.'],
      ['📱', '<b>Control everything from your phone</b> — pause, skip, or swap recipes anytime.'],
      ['🚚', '<b>Delivered right to your door</b> — or pick up for free.'],
      ['💬', '<b>AI Nutrition Assistant</b> with a direct line to our vet team.'],
      ['🌴', '<b>Local jobs</b> — cooked and delivered by our own Miami team.'],
      ['🐾', '<b>Independently owned</b> — no private equity, no VC, no rich parents. Just dog people.']
    ];
    var pointsHtml =
      '<div class="onb2-info-points">' +
      points.map(function (p) {
        return '<div class="onb2-info-point"><span class="em">' + p[0] + '</span><span>' + p[1] + '</span></div>';
      }).join('') +
      '</div>';

    var recipes =
      '<div class="onb2-info-recipes-h">Ingredients &amp; nutrition</div>' +
      recipeAccordionHtml(S.infoRecipe);

    return sheetHtml({
      overlayAttr: 'data-act-infooverlay',
      kicker: 'Our food',
      count: 'Fresh, human-grade, expert-built',
      closeAct: 'info-close',
      bodyHtml: team + pointsHtml + recipes,
      footHtml: '<button type="button" class="onb2-sheet-cta" data-act="info-begin">Build my dog’s plan</button>'
    });
  }

  // "Why fresh food" modal — triggered from the dark landing section. Every stat is real
  // and sourced (obesity/cancer/lifespan/processing); tone is funny-outrageous-but-true.
  function viewWhyModal() {
    if (!S.whyModal) return '';
    var STATS = [
      ['59%', 'of U.S. dogs are overweight or obese. That’s more than half the dog park — and no, yours probably isn’t the exception. (We’re sorry.)', 'Assoc. for Pet Obesity Prevention, 2022'],
      ['+2 yrs', 'longer that lean dogs lived than their chubbier littermates in a 14-year study — a median 13 years vs. 11.2. Two bonus years of zoomies, just from not overfeeding.', 'Purina Life Span Study · JAVMA'],
      ['1 in 2', 'dogs over age 10 will develop cancer (about 1 in 4 across all ages). Not “someday, somewhere” — over half of senior dogs.', 'Veterinary Cancer Society / AAHA'],
      ['2×', 'Cancer causes roughly half of senior-dog deaths — more than double the ~20% human rate. Our dogs are catching our diseases. Maybe because they eat a version of our worst diet.', 'AAHA (dogs) · CDC (humans)'],
      ['30–60%', 'of a typical bag of kibble is carbohydrate, extruded at up to 200°C until the nutrients tap out (up to 80% of the lysine — gone). Shelf-stable is great for a Twinkie. Less great for a heartbeat.', 'Pet-food extrusion research']
    ];
    var cards = STATS.map(function (s) {
      return '<div class="onb2-why-card"><div class="onb2-why-n">' + s[0] + '</div>' +
        '<div class="onb2-why-body"><div class="cap">' + s[1] + '</div><div class="src">' + s[2] + '</div></div></div>';
    }).join('');
    var FIXES = [
      ['🍖', '<b>Actual food.</b> Human-grade meat and vegetables you’d recognize, gently cooked — not milled into shelf-stable gravel.'],
      ['⚖️', '<b>Portioned to the calorie.</b> Obesity is the most preventable thing on this list, and honestly it’s just math. We do the math for you.'],
      ['🤖', '<b>AI that watches the waistline.</b> Your dog’s plan adjusts as they age, slow down, or (be honest) charm one too many treats out of grandma.'],
      ['📱', '<b>Managed from your phone.</b> Skip, pause, swap recipes, re-portion — the whole plan lives in your pocket.']
    ];
    var fixes = FIXES.map(function (f) {
      return '<div class="onb2-why-fix"><span class="em">' + f[0] + '</span><span>' + f[1] + '</span></div>';
    }).join('');
    return sheetHtml({
      overlayAttr: 'data-act-whyoverlay',
      kicker: 'Why fresh',
      count: 'The unfun facts — and the fix',
      closeAct: 'why-close',
      bodyHtml:
        '<p class="onb2-why-intro">We love our dogs like family. Then we feed them the same bag of ultra-processed pellets for 12 years straight and act shocked when things go sideways. Here’s what the research actually says — and why <b>real food isn’t a luxury, it’s just… food.</b></p>' +
        '<div class="onb2-why-cards">' + cards + '</div>' +
        '<div class="onb2-why-fix-h">So here’s the (not complicated) fix</div>' +
        '<div class="onb2-why-fixes">' + fixes + '</div>' +
        '<p class="onb2-why-close">Fresh food won’t make your dog immortal. But “lives longer, gets sick less, and actually likes dinner” is a pretty great deal for something you were going to buy anyway.</p>',
      footHtml: '<button type="button" class="onb2-sheet-cta" data-act="why-begin">Build my dog’s plan</button>'
    });
  }

  function bulkChipHtml() {
    if (BULK_ON) return S.dogCount > 1 ? '<span class="onb2-me-bulknote2">🎁 Feeding ' + S.dogCount + ' dogs? Bulk bags can cost less per day — we’ll price it for your pack at the end.</span>' : '';
    if (S.dogCount <= 1) return '';
    if (S.bulkLeadSent) return '<span class="onb2-me-bulknote">✓ Bulk plan requested — we’ll be in touch</span>';
    return '<button type="button" class="onb2-me-bulkbtn" data-act="bulk-open">🎁 Save up to 35% by switching to bulk packs on multiple dogs</button>';
  }

  function viewBulkModal() {
    if (!S.bulkModal) return '';
    return '<div class="onb2-overlay" data-act-bulkoverlay>' +
      '<div class="onb2-modal onb2-bulk">' +
      '<button type="button" class="onb2-bulk-x" data-act="bulk-close" aria-label="Close">✕</button>' +
      '<div class="onb2-bulk-kicker">Feeding ' + S.dogCount + ' dogs?</div>' +
      '<h3>Bulk packs for the whole pack</h3>' +
      '<div class="onb2-bulk-card is-info">' +
      '<span class="onb2-bulk-body">' +
      '<span class="onb2-bulk-top">Combine into large packs <span class="onb2-bulk-pill">Save up to 35%</span></span>' +
      '<span class="onb2-bulk-desc">Combine everyone’s food into large packs instead of bags pre-portioned per dog. A little more scooping, a lot more savings — custom-built for your pack at wholesale pricing.</span>' +
      '<span class="onb2-bulk-scale"><span class="em">⚖️</span><span><b>Includes a food scale</b> + per-dog feeding instructions, so every bowl is portioned perfectly.</span></span>' +
      '</span></div>' +
      '<p class="onb2-bulk-foot">A real member of our team designs your multi-dog plan personally.</p>' +
      '<div class="onb2-bulk-actions">' +
      '<button type="button" class="onb2-bulk-primary" data-act="bulk-continue">Continue</button>' +
      '<button type="button" class="onb2-bulk-skip" data-act="bulk-skip">No thanks, keep per-dog bags</button>' +
      '</div>' +
      '</div></div>';
  }

  function bulkNamesPhrase() {
    var names = S.dogs.slice(0, Math.max(1, S.dogCount)).map(function (d) { return trim(d.name); }).filter(Boolean);
    if (names.length < S.dogCount || !names.length) return 'names to follow';
    return joinList(names, ' & ');
  }

  function bulkLeadReady() {
    if (!emailOk(S.email)) return false;
    for (var i = 0; i < S.dogCount; i++) { if (!(parseFloat((S.dogs[i] || {}).idealWeight) > 0)) return false; }
    return true;
  }

  function bulkLeadMsg() {
    var n = S.dogCount;
    return 'Hi PETCHEFY team, I have ' + n + ' dog' + (n > 1 ? 's' : '') + ' (' + bulkNamesPhrase() + ') and I’d like a custom bulk-pack plan that combines their food into large packs. Please reach out to set it up.';
  }

  function viewBulkLeadModal() {
    if (!S.bulkLeadModal) return '';
    var n = S.dogCount;
    if (S.bulkLeadSent) {
      return '<div class="onb2-overlay" data-act-bulkleadoverlay>' +
        '<div class="onb2-modal onb2-bulklead onb2-bulklead--done">' +
        '<div class="onb2-bulklead-tick">✓</div>' +
        '<h3>You’re on our list!</h3>' +
        '<p class="onb2-bulklead-sub">A real member of our team will reach out from <b>' + esc(RX_TO) + '</b> — usually within one business day — to build ' + esc(bulkNamesPhrase() === 'names to follow' ? 'your pack' : bulkNamesPhrase()) + '’s custom bulk-pack plan.</p>' +
        '<button type="button" class="onb2-bulk-primary" data-act="bulk-lead-close">Got it</button>' +
        '</div></div>';
    }
    var weightRows = '';
    for (var i = 0; i < n; i++) {
      var d = S.dogs[i] || {};
      weightRows += '<div class="onb2-bulklead-wrow">' +
        '<button type="button" class="onb2-bulklead-remove" data-act="bulk-remove-dog" data-idx="' + i + '" aria-label="Remove dog">×</button>' +
        '<input class="onb2-bulklead-namein" data-in="bulk-name" data-idx="' + i + '" value="' + esc(d.name || '') + '" placeholder="Dog ' + (i + 1) + '’s name" autocapitalize="words" autocomplete="off" aria-label="dog name">' +
        '<span class="onb2-bulklead-winput"><input data-in="bulk-ideal" data-idx="' + i + '" value="' + esc(d.idealWeight || '') + '" type="text" inputmode="decimal" maxlength="5" placeholder="00" aria-label="ideal weight"><span class="lbs">lbs</span></span>' +
        '</div>';
    }
    var addDog = n < 4 ? '<button type="button" class="onb2-bulklead-adddog" data-act="bulk-add-dog">+ Add another dog</button>' : '';
    return '<div class="onb2-overlay" data-act-bulkleadoverlay>' +
      '<div class="onb2-modal onb2-bulklead">' +
      '<button type="button" class="onb2-bulk-x" data-act="bulk-lead-close" aria-label="Close">✕</button>' +
      '<div class="onb2-bulk-kicker">Bulk packs · ' + n + ' dog' + (n > 1 ? 's' : '') + '</div>' +
      '<h3>Let’s build your multi-dog plan together</h3>' +
      '<p class="onb2-bulklead-intro">Bulk packs are custom-portioned for each dog, so a real member of our team will craft your plan personally. Drop your details and we’ll reach out from <b>' + esc(RX_TO) + '</b>.</p>' +
      '<div class="onb2-bulklead-label">Your email</div>' +
      '<input class="onb2-bulklead-input" data-in="email" value="' + esc(S.email) + '" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="you@email.com" aria-label="your email">' +
      '<div class="onb2-bulklead-label">Your dogs &amp; their ideal weight <span class="opt">so we can size the food we design for them</span></div>' +
      '<div class="onb2-bulklead-weights">' + weightRows + '</div>' +
      addDog +
      '<div class="onb2-bulklead-label">Phone <span class="opt">Optional — helps us reach you faster.</span></div>' +
      '<input class="onb2-bulklead-input" data-in="bulk-phone" value="' + esc(S.bulkPhone) + '" type="tel" inputmode="tel" autocomplete="tel" placeholder="(305) 555-0123" aria-label="phone">' +
      '<div class="onb2-bulklead-preview" data-bulk-preview>' + esc(bulkLeadMsg()) + '</div>' +
      '<div class="onb2-bulklead-actions">' +
      '<button type="button" class="onb2-bulk-skip" data-act="bulk-lead-skip">Skip for now</button>' +
      '<button type="button" class="onb2-bulklead-send" data-act="bulk-lead-send"' + (bulkLeadReady() ? '' : ' disabled') + '>Send to our team</button>' +
      '</div>' +
      '</div></div>';
  }

  // Footer modals (landing) — Fresh Digest (curated reads), Affiliates (partner contact),
  // For Vet Professionals (nutrition/standards + contact). One state: S.footerModal.
  function viewFooterModal() {
    if (!S.footerModal) return '';
    var ig = 'https://instagram.com/petchefy';
    var contact =
      '<div class="onb2-contact-cards">' +
      '<a class="onb2-contact-card" href="mailto:' + esc(RX_TO) + '"><span class="ic">📧</span><span class="tx"><span class="l">Email us</span><span class="v">' + esc(RX_TO) + '</span></span></a>' +
      '<a class="onb2-contact-card" href="' + ig + '" target="_blank" rel="noopener"><span class="ic">📸</span><span class="tx"><span class="l">DM us on Instagram</span><span class="v">@petchefy</span></span></a>' +
      '<a class="onb2-contact-card" href="' + PHONE_SMS + '"><span class="ic">💬</span><span class="tx"><span class="l">Text us</span><span class="v">' + PHONE_DISPLAY + '</span></span></a>' +
      '</div>';
    var kicker, count, bodyHtml, cta;

    if (S.footerModal === 'digest') {
      kicker = 'The Fresh Digest'; count = 'Real reading on real food';
      var DIGEST = [
        ['🥗', 'Longevity', 'Lean dogs live longer', 'Purina 14-year Life Span Study', 'Feeding to a lean body condition added a median of nearly 2 healthy years — 13 vs. 11.2.', 'https://penntoday.upenn.edu/news/study-finds-dogs-fed-reduced-calorie-diet-live-nearly-two-years-longer-dogs-unrestricted-diet'],
        ['🎗️', 'Cancer', 'How common is cancer in dogs?', 'American Animal Hospital Assoc.', 'About 1 in 4 dogs develop cancer — climbing to roughly 1 in 2 for dogs over age 10.', 'https://www.aaha.org/resources/how-common-is-cancer-in-dogs/'],
        ['⚖️', 'Obesity', 'The State of Pet Obesity', 'Assoc. for Pet Obesity Prevention', '59% of U.S. dogs are overweight or obese — the most common preventable disease in dogs.', 'https://www.petobesityprevention.org/2022'],
        ['🔬', 'Processing', 'Fresh vs. extruded kibble', 'Peer-reviewed clinical study', 'Dogs eating minimally-processed food showed measurably different health markers than kibble-fed dogs.', 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8174467/']
      ];
      var cards = DIGEST.map(function (d) {
        return '<a class="onb2-digest-card" href="' + d[5] + '" target="_blank" rel="noopener">' +
          '<span class="onb2-digest-ic">' + d[0] + '</span>' +
          '<span class="onb2-digest-body">' +
          '<span class="tag">' + d[1] + '</span>' +
          '<span class="t">' + d[2] + '</span>' +
          '<span class="src">' + d[3] + '</span>' +
          '<span class="take">' + d[4] + '</span>' +
          '<span class="read">Read →</span>' +
          '</span></a>';
      }).join('');
      bodyHtml =
        '<p class="onb2-why-intro">The science behind the bowl — a few independent reads we trust on why fresh, portioned food changes a dog’s life.</p>' +
        '<div class="onb2-digest-cards">' + cards + '</div>';
      cta = '<button type="button" class="onb2-sheet-cta" data-act="footer-begin">Build my dog’s plan</button>';

    } else if (S.footerModal === 'affiliates') {
      kicker = 'Affiliates &amp; Partners'; count = 'Let’s grow the pack together';
      bodyHtml =
        '<p class="onb2-why-intro">Love fresh food and have an audience of dog people — a clinic, a rescue, a following, a newsletter? Let’s partner. Reach out any of these ways:</p>' +
        contact +
        '<div class="onb2-contact-note">Tell us a bit about you and your audience and we’ll follow up fast.</div>';
      cta = '<button type="button" class="onb2-sheet-cta" data-act="footer-close">Got it</button>';

    } else {
      kicker = 'For Veterinary Professionals'; count = 'The nutrition, standards &amp; team';
      var team =
        '<div class="onb2-vet-team"><div class="onb2-vet-team-h">The full nutrition team behind every recipe</div>' +
        TEAM_ROWS.map(function (x) {
          return '<div class="onb2-vet-team-row">' + SVG_CHK_S + '<span>' + x + '</span></div>';
        }).join('') + '</div>';
      var STD = [
        ['AAFCO', 'Formulated to meet AAFCO adult-maintenance nutrient profiles.'],
        ['LAB', 'Eurofins lab-verified guaranteed analysis on every recipe.'],
        ['USDA', 'Human-grade ingredients, prepared to human food-safety standards.'],
        ['FRESH', 'Gently cooked weekly from whole foods — never extruded or rendered.']
      ];
      var stds = STD.map(function (s) {
        return '<div class="onb2-vet-std"><span class="b">' + s[0] + '</span><span class="t">' + s[1] + '</span></div>';
      }).join('');
      bodyHtml =
        '<p class="onb2-why-intro">PETCHEFY is fresh, gently-cooked, complete-and-balanced nutrition — expert-built and lab-verified. The details you’d want before recommending us:</p>' +
        team +
        '<div class="onb2-vet-stds">' + stds + '</div>' +
        '<div class="onb2-vet-getintouch">Get in touch</div>' +
        '<p class="onb2-why-intro" style="margin-bottom:14px;">Interested in offering PETCHEFY to your patients? Want to join our Veterinary Nutritionist referral network and we’ll send you patients looking to formulate their own recipes? Let us know below.</p>' +
        contact;
      cta = '<button type="button" class="onb2-sheet-cta" data-act="footer-close">Got it</button>';
    }

    return sheetHtml({
      overlayAttr: 'data-act-footeroverlay',
      kicker: kicker,
      count: count,
      closeAct: 'footer-close',
      bodyHtml: bodyHtml,
      footHtml: cta
    });
  }

  // Nutrition Facts modal (plan page) — reuses the landing info modal's
  // "Ingredients & nutrition" accordion (all recipes), nothing else.
  function viewNutritionModal() {
    if (!S.nutritionModal) return '';
    return sheetHtml({
      overlayAttr: 'data-act-nutrioverlay',
      kicker: 'Ingredients &amp; nutrition',
      count: 'Every recipe, lab-verified',
      closeAct: 'nutri-close',
      bodyHtml: recipeAccordionHtml(''),
      footHtml: '<button type="button" class="onb2-sheet-cta" data-act="nutri-close">Done</button>'
    });
  }

  /* ---------- bulk bags (phase 2, 2026-09-20) ----------
   * Everything in this block is gated on BULK_ON: the section's bulk_enabled switch AND the pricing
   * engine (onboarding-v2-bulk.js, window.PCFY_BULK) AND the bulk product's variants being injected.
   * Off = none of it renders and the quiz behaves exactly as before. Prices come only from the bulk
   * variants (cents) so displayed = charged; the pre-portioned comparison uses the same meal-plan
   * variants the pre-portioned checkout charges. Rules: bulk-plan/engine-src.js header. */
  var BULK_CFG = parseJSON(COMMERCE.bulkConfig, {});
  var BULK_PLANS = parseJSON(COMMERCE.bulkPlans, {});
  var BULK_ON = !!COMMERCE.bulkEnabled && !!window.PCFY_BULK && Array.isArray(COMMERCE.bulkVariants) && COMMERCE.bulkVariants.length > 0;
  var BULK_ENGINE = null;
  try { if (BULK_ON) BULK_ENGINE = window.PCFY_BULK.create({ bulkVariants: COMMERCE.bulkVariants, mealVariants: COMMERCE.variants, config: BULK_CFG }); } catch (e) { BULK_ON = false; }
  var BULK_KEYS = BULK_ON ? window.PCFY_BULK.KEYS : ['turkey', 'chicken', 'beef', 'pork'];
  var BULK_SHORT = { turkey: 'Turkey', chicken: 'Chicken', beef: 'Beef', pork: 'Pork' };
  var BULK_WS_EMAIL = trim(COMMERCE.bulkWholesaleEmail || '') || RX_TO;
  var BULK_WS_PHONE = trim(COMMERCE.bulkWholesalePhone || '') || PHONE_DISPLAY;
  var BULK_WS_SMS = 'sms:+1' + BULK_WS_PHONE.replace(/\D/g, '').replace(/^1/, '');
  var bulkDraft = null; // recipe-mix modal draft { key: bags } — transient, never persisted
  // The freezer question was replaced by the feeding-style step on 2026-10-03. These labels only
  // translate an answer saved before then into the order's _freezer_space note (see buildBulkCartItems).
  var FREEZER_CARDS = [
    { emoji: '🧊', title: 'A freezer shelf', desc: 'Top of the fridge, one shelf', lb: 15 },
    { emoji: '🗄️', title: 'A drawer or two', desc: 'A couple of freezer drawers', lb: 30 },
    { emoji: '❄️', title: 'Half a freezer', desc: 'Plenty of room to stack', lb: 60 },
    { emoji: '🧰', title: 'A chest freezer', desc: 'Or a second freezer', lb: 150 }
  ];

  function fmt0(v) { return (v < 0 ? '−$' : '$') + Math.round(Math.abs(v)); }
  function bulkNum(v, fb) { var n = parseFloat(v); return Number.isFinite(n) ? n : fb; }
  function bulkCfg() { return BULK_ENGINE ? BULK_ENGINE.config : BULK_CFG; }
  function bulkRecipe(key) { return RECIPE_BOOK.filter(function (r) { return r.key === key; })[0]; }
  // the weight a plan is sized to — same rule as the pre-portioned variant (guideWeight)
  function bulkDogsInput() {
    return S.dogs.map(function (d) { return { name: dogName(d), weight: guideWeight(d) }; }).filter(function (x) { return x.weight > 0; });
  }
  function bulkSizedLabel(d) {
    var g = guideWeight(d), w = parseFloat(d.weight);
    return esc(dogName(d)) + ' (' + (w || g) + ' lb' + (g && w && g !== w ? ', sized to ' + g + ' lb goal' : '') + ')';
  }
  // the portion the plan page actually sells: Half needs every dog >= 6 lb, Topper > 15 lb (same gates as viewPlan)
  function p2EffectivePortion() {
    var sized = function (d) { return parseFloat((d.body === 1) ? d.weight : (d.idealWeight || d.weight)); };
    var topperOk = S.dogs.every(function (d) { var w = sized(d); return Number.isFinite(w) && w > 15; });
    var halfOk = S.dogs.every(function (d) { var w = sized(d); return Number.isFinite(w) && w >= 6; });
    var p = S.p2Portion || 'full';
    if (p === 'topper' && !topperOk) p = 'full';
    if (p === 'half' && !halfOk) p = 'full';
    return p;
  }
  function bulkInput(over) {
    over = over || {};
    var mix = ('mix' in over) ? over.mix : S.bulkMix;
    return { dogs: bulkDogsInput(), portion: p2EffectivePortion(), recipes: over.recipes || (mix ? null : (Array.isArray(S.recipeSel) && S.recipeSel.length ? S.recipeSel : null)), mix: mix };
  }
  function bulkPlan(over) { if (!BULK_ON) return null; try { return BULK_ENGINE.plan(bulkInput(over)); } catch (e) { return null; } }
  function bulkDefaultKeys() { try { return BULK_ENGINE.defaultRecipes(bulkDogsInput(), p2EffectivePortion()); } catch (e) { return ['turkey', 'beef']; } }
  // bulk drives the footer/checkout only when the shopper chose it AND it can actually be sold: not wholesale, every bag size has a variant, a trial plan exists
  function bulkSellable(P) { return !!(P && !P.wholesale && !P.missingVariant && BULK_PLANS.trial); }
  function bulkActive() { return BULK_ON && S.bulkFormat === 'bulk' && bulkSellable(bulkPlan()); }
  // Default recipes per format. Pre-portioned: Turkey + Beef, the chosen default pair (also the
  // default when bulk is off). Bulk: the engine's cheapest mix.
  function defaultRecipesFor(fmt) { return (BULK_ON && fmt === 'bulk') ? bulkDefaultKeys() : ['turkey', 'beef']; }
  function sameKeys(a, b) { return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every(function (k) { return b.indexOf(k) >= 0; }); }
  // The bulk plan to show a shopper who is on pre-portioned = exactly what tapping the switch gives:
  // the default bulk mix while their recipes are still the untouched default (the 'bulk-format'
  // handler re-seeds them the same way), or bulk on their own recipes / saved bag mix otherwise.
  // So the saving quoted on the feeding step and the plan page is the price they then see.
  function bulkOfferPlan() {
    if (!BULK_ON) return null;
    if (S.bulkFormat === 'bulk' || S.bulkMix) return bulkPlan();
    var rs = S.recipeSel;
    return (!Array.isArray(rs) || !rs.length || sameKeys(rs, defaultRecipesFor('pre'))) ? bulkPlan({ recipes: bulkDefaultKeys() }) : bulkPlan();
  }
  function bulkSameMix(a, b) { var ks = {}, k; for (k in a) if (a[k] > 0) ks[k] = 1; for (k in b) if (b[k] > 0) ks[k] = 1; for (k in ks) { if ((a[k] || 0) !== (b[k] || 0)) return false; } return true; }
  function bulkDefaultTrialMix() { var P0 = bulkPlan({ mix: null }); return P0 && !P0.wholesale ? P0.trialMix : {}; }
  // the plan a draft would produce if saved (the default path when the draft equals the default mix)
  function bulkPreview(draft) { var tot = 0; for (var k in draft) tot += draft[k] || 0; if (!tot) return null; return bulkSameMix(draft, bulkDefaultTrialMix()) ? bulkPlan({ mix: null }) : bulkPlan({ mix: draft }); }
  function bulkKeysWithBags(mix) { return BULK_KEYS.filter(function (k) { return mix[k] > 0; }); }
  // compact facts for the funnel sink (rides on every event once bulk is on)
  function bulkSummary() {
    if (!BULK_ON) return null;
    var P = bulkPlan(); if (!P) return null;
    if (P.wholesale) return { wholesale: true, lbDay: +P.lbDay.toFixed(2) };
    return { format: S.bulkFormat, lbDay: +P.lbDay.toFixed(2), bag: P.bag, trialBags: P.trial.n, trialPrice: +P.trial.price.toFixed(2), recurBags: P.recur.n, recurPrice: +P.recur.price.toFixed(2), listDay: +P.listDay.toFixed(2), bulkDay: +P.recur.perDay.toFixed(2), saveDay: +P.saveDay.toFixed(2), mix: P.trialMix, custom: !!S.bulkMix };
  }

  /* --- feeding style (household step after the last dog; replaced the freezer question 2026-10-03) ---
   * Pre-portioned is the recommendation and the default, so it shows selected and Continue is live
   * without a tap. The bulk card quotes this pack's real saving from the same plan the plan page
   * offers (bulkOfferPlan), and makes no saving claim when bulk isn't cheaper. A pack bulk can't be sold
   * to online (wholesale size, or a catalog gap) sees the pre-portioned card alone. */
  function viewFeeding() {
    var names = joinList(S.dogs.map(function (x) { return trim(x.name) || 'your pup'; }), ' & ');
    var P = bulkOfferPlan(), sell = bulkSellable(P), onBulk = sell && S.bulkFormat === 'bulk';
    var whose = S.dogs.length > 1 ? 'each dog’s' : esc(dogPoss(S.dogs[0]));
    var card = function (key, on, emoji, title, desc, lead, badge) {
      return '<button type="button" class="onb2-feedcard' + (on ? ' is-on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-act="bulk-format" data-key="' + key + '">' +
        (badge ? '<span class="onb2-feed-badge">' + badge + '</span>' : '') +
        '<span class="em" aria-hidden="true">' + emoji + '</span>' +
        '<span class="tx"><span class="t">' + title + '</span>' + (lead || '') + '<span class="d">' + desc + '</span></span>' +
        '</button>';
    };
    // per day of food (box ÷ days of food in it), the same figure the plan page explains; no monthly
    // figure here, where there is no room for that footnote
    var save = (sell && P.saveDay >= 0.01) ? '<span class="s">Save about ' + fmt(P.saveDay) + ' a day</span>' : '';
    var note = (!sell && P && P.wholesale)
      ? '<p class="onb2-feed-note">Bulk bags for a pack this size are priced by hand. Text <a href="' + esc(BULK_WS_SMS) + '">' + esc(BULK_WS_PHONE) + '</a> and we’ll set it up.</p>' : '';
    return '<div class="onb2-screen onb2-screen--tight onb2-screen--feed">' +
      '<p class="onb2-line">How would you like to feed ' + esc(names) + '?</p>' +
      '<div class="onb2-feed">' +
      card('pre', !onBulk, '🥣', 'Pre-portioned convenience', 'Packs portioned to ' + whose + ' size. Best for complete control and weight management.', '', 'Recommended') +
      (sell ? card('bulk', onBulk, '⚖️', 'Feed at your own pace', 'Large bulk bags you weigh and serve yourself.', save) : '') +
      '</div>' + note +
      '</div>';
  }

  /* --- plan page: the bulk block (under "Choose your amount") --- */
  function bulkBagChip(l) { return '<span class="onb2-bk-bag">' + l.qty + ' × ' + BULK_SHORT[l.key] + ' ' + l.size + ' lb</span>'; }
  // "100% chest freezer rebate on plans over $300 a month" (Andres 2026-10-03). The rule is about
  // spend, not format: any plan, pre-portioned or bulk, whose spend averages over the threshold a
  // month across the year — deliveries can be weeks apart, so never the size of one box. The line
  // shows for every pack; the plan being bought (`onBulk` = bulk drives checkout) gets its own
  // figure and the number to text when it clears the threshold.
  // The figure is price per day of FOOD × 30.4 (food only, before delivery and tax). For
  // pre-portioned that is exactly what the plan bills. For bulk it is a floor: the every-14-days
  // boxes hold more than 14 days of food, so a shopper who takes every box spends more (62 lb dog:
  // $293 on this measure, $331 billed). So it may only ever be used to say a plan QUALIFIES — never
  // that one falls short. A plan under the line gets the rule and nothing else.
  function bulkRebateHtml(P, cfg, onBulk) {
    var thr = bulkNum(cfg.freezerOfferMonthly, 300);
    if (!(thr > 0)) return '';
    var monthly = onBulk ? P.monthly : P.listDay * 30.4;
    // Whole dollars: the bulk floor rounds DOWN (an "at least" figure must not exceed what the boxes
    // bill), and a plan a few cents over the line reads "just over $300", not "about $300 ... qualifies".
    var shown = onBulk ? Math.floor(monthly) : Math.round(monthly);
    var fig = shown <= thr ? 'just over ' + fmt0(thr) : (onBulk ? 'at least ' : 'about ') + '$' + commas(shown);
    var own = (monthly > thr)
      ? ' Your ' + (onBulk ? 'bulk' : 'pre-portioned') + ' plan averages ' + fig + ' a month, so it qualifies. Text <a href="' + esc(BULK_WS_SMS) + '">' + esc(BULK_WS_PHONE) + '</a> to claim it.'
      : '';
    return '<div class="onb2-bk-callout"><b>100% chest freezer rebate</b> on plans over ' + fmt0(thr) + ' a month.' + own + '</div>';
  }
  function bulkBlockHtml(m) {
    var P = bulkOfferPlan(); if (!P) return '';
    var cfg = bulkCfg();
    if (P.wholesale) {
      return '<section class="cream"><p class="onb2-bk-kicker">Bulk bags</p><h3 class="onb2-bk-h">That’s a serious pack</h3>' +
        '<p class="onb2-bk-line">' + esc(m.planFor) + ' eat about <b>' + P.lbDay.toFixed(1) + ' lb a day</b> — more than our biggest ' + cfg.maxBag + ' lb bag covers in ' + cfg.thawDays + ' days. That’s wholesale territory, and we price it by hand.</p>' +
        '<div class="onb2-bk-callout">Text or call <a href="' + esc(BULK_WS_SMS) + '">' + esc(BULK_WS_PHONE) + '</a> or email <a href="mailto:' + esc(BULK_WS_EMAIL) + '">' + esc(BULK_WS_EMAIL) + '</a> and we’ll set up your pack’s plan.</div>' +
        '<p class="onb2-bk-note">The pre-portioned plan above works as-is.</p>' + bulkRebateHtml(P, cfg, false) + '</section>';
    }
    if (!bulkSellable(P)) return ''; // catalog gap (no variant for this bag size, or no trial plan): stay silent
    var T = P.trial, R = P.recur;
    var per = S.dogs.map(function (d, i) { var lc = (P.dogs[i] || {}).listCents || 0; return '<div class="onb2-bk-row"><span>' + bulkSizedLabel(d) + ' · pre-portioned</span><span class="r">' + fmt(lc / 100) + '/day</span></div>'; }).join('');
    var saveLine = P.saveDay >= 0.01
      ? '<div class="onb2-bk-big">You save ' + fmt(P.saveDay) + '/day<span class="hand">≈ ' + fmt0(P.saveDay * 30.4) + ' a month</span></div>'
      : (P.saveDay <= -0.01
        ? '<div class="onb2-bk-big">Bulk costs ' + fmt(-P.saveDay) + '/day more with this mix</div>'
        : '<div class="onb2-bk-big">Same price per day with this mix</div>');
    var mixLine = P.recipes.map(function (r) { return Math.round(P.shares[r] * 100) + '% ' + BULK_SHORT[r]; }).join(' · ');
    var feed = P.dogs.map(function (d) { return '<b>' + esc(d.name) + '</b>: ' + P.recipes.map(function (r) { return BULK_SHORT[r] + ' ' + Math.round(d.g[r]) + ' g/day'; }).join(' · '); }).join('<br>');
    var smallNote = P.bagDays > cfg.thawDays + 0.05 ? '<p class="onb2-bk-note">A ' + P.bag + ' lb bag lasts ' + esc(m.planFor) + ' about ' + P.bagDays.toFixed(1) + ' days — keep it cold and use it up.</p>' : '';
    var shipFrom = bulkNum(BULK_CFG.shippingFrom, 0);
    var saveCard = '<div class="onb2-bk-save">' + per +
      '<div class="onb2-bk-row tot"><span>' + (S.bulkFormat === 'bulk' ? 'Pre-portioned packs' : 'Your pre-portioned plan') + '</span><span class="r">' + fmt(P.listDay) + '/day</span></div>' +
      '<div class="onb2-bk-row tot"><span>Bulk bags · ' + P.lbDay.toFixed(1) + ' lb a day</span><span class="r">' + fmt(R.perDay) + '/day</span></div>' +
      saveLine + '<div class="onb2-bk-note">Per day = box ÷ days of food in it. Before delivery and tax. Mix: ' + mixLine + '.</div></div>';
    if (S.bulkFormat !== 'bulk') {
      // Pre-portioned is the plan being sold (the recommended default). Bulk is the savings offer,
      // one tap away: the comparison, the trial in one line, a switch, and the freezer rebate.
      var saves = P.saveDay >= 0.01;
      return '<section class="cream" data-bulk-block>' +
        '<p class="onb2-bk-kicker">' + (saves ? 'Want to save? ' : '') + 'Bulk bags · ' + esc(m.planFor) + '</p>' +
        '<h3 class="onb2-bk-h">' + (saves ? 'Feed at your own pace and save ' + fmt(P.saveDay) + ' a day' : 'Feed at your own pace with bulk bags') + '</h3>' +
        saveCard +
        '<p class="onb2-bk-line">Same food in large bags you weigh and serve yourself. Trial box: ' + T.lbs + ' lb, about ' + Math.round(T.covered) + ' days, <b>' + fmt(T.price) + '</b> + free shipping.</p>' +
        '<button type="button" class="onb2-bk-btn" data-act="bulk-format" data-key="bulk">Switch to bulk bags</button>' +
        bulkRebateHtml(P, cfg, false) +
        '</section>';
    }
    return '<section class="cream" data-bulk-block>' +
      '<p class="onb2-bk-kicker">Bulk bags · ' + esc(m.planFor) + '</p><h3 class="onb2-bk-h">Same food, bigger bags, you portion it</h3>' +
      saveCard +
      '<h4 class="onb2-bk-sub">Your trial box · about ' + cfg.trialDays + ' days</h4><div class="onb2-bk-bags">' + T.lines.map(bulkBagChip).join('') + '</div>' +
      '<p class="onb2-bk-line">' + T.lbs + ' lb · about ' + Math.round(T.covered) + ' days · <b>' + fmt(T.price) + '</b> + free shipping</p>' +
      '<h4 class="onb2-bk-sub">Then every ' + cfg.cadenceDays + ' days</h4><div class="onb2-bk-bags">' + R.lines.map(bulkBagChip).join('') + '</div>' +
      '<p class="onb2-bk-line">' + R.lbs + ' lb · about ' + Math.round(R.covered) + ' days · <b>' + fmt(R.price) + '</b> per box' + (shipFrom > 0 ? ' + shipping starting at ' + fmt(shipFrom) : '') + '</p>' +
      '<p class="onb2-bk-feed"><b>Feeding card</b> (packed in the box, with a digital scale on your trial)<br>' + feed + '<br>Thaw one bag at a time in the fridge and use it within ' + cfg.thawDays + ' days of opening' + (cfg.thawDays === 3 ? ' (open Monday, finish by Thursday)' : '') + '. Bags are sized so ' + esc(m.planFor) + ' finish one in about ' + P.bagDays.toFixed(1) + ' days.</p>' +
      smallNote + bulkRebateHtml(P, cfg, true) +
      '<p class="onb2-bk-switch">Prefer meals weighed and bagged per dog? <button type="button" class="onb2-bk-link" data-act="bulk-format" data-key="pre">Switch to pre-portioned packs</button></p>' +
      '</section>';
  }

  // the plan page's recipe line + trial-bags line in bulk mode
  function bulkTrialMixLine() {
    var P = bulkPlan(); if (!P || !bulkSellable(P)) return '';
    return '<p class="onb2-of-recipes" style="margin-top:4px;"><b>Trial bags:</b> ' + P.trial.lines.map(function (l) { return l.qty + '× ' + BULK_SHORT[l.key]; }).join(' · ') + '</p>';
  }
  // the sticky footer's price line + footnote when bulk drives checkout (null = keep the pre-portioned ones)
  function bulkFootbar() {
    if (!bulkActive()) return null;
    var P = bulkPlan(), cfg = bulkCfg();
    return {
      priceLine: '<div class="onb2-of-price"><b>Bulk trial:</b> <span class="now">' + fmt(P.trial.perDay) + '/day</span> <span class="ship">+ FREE shipping</span></div>',
      note: 'Trial box (' + P.trial.lbs + ' lb of bulk bags, about ' + Math.round(P.trial.covered) + ' days) ≈ ' + fmt(P.trial.price) + ' · pre tax · then every ' + cfg.cadenceDays + ' days'
    };
  }

  /* --- recipe mix modal (the Customer Portal's allocator, with bags) --- */
  function viewBulkMixModal() {
    if (!S.bulkMixModal || !BULK_ON) return '';
    var base = bulkPlan({ mix: null }); if (!base || base.wholesale) return '';
    var draft = bulkDraft || {}, tot = 0, used = 0;
    BULK_KEYS.forEach(function (k) { tot += draft[k] || 0; if (draft[k] > 0) used++; });
    var PV = bulkPreview(draft), n = PV && !PV.wholesale ? PV.trialRecommended : base.trialRecommended;
    var cfg = bulkCfg();
    var cards = BULK_KEYS.map(function (k) {
      var r = bulkRecipe(k) || { name: BULK_SHORT[k], ing: '', kcalKg: '', img: '' };
      var c = draft[k] || 0, locked = c === 0 && used >= 3, full = tot >= n;
      var solo = bulkPlan({ mix: null, recipes: [k] });
      var pd = solo && !solo.wholesale && !solo.missingVariant ? '<div class="pd">Bulk: ' + fmt(solo.recur.perDay) + '/day for the pack</div>' : '';
      var ing = (r.ing || '').split(',').slice(0, 4).join(',');
      return '<div class="onb2-mixcard' + (c > 0 ? ' is-on' : '') + (locked ? ' is-locked' : '') + '">' +
        '<span class="tag">' + esc(BULK_SHORT[k]) + '</span>' + (c > 0 ? '<span class="cnt">' + c + '</span>' : '') +
        '<div class="onb2-mixcard-img" role="img" aria-label="' + esc(r.name) + '" style="background-image:url(\'' + (r.img || '') + '\')">' + (locked ? '<span class="lock">MAX 3 RECIPES</span>' : '') + '<span class="kcal">' + esc(r.kcalKg || 'Energy TBD') + '</span></div>' +
        '<div class="n">' + esc(r.full || r.name) + '</div><div class="d">' + esc(ing) + '</div>' + pd +
        '<button type="button" class="lnk" data-act="recipe-facts" data-key="' + k + '">Ingredients &amp; nutrition →</button>' +
        '<div class="onb2-mix-step"><button type="button" data-act="bulk-mix-dec" data-key="' + k + '"' + (c === 0 ? ' disabled' : '') + ' aria-label="one less bag">−</button><span class="v">' + c + '</span><button type="button" data-act="bulk-mix-inc" data-key="' + k + '"' + (locked || full ? ' disabled' : '') + ' aria-label="one more bag">+</button></div>' +
        '</div>';
    }).join('');
    var mixTxt = tot ? BULK_KEYS.filter(function (k) { return draft[k] > 0; }).map(function (k) { var r = bulkRecipe(k); return draft[k] + '× ' + esc(r ? r.full : BULK_SHORT[k]); }).join(' · ') : 'no bags yet';
    var thenTxt = PV && !PV.wholesale ? 'Then every ' + cfg.cadenceDays + ' days: ' + PV.recur.lines.map(function (l) { return l.qty + '× ' + BULK_SHORT[l.key]; }).join(' · ') + ' (' + PV.recur.lbs + ' lb, ' + fmt(PV.recur.price) + '). Change it anytime in your account.' : '';
    var ok = tot === n && tot > 0;
    var names = joinList(S.dogs.map(function (x) { return trim(x.name) || 'your pup'; }), ' & ');
    return sheetHtml({
      overlayAttr: 'data-act-mixoverlay',
      kicker: 'Recipe mix',
      count: tot + ' of ' + n + ' bag' + (n > 1 ? 's' : '') + ' in your trial · up to 3 recipes',
      closeAct: 'bulk-mix-cancel',
      bodyHtml:
        '<div class="onb2-mix-counter"><div class="top"><span class="big">' + tot + ' <small>/ ' + n + '</small></span><span class="lbl">bags in your trial</span>' +
        '<span class="acts"><button type="button" data-act="bulk-mix-spread">Spread evenly</button><button type="button" data-act="bulk-mix-clear">Clear</button></span></div>' +
        '<div class="bar"><i style="width:' + Math.min(100, Math.round(tot / n * 100)) + '%"></i></div></div>' +
        '<div class="onb2-mix-grid">' + cards + '</div>' +
        '<div class="onb2-mix-your"><div class="l">Your mix</div><div><b>' + mixTxt + '</b></div>' + (thenTxt ? '<div style="font-size:.82rem;color:var(--muted2);margin-top:4px;">' + thenTxt + '</div>' : '') + '</div>' +
        '<p style="font-size:.82rem;color:var(--muted);margin:0 0 12px;line-height:1.5;">Each bag is one recipe, sized so ' + esc(names) + ' finish it in about ' + cfg.thawDays + ' days. Your trial is ' + n + ' bag' + (n > 1 ? 's' : '') + '; pick how many of each.</p>',
      footHtml: '<div class="onb2-mix-foot"><button type="button" class="onb2-modal-cancel" data-act="bulk-mix-cancel">Cancel</button><button type="button" class="onb2-sheet-cta" data-act="bulk-mix-save"' + (ok ? '' : ' disabled') + '>Save mix</button></div>'
    });
  }

  /* --- checkout payload: one cart line per trial bag on the trial selling plan (same shape as the pre-portioned trial) --- */
  function buildBulkCartItems() {
    // bulkOfferPlan() is bulkPlan() whenever bulk is the chosen format (the only time Checkout calls
    // this). On pre-portioned it is the plan a switch would give, which keeps the QA hook below and the
    // phone-link parity test reading the default bulk mix for a household that never picked recipes.
    var P = bulkOfferPlan(); if (!bulkSellable(P)) return null;
    var cfg = bulkCfg();
    var props = {
      _trial: 'true', _bulk: 'true', _cadence_days: String(cfg.cadenceDays), _recur_bags_per_box: String(P.recur.n), _bag_lb: String(P.bag),
      _household_lb_day: P.lbDay.toFixed(2), _dog_names: S.dogs.map(dogName).join(', '), _portion: P.portion,
      _freezer_space: (S.freezer >= 0 && FREEZER_CARDS[S.freezer]) ? FREEZER_CARDS[S.freezer].title : '', _freezer_interest: S.freezerInterest ? 'yes' : 'no', _first_box_scale: 'true'
    };
    P.dogs.forEach(function (d, i) {
      var sd = S.dogs[i] || {}, w = parseFloat(sd.weight), g = d.weight;
      props['Feeding — ' + d.name + ' (' + (w || g) + ' lb' + (w && g !== w ? ', goal ' + g + ' lb' : '') + ')'] = P.recipes.map(function (r) { return BULK_SHORT[r] + ' ' + Math.round(d.g[r]) + ' g/day'; }).join(' · ');
    });
    return P.trial.lines.map(function (l) {
      var rq = 0; P.recur.lines.forEach(function (x) { if (x.key === l.key) rq = x.qty; });
      var pr = { _recur_qty: String(rq), _recur_price: l.unit.toFixed(2) };
      for (var k in props) pr[k] = props[k];
      return { id: l.variantId, selling_plan: BULK_PLANS.trial, quantity: l.qty, properties: pr };
    });
  }
  // read-only QA hook (qa/bulk-phase2-check.js inspects the payload without touching a cart)
  try { window.__onb2BulkPayload = function () { return BULK_ON ? buildBulkCartItems() : null; }; } catch (e) {}

  /* ---------- chrome (header / footbar / rx modal / jump) ---------- */

  function phaseOf(t) {
    if (DOG_STEPS.indexOf(t) >= 0 || t === 'feeding') return 1;
    if (t === 'calc') return 2;   // loading page = 3rd node
    if (t === 'plan') return 3;   // plan page = 4th node (full bar)
    return 0;
  }

  function stepLabel(t) {
    if (t === 'landing' || t === 'intro') return '';
    var p = phaseOf(t);
    return p === 0 ? 'Me (1/4)' : (p === 1 ? 'My Dogs (2/4)' : (p === 2 ? 'Building (3/4)' : 'Your Plan (4/4)'));
  }

  function viewHeader() {
    var c = cur();
    var showBack = S.stepIdx > 0 && c.t !== 'calc';
    var phase = phaseOf(c.t);
    var label = stepLabel(c.t);
    var nodes = '';
    for (var i = 0; i < 4; i++) {
      var cls = i < phase ? ' done' : (i === phase ? ' on' : '');
      nodes += '<span class="node' + cls + '"></span>';
      if (i < 3) nodes += '<span class="seg' + (i < phase ? ' done' : '') + '"></span>';
    }
    return '<div class="onb2-promo">' + esc(PROMO) + '</div>' +
      '<div class="onb2-topbar">' +
      '<button type="button" class="onb2-back" data-act="back" style="visibility:' + (showBack ? 'visible' : 'hidden') + ';">' + SVG_BACK + 'back</button>' +
      '<img class="onb2-topbar-logo" src="' + (A.logo2 || A.logo) + '" alt="PETCHEFY">' +
      (c.t === 'landing' ? '<a class="onb2-login" href="https://petchefy.com/apps/account">Log In</a>' : '<span class="onb2-steplabel">' + label + '</span>') +
      '</div>' +
      (c.t !== 'landing' ? '<div class="onb2-progress">' + nodes + '</div>' : '');
  }

  function nextLabel(c, d) {
    if (c.t === 'contact' && zipOk() && !zipServed()) {
      return S.waitlistSent ? 'We’ll be in touch' : 'Keep me posted';
    }
    if (c.t === 'health' && d.rx === 'does') {
      // Once the referral is sent the step is a deliberate dead end (we can't sell a
      // prescription plan online). Say that on the button instead of leaving a greyed-out
      // "Continue", which reads as broken and invites going back to change the answer.
      return d.referralSent ? 'We’ll be in touch' : 'Refer Me';
    }
    return 'Continue';
  }

  /* Single source of truth for the footer CTA, used by BOTH the initial render and the
   * live refresh — they used to compute readiness separately and could disagree.
   * Two steps deliberately keep the bar live but do not advance the funnel:
   *   - prescription diet: we don't serve Rx without a nutritionist-approved formula
   *   - out-of-area ZIP: we only deliver in Florida today
   * Both offer a capture action, then grey out once it's been sent. */
  function footbarState(c, d) {
    var rxDiet = (c.t === 'health' && d.rx === 'does');
    var outOfArea = (c.t === 'contact' && zipOk() && !zipServed());
    return {
      can: (rxDiet || outOfArea) ? true : canNext(c, d),
      blocked: (rxDiet && d.referralSent) || (outOfArea && S.waitlistSent)
    };
  }

  function viewFootbar() {
    var c = cur();
    if (QUIZ_STEPS.indexOf(c.t) < 0) return '';
    var d = curDog();
    var f = footbarState(c, d);
    return '<div class="onb2-footbar' + (f.can ? ' is-ready' : '') + '" data-footbar>' +
      '<button type="button" class="onb2-cta" data-act="next"' + (f.blocked ? ' disabled' : '') + '>' + nextLabel(c, d) + '</button>' +
      '</div>';
  }

  function viewRxModal() {
    if (!S.rxModal) return '';
    var d = curDog();
    var val = rxEmailVal();
    var preview = 'Hi PETCHEFY team, I’d like to be referred to a board-certified veterinary nutritionist for help with ' + esc(dogPoss(d)) + ' prescription diet needs. Once I have a nutritionist-approved formula, I understand I can choose to have PETCHEFY prepare ' + esc(dogPoss(d)) + ' food according to that formula. Please follow up with me at this email address.';
    return '<div class="onb2-overlay" data-act-overlay>' +
      '<div class="onb2-modal">' +
      '<h3>Confirm your referral request</h3>' +
      '<p class="onb2-modal-sub">We’ll send a referral request to <strong>' + esc(RX_TO) + '</strong> so our team can help connect you with a board-certified veterinary nutritionist. Please confirm the email below is where you’d like us to follow up.</p>' +
      '<div class="onb2-modal-label">Confirm your email</div>' +
      '<input value="' + esc(val) + '" data-in="rx-email" placeholder="you@email.com" inputmode="email" class="onb2-modal-input">' +
      '<div class="onb2-modal-preview">' + preview + '</div>' +
      '<div class="onb2-modal-actions">' +
      '<button type="button" class="onb2-modal-cancel" data-act="rx-close">Cancel</button>' +
      '<button type="button" class="onb2-modal-send" data-act="rx-send"' + (rxEmailValid() ? '' : ' disabled') + '>Send Referral Request</button>' +
      '</div></div></div>';
  }

  /* Out-of-area waitlist. Same shape as the referral modal: capture, transmit for real,
   * then say plainly that this is where the plan stops. It POSTs through the funnel sink
   * every other step already uses — a modal that confirms without transmitting is exactly
   * the bug we fixed in the referral flow. */
  function viewWaitlistModal() {
    if (!S.waitlistModal) return '';
    return '<div class="onb2-overlay" data-act-overlay>' +
      '<div class="onb2-modal">' +
      '<h3>We’re not in your area yet</h3>' +
      '<p class="onb2-modal-sub">PETCHEFY delivers fresh, weekly-made food across <strong>Florida</strong> today, and we’re expanding. Leave your details and we’ll let you know the moment we reach you.</p>' +
      '<div class="onb2-modal-label">Email us at</div>' +
      '<input value="' + esc(waitlistEmailVal()) + '" data-in="waitlist-email" placeholder="you@email.com" inputmode="email" class="onb2-modal-input">' +
      '<div class="onb2-modal-label">Phone (optional)</div>' +
      '<input value="' + esc(S.waitlistPhone) + '" data-in="waitlist-phone" placeholder="(555) 555-5555" inputmode="tel" class="onb2-modal-input">' +
      '<p class="onb2-rx-contact" style="margin-top:14px;">In a hurry? Text us at <a href="' + PHONE_SMS + '">' + PHONE_DISPLAY + '</a> and we’ll see whether we can find a plan that works for you.</p>' +
      '<div class="onb2-modal-actions">' +
      '<button type="button" class="onb2-modal-cancel" data-act="waitlist-close">Cancel</button>' +
      '<button type="button" class="onb2-modal-send" data-act="waitlist-send"' + (waitlistValid() ? '' : ' disabled') + '>Keep me posted</button>' +
      '</div></div></div>';
  }

  function viewJump() {
    if (!DEBUG) return '';
    var c = cur();
    var f = flow();
    var bottom = (c.t === 'plan' || QUIZ_STEPS.indexOf(c.t) >= 0) ? '160px' : '18px';
    var panel = '';
    if (S.jumpOpen) {
      panel = '<div class="onb2-jump-panel"><div class="onb2-jump-kicker">Jump to screen</div>' +
        f.map(function (st, i) {
          var label = STEP_LABELS[st.t] || st.t;
          if (st.dog != null) {
            var dn = trim(S.dogs[st.dog] && S.dogs[st.dog].name) || 'Pup ' + (st.dog + 1);
            label = dn + ' · ' + label;
          }
          return '<button type="button" class="onb2-jump-item' + (i === S.stepIdx ? ' is-on' : '') + '" data-act="jump-go" data-idx="' + i + '">' +
            '<span class="onb2-jump-num">' + String(i + 1).padStart(2, '0') + '</span><span>' + esc(label) + '</span></button>';
        }).join('') +
        '</div>';
    }
    return '<div class="onb2-jump" style="bottom:' + bottom + '">' + panel +
      '<button type="button" class="onb2-jump-toggle" data-act="jump-toggle">⚡ Screens</button></div>';
  }

  /* ---------- main render ---------- */

  function viewScreen() {
    var c = cur();
    var di = c.dog != null ? c.dog : 0;
    var d = curDog();
    switch (c.t) {
      case 'landing': return viewLanding();
      case 'intro': return viewIntro();
      case 'me': return viewMe();
      case 'owner': return viewOwner();
      case 'contact': return viewContact();
      case 'profile': return viewProfile(d, di);
      case 'weightbody': return viewWeightBody(d, di);
      case 'activity': return viewActivity(d, di);
      case 'eating': return viewEating(d, di);
      case 'food': return viewFood(d, di);
      case 'health': return viewHealth(d, di);
      case 'feeding': return viewFeeding();
      case 'calc': return viewCalc();
      case 'plan': return viewPlan();
      default: return '';
    }
  }

  function modalsHtml() {
    return viewRecipePicker() +
      viewRecipeModal() +
      viewRxModal() +
      viewWaitlistModal() +
      viewInfoModal() +
      viewWhyModal() +
      viewBulkModal() +
      viewBulkLeadModal() +
      viewFooterModal() +
      viewNutritionModal() +
      viewPortionModal() +
      viewBulkMixModal();
  }

  // plan-page "portion details" — per-dog daily calorie guideline from the vet-team MER table
  function viewPortionModal() {
    if (!S.portionModal) return '';
    var rows = S.dogs.slice(0, Math.max(1, S.dogCount)).map(function (d) {
      var gw = guideWeight(d), kcal = gw ? merFor(gw) : null;
      if (!kcal) return '';
      var nm = esc(dogName(d));
      var target = d.body !== 1 && parseFloat(d.idealWeight) > 0;
      var line = target
        ? 'Sized to ' + nm + '’s <b>target weight of ' + Math.round(gw) + ' lb</b>.'
        : nm + ' is right on target — maintenance for a <b>' + Math.round(gw) + ' lb</b> dog.';
      return '<div class="onb2-pd-row"><div class="onb2-pd-kcal">' + commas(kcal) + ' <span>cal / day</span></div>' +
        '<div class="onb2-pd-sub">' + line + '</div></div>';
    }).join('');
    var poss = S.dogCount > 1 ? 'your dogs’' : esc(dogPoss(S.dogs[0]));
    return '<div class="onb2-overlay" data-act-portionoverlay>' +
      '<div class="onb2-modal onb2-pd" style="position:relative;">' +
      '<button type="button" class="onb2-bulk-x" data-act="portion-close" aria-label="Close">✕</button>' +
      '<div class="onb2-pd-kicker">Your daily plan</div>' +
      '<h3>Portioned to the calorie</h3>' +
      rows +
      '<p class="onb2-pd-note">These are starting guidelines from our vet team. Every dog is different — age, breed, and activity all change real needs, so no two dogs eat exactly alike.</p>' +
      '<p class="onb2-pd-note">If ' + poss + ' needs change, you can monitor and log meals in your client portal — with help from your vet — to fine-tune the perfect plan.</p>' +
      '</div></div>';
  }

  // info modal opened from a bowl tap -> reveal the chosen recipe
  function infoJump() {
    if (S.infoModal && S.infoRecipe) {
      var jump = root.querySelector('[data-info-jump]');
      if (jump) try { jump.scrollIntoView({ block: 'start' }); } catch (e) {}
    }
  }

  function render() {
    var c = cur();
    var isQuiz = QUIZ_STEPS.indexOf(c.t) >= 0;
    // innerHTML rebuild wipes user-visible DOM state -> snapshot & restore it
    var openFaq = [];
    root.querySelectorAll('.onb2-main .onb2-faq details').forEach(function (el, i) { if (el.open) openFaq.push(i); });
    var carou = root.querySelector('.onb2-carou');
    var carouLeft = carou ? carou.scrollLeft : 0;
    root.innerHTML = '<div class="onb2-app">' +
      viewHeader() +
      '<div class="onb2-main' + (isQuiz ? ' onb2-main--quiz' : '') + '">' + viewScreen() + '</div>' +
      viewFootbar() +
      '<div data-onb2-modals>' + modalsHtml() + '</div>' +
      viewJump() +
      '</div>';
    var dets = root.querySelectorAll('.onb2-main .onb2-faq details');
    openFaq.forEach(function (i) { if (dets[i]) dets[i].open = true; });
    carou = root.querySelector('.onb2-carou');
    if (carou && carouLeft) carou.scrollLeft = carouLeft;
    fitSelects();
    // innerHTML-injected videos sometimes miss the muted flag -> re-assert + nudge play().
    // Autoplay only works muted; the hero honors the user's unmute choice, all others stay muted.
    root.querySelectorAll('video').forEach(function (v) {
      v.muted = v.closest('.onb2-land-hero') ? !heroUnmuted : true;
      var vp = v.play();
      if (vp && vp.catch) vp.catch(function () {}); // low-power mode etc. -> poster stays
    });
    infoJump();
    updateStepsLine();
    requestAnimationFrame(updateStepsLine); // re-measure once fonts/layout settle
    updateLandCta();
    observeWhyRows();
  }

  // "Why PETCHEFY?" rows glow coral while they pass through the middle of the viewport —
  // a traveling highlight as the user reads down the list. Re-attached after every render.
  var whyGlowObs = null;
  function observeWhyRows() {
    if (whyGlowObs) whyGlowObs.disconnect();
    var rows = root.querySelectorAll('.onb2-land-listrow');
    if (!rows.length || !('IntersectionObserver' in window)) return;
    if (!whyGlowObs) {
      whyGlowObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.target.classList.toggle('is-lit', en.isIntersecting); });
      }, { rootMargin: '-32% 0px -32% 0px' });
    }
    rows.forEach(function (r) { whyGlowObs.observe(r); });
  }

  // Landing: reveal the sticky "See plans & pricing" bar once the hero's own CTA scrolls away,
  // so shoppers can start the quiz from any point down the page. No-op off the landing screen.
  function updateLandCta() {
    var bar = root.querySelector('[data-land-cta]');
    if (!bar) return;
    var heroCta = root.querySelector('.onb2-land-hero-overlay .onb2-land-cta-coral');
    var show = heroCta ? (heroCta.getBoundingClientRect().bottom < 8) : (window.pageYOffset > 320);
    bar.classList.toggle('is-visible', show);
  }
  window.addEventListener('scroll', updateLandCta, { passive: true });
  window.addEventListener('resize', updateLandCta);

  // Pure modal open/close: re-render ONLY the modal layer so the screen DOM survives —
  // keeps the landing hero <video> playing (no restart/re-buffer) and scroll positions intact.
  function renderModals() {
    var layer = root.querySelector('[data-onb2-modals]');
    if (!layer) { render(); return; }
    var wasOpen = !!lastDialog;
    layer.innerHTML = modalsHtml();
    infoJump();
    syncDialogFocus(wasOpen);
  }

  /* ---------- dialog focus management (see sheetHtml) ---------- */

  var lastDialog = null;      // the open dialog node, if any
  var focusBeforeDialog = null; // what had focus when it opened, so we can hand it back

  function focusablesIn(node) {
    return [].slice.call(node.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function syncDialogFocus(wasOpen) {
    var dlg = root.querySelector('[data-onb2-dialog]');
    if (dlg) {
      if (!wasOpen) { focusBeforeDialog = document.activeElement; }
      lastDialog = dlg;
      // only pull focus on OPEN, not on every re-render (toggling a recipe re-renders the sheet)
      if (!wasOpen) {
        var f = focusablesIn(dlg);
        (f.length ? f[0] : dlg).focus();
      }
      return;
    }
    if (wasOpen) {
      lastDialog = null;
      if (focusBeforeDialog && document.contains(focusBeforeDialog)) {
        try { focusBeforeDialog.focus(); } catch (e) {}
      }
      focusBeforeDialog = null;
    }
  }

  // Escape closes, Tab cycles inside. Bound once at document level; a no-op when no dialog is open.
  document.addEventListener('keydown', function (e) {
    var dlg = root.querySelector('[data-onb2-dialog]');
    if (!dlg) return;
    if (e.key === 'Escape') {
      // route through the sheet's own close action so its guards still apply
      // (the recipe picker refuses to close with zero recipes selected)
      var x = dlg.querySelector('.onb2-sheet-x:not([disabled])');
      if (x) { e.preventDefault(); x.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusablesIn(dlg);
    if (!f.length) { e.preventDefault(); dlg.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (!dlg.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function refreshFootbar() {
    var bar = root.querySelector('[data-footbar]');
    if (!bar) return;
    var c = cur();
    var d = curDog();
    var f = footbarState(c, d);
    bar.classList.toggle('is-ready', f.can);
    var btn = bar.querySelector('.onb2-cta');
    if (btn) { btn.textContent = nextLabel(c, d); btn.disabled = f.blocked; }
  }

  /* size each inline select to its SELECTED text, not its widest option (design-zip trick) */
  var sizerEl = null;
  function fitSelects() {
    var sels = root.querySelectorAll('select.onb2-sel');
    if (!sels.length) return;
    if (!sizerEl) {
      sizerEl = document.createElement('span');
      sizerEl.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;white-space:pre;';
      document.body.appendChild(sizerEl);
    }
    sels.forEach(function (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (!opt) return;
      var cs = getComputedStyle(sel);
      sizerEl.style.fontFamily = cs.fontFamily; sizerEl.style.fontSize = cs.fontSize;
      sizerEl.style.fontWeight = cs.fontWeight; sizerEl.style.fontStyle = cs.fontStyle;
      sizerEl.textContent = opt.text;
      sel.style.width = (sizerEl.offsetWidth + 26) + 'px';
    });
  }
  window.addEventListener('resize', fitSelects);

  /* ---------- interactive step connector (landing "how it works") ----------
   * A dotted line threads badge 1 -> 3; a coral fill draws down it as the section
   * scrolls into view, lighting each badge as the fill reaches it. Geometry is
   * measured (handles the variable row heights); guards make it a no-op off-landing. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function updateStepsLine() {
    var wrap = root.querySelector('[data-steps]');
    if (!wrap) return;
    var line = wrap.querySelector('[data-steps-line]');
    var fill = wrap.querySelector('[data-steps-fill]');
    var badges = wrap.querySelectorAll('.onb2-land-step-n');
    if (!line || !fill || badges.length < 2) return;
    wrap.classList.add('js-steps');
    var wr = wrap.getBoundingClientRect();
    var first = badges[0].getBoundingClientRect();
    var last = badges[badges.length - 1].getBoundingClientRect();
    var cx = (first.left + first.width / 2) - wr.left;
    var topY = (first.top + first.height / 2) - wr.top;
    var botY = (last.top + last.height / 2) - wr.top;
    var span = Math.max(0, botY - topY);
    line.style.left = cx + 'px';
    line.style.top = topY + 'px';
    line.style.height = span + 'px';
    // progress: fill from badge 1 down to wherever a trigger line (62% down the viewport) has passed
    var trigger = window.innerHeight * 0.62;
    var firstCY = first.top + first.height / 2;
    var filled = Math.max(0, Math.min(span, trigger - firstCY));
    fill.style.height = filled + 'px';
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i].getBoundingClientRect();
      badges[i].classList.toggle('is-reached', (b.top + b.height / 2) <= trigger + 1);
    }
  }
  var stepsRAF = null;
  function onStepsScroll() {
    if (stepsRAF) return;
    stepsRAF = requestAnimationFrame(function () { stepsRAF = null; updateStepsLine(); });
  }
  window.addEventListener('scroll', onStepsScroll, { passive: true });
  window.addEventListener('resize', onStepsScroll);

  /* ---------- surgical typing sync (no re-render, keeps focus) ---------- */

  function syncMe() {
    var n = S.dogCount;
    var num = root.querySelector('[data-in="dogcount"]');
    if (num) num.classList.toggle('set', n > 0);
    var w = root.querySelector('[data-dogword]');
    if (w) w.textContent = n === 1 ? 'dog' : 'dogs';
    var named = root.querySelector('[data-named]');
    if (named) named.style.display = n >= 1 ? 'inline' : 'none';
    var filled = 0;
    for (var i = 0; i < n; i++) { if (trim((S.dogs[i] || {}).name)) filled++; else break; }
    var visibleCount = Math.min(n, filled + 1);
    root.querySelectorAll('.onb2-namerow').forEach(function (row) {
      var idx = parseInt(row.getAttribute('data-row-idx'), 10);
      row.classList.toggle('is-hidden', !(idx < visibleCount));
    });
    var chip = root.querySelector('[data-bulk-chip]');
    if (chip) chip.innerHTML = bulkChipHtml();
  }

  // "Add another breed" lands directly under the fixed Continue bar at 375/390px once a
  // breed chip appears — fully covered at 375, all but ~5px at 390. The page looks finished
  // (the madlib ends at the chip), so a mixed-breed owner never scrolls and never finds it.
  // Nudge the page only when it is genuinely occluded; 430px and desktop are untouched.
  function revealAddBreed() {
    var ab = root.querySelector('.onb2-addbreed');
    var fb = root.querySelector('[data-footbar]');
    if (!ab || !fb) return;
    var need = ab.getBoundingClientRect().bottom - fb.getBoundingClientRect().top + 12;
    if (need <= 0) return;
    try { window.scrollBy({ top: need, behavior: 'smooth' }); } catch (e) { window.scrollBy(0, need); }
  }

  function syncReveal(show) {
    var rest = root.querySelector('[data-rest]');
    if (rest) rest.classList.toggle('show', !!show);
  }

  function syncZip() {
    var box = root.querySelector('[data-zip-check]');
    if (box) box.innerHTML = zipMsgHtml();
  }

  function syncIdeal(d) {
    var box = root.querySelector('[data-ideal-check]');
    if (box) box.innerHTML = idealMsgHtml(d);
    var rbox = root.querySelector('[data-weight-check]');
    if (rbox) rbox.innerHTML = rangeMsgHtml(d);
  }

  /* ---------- events ---------- */

  function sanitize(value, type) {
    if (type === 'zip') return value.replace(/[^0-9]/g, '').slice(0, 5);
    if (type === 'age') return value.replace(/[^0-9]/g, '').slice(0, 2);
    if (type === 'weight' || type === 'ideal' || type === 'bulk-ideal') return value.replace(/[^0-9.]/g, '').slice(0, 5);
    if (type === 'bulk-phone' || type === 'waitlist-phone') return value.replace(/[^0-9()+\-.\s]/g, '').slice(0, 20);
    return value;
  }

  function refreshBulkSend() {
    var btn = root.querySelector('.onb2-bulklead-send');
    if (btn) btn.disabled = !bulkLeadReady();
  }

  root.addEventListener('input', function (e) {
    var t = e.target;
    var kind = t.getAttribute('data-in');
    if (!kind) return;
    var clean = sanitize(t.value, kind);
    if (clean !== t.value) t.value = clean;
    var c = cur();
    var di = c.dog != null ? c.dog : 0;
    switch (kind) {
      case 'dogcount': {
        var v = parseInt(clean, 10); if (isNaN(v)) v = 0; if (v < 0) v = 0; if (v > 4) v = 4;
        if (String(v) !== clean && clean !== '') t.value = String(v);
        var dogs = S.dogs.slice(0, Math.max(1, v));
        while (dogs.length < Math.max(1, v)) dogs.push(newDog());
        set({ dogCount: v, dogs: dogs });
        var rowsBox = root.querySelector('[data-name-rows]');
        if (rowsBox) rowsBox.innerHTML = nameRowsHtml();
        syncMe();
        // multi-dog homes: surface the bulk-pack offer once, automatically
        if (!BULK_ON && v > 1 && !S.bulkSeen) { set({ bulkSeen: true, bulkModal: true }); render(); return; }
        break;
      }
      case 'name': {
        updateDog(parseInt(t.getAttribute('data-idx'), 10), { name: clean });
        t.classList.toggle('filled', trim(clean).length > 0);
        syncMe();
        break;
      }
      case 'owner': {
        set({ ownerFirst: clean });
        t.classList.toggle('filled', trim(clean).length > 0);
        syncReveal(trim(clean).length > 0);
        break;
      }
      case 'zip': {
        var wasServed = zipServed();
        set({ zip: clean });
        t.classList.toggle('filled', clean.length > 0);
        syncReveal(zipOk());
        syncZip();
        // CTA label and enabled-state both depend on whether we serve this ZIP, and both
        // live in the fixed footbar — repaint it only when that answer actually changes
        if (wasServed !== zipServed()) refreshFootbar();
        break;
      }
      case 'email': {
        set({ email: clean });
        t.classList.toggle('filled', emailOk(clean));
        var hint = root.querySelector('[data-email-hint]');
        if (hint) hint.innerHTML = emailHintHtml();
        scheduleEmailCapture();
        break;
      }
      case 'age': {
        updateDog(di, { age: clean });
        t.classList.toggle('filled', trim(clean) !== '');
        syncReveal(parseFloat(clean) > 0);
        // singular/plural on the unit select
        var unitSel = root.querySelector('select[data-sel="age-unit"]');
        if (unitSel) {
          var one = trim(clean) === '1';
          if (unitSel.options[0]) unitSel.options[0].text = one ? 'year' : 'years';
          if (unitSel.options[1]) unitSel.options[1].text = one ? 'month' : 'months';
          fitSelects();
        }
        break;
      }
      case 'weight': {
        updateDog(di, { weight: clean });
        t.classList.toggle('filled', trim(clean) !== '');
        syncReveal(parseFloat(clean) > 0);
        syncIdeal(S.dogs[di]);
        break;
      }
      case 'ideal': {
        updateDog(di, { idealWeight: clean });
        t.classList.toggle('filled', trim(clean) !== '');
        syncIdeal(S.dogs[di]);
        break;
      }
      case 'brand': {
        updateDog(di, { brand: clean });
        t.classList.toggle('filled', trim(clean) !== '');
        break;
      }
      case 'breed-query': {
        S.breedQuery = clean;
        var list = root.querySelector('[data-breed-list]');
        if (list) {
          var html = breedListHtml(S.dogs[di], trim(clean).toLowerCase());
          list.innerHTML = html;
          list.classList.toggle('open', !!html);
        }
        break;
      }
      case 'rx-email': {
        S.rxEmail = clean; persist();
        var send = root.querySelector('[data-act="rx-send"]');
        if (send) send.disabled = !rxEmailValid();
        break;
      }
      case 'waitlist-email': {
        S.waitlistEmail = clean; persist();
        var wlSend = root.querySelector('[data-act="waitlist-send"]');
        if (wlSend) wlSend.disabled = !waitlistValid();
        break;
      }
      case 'waitlist-phone': { S.waitlistPhone = clean; persist(); break; }
      case 'bulk-ideal': {
        updateDog(parseInt(t.getAttribute('data-idx'), 10), { idealWeight: clean });
        break;
      }
      case 'bulk-name': {
        updateDog(parseInt(t.getAttribute('data-idx'), 10), { name: clean });
        var prev = root.querySelector('[data-bulk-preview]');
        if (prev) prev.textContent = bulkLeadMsg();
        break;
      }
      case 'bulk-phone': { set({ bulkPhone: clean }); break; }
      case 'news-email': { set({ email: clean }); scheduleEmailCapture(); break; }
    }
    if (S.bulkLeadModal) refreshBulkSend();
    refreshFootbar();
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    var sel = t.getAttribute('data-sel');
    if (!sel) return;
    var c = cur();
    var di = c.dog != null ? c.dog : 0;
    var map = {
      'belief': function (v) { set({ belief: v }); },
      'gender': function (v) { updateDog(di, { sex: v }); },
      'age-unit': function (v) { updateDog(di, { ageUnit: v }); },
      'spay': function (v) { updateDog(di, { fixed: v }); },
      'adj': function (v) { updateDog(di, { adj: v }); },
      'food-type': function (v) { updateDog(di, { foodType: v }); },
      'treats': function (v) { updateDog(di, { treats: v }); },
      'has-issues': function (v) { updateDog(di, { hasIssues: v }); },
      'rx': function (v) { updateDog(di, { rx: v }); }
    };
    if (map[sel]) { map[sel](t.value); render(); }
  });

  // tap-outside-to-close, one entry per overlay attribute: [attr, closer, needsFullRender].
  // bulk-lead needs a FULL render: its inputs edit dog names/ideal weights shown on the screen behind.
  var OVERLAY_CLOSERS = [
    ['data-act-overlay', function () { if (S.recipeModal) S.recipeModal = ''; else S.rxModal = false; }],
    ['data-act-pickeroverlay', function () { if (S.recipeSel.length > 0) S.recipePicker = false; }],
    ['data-act-infooverlay', function () { S.infoModal = false; }],
    ['data-act-whyoverlay', function () { S.whyModal = false; }],
    ['data-act-footeroverlay', function () { S.footerModal = ''; }],
    ['data-act-nutrioverlay', function () { S.nutritionModal = false; }],
    ['data-act-bulkoverlay', function () { S.bulkModal = false; }],
    ['data-act-bulkleadoverlay', function () { S.bulkLeadModal = false; }, true],
    ['data-act-portionoverlay', function () { S.portionModal = false; }],
    ['data-act-mixoverlay', function () { S.bulkMixModal = false; bulkDraft = null; }]
  ];

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    for (var oi = 0; oi < OVERLAY_CLOSERS.length; oi++) {
      var ov = e.target.closest('[' + OVERLAY_CLOSERS[oi][0] + ']');
      if (ov && e.target === ov) { OVERLAY_CLOSERS[oi][1](); (OVERLAY_CLOSERS[oi][2] ? render : renderModals)(); return; }
    }
    // tap-away closes the breed dropdown
    var wrap = root.querySelector('[data-searchwrap]');
    if (wrap && !wrap.contains(e.target)) {
      var bl = root.querySelector('[data-breed-list]');
      if (bl) bl.classList.remove('open');
    }
    if (!btn) return;
    var act = btn.getAttribute('data-act');
    var c = cur();
    var di = c.dog != null ? c.dog : 0;
    var d = curDog();

    switch (act) {
      case 'begin': go(1); break;
      case 'hero-mute': {
        heroUnmuted = !heroUnmuted;
        var hmv = root.querySelector('.onb2-land-hero video');
        if (hmv) {
          hmv.muted = !heroUnmuted;
          if (heroUnmuted) { var pr = hmv.play(); if (pr && pr.catch) pr.catch(function () {}); }
        }
        var hmBtn = root.querySelector('.onb2-hero-mute');
        if (hmBtn) { hmBtn.innerHTML = heroMuteIcon(); hmBtn.classList.toggle('is-on', heroUnmuted); }
        break;
      }
      case 'intro-next': go(S.stepIdx + 1); break;
      case 'info-open': S.infoRecipe = ''; S.infoModal = true; renderModals(); break;
      case 'info-close': S.infoModal = false; renderModals(); break;
      case 'info-begin': S.infoModal = false; go(1); break;
      case 'bowl-modal': {
        // open the ingredients/nutrition modal at whichever bowl is currently most visible
        var slides = root.querySelectorAll('.onb2-bowlslide');
        var pick = '', bestOp = -1;
        slides.forEach(function (s) {
          var op = parseFloat(getComputedStyle(s).opacity) || 0;
          if (op > bestOp) { bestOp = op; pick = s.getAttribute('data-recipe') || ''; }
        });
        S.infoRecipe = pick; S.infoModal = true; renderModals();
        break;
      }
      case 'why-open': S.whyModal = true; renderModals(); break;
      case 'why-close': S.whyModal = false; renderModals(); break;
      case 'bulk-open': set({ bulkModal: true, bulkSeen: true }); renderModals(); break;
      case 'bulk-close': set({ bulkModal: false }); renderModals(); break;
      case 'bulk-skip': set({ consolidate: false, bulkModal: false }); renderModals(); break;
      case 'bulk-continue': set({ consolidate: true, bulkModal: false, bulkLeadModal: true }); renderModals(); break;
      case 'bulk-lead-skip': set({ bulkLeadModal: false }); render(); break; // full: modal may have edited names/weights
      // NOTE: keeps bulkLeadSent=true — the me-screen chip stays and duplicate leads are blocked
      case 'bulk-lead-close': set({ bulkLeadModal: false }); render(); break;
      case 'bulk-add-dog': {
        if (S.dogCount >= 4) break;
        var dogsA = S.dogs.slice(); dogsA.push(newDog());
        set({ dogCount: S.dogCount + 1, dogs: dogsA });
        render();
        break;
      }
      case 'bulk-remove-dog': {
        var ri = parseInt(btn.getAttribute('data-idx'), 10);
        if (S.dogCount <= 1) {
          // going under 1 dog -> bail to the first (count) screen and close the modal
          set({ bulkModal: false, bulkLeadModal: false, bulkSeen: false, consolidate: false, dogCount: 1, dogs: [newDog()] });
          go(stepIndexOf('me'));
          break;
        }
        var dogsR = S.dogs.slice(); dogsR.splice(ri, 1);
        set({ dogCount: S.dogCount - 1, dogs: dogsR });
        render();
        break;
      }
      case 'bulk-lead-send': {
        if (!bulkLeadReady()) break;
        set({ capturedEmail: trim(S.email) });
        sendFunnel('bulk-lead'); // -> BigQuery: the team's manual-follow-up trigger
        set({ bulkLeadSent: true });
        render();
        break;
      }
      case 'why-begin': S.whyModal = false; go(1); break;
      case 'digest-open': S.footerModal = 'digest'; renderModals(); break;
      case 'affiliates-open': S.footerModal = 'affiliates'; renderModals(); break;
      case 'vet-open': S.footerModal = 'vet'; renderModals(); break;
      case 'footer-close': S.footerModal = ''; renderModals(); break;
      case 'nutri-close': S.nutritionModal = false; renderModals(); break;
      case 'footer-begin': S.footerModal = ''; go(1); break;
      case 'news-submit': {
        // footer newsletter -> Klaviyo list + warehouse (source of truth)
        var ne = root.querySelector('[data-in="news-email"]');
        var nv = ne ? trim(ne.value) : '';
        if (!emailOk(nv)) { if (ne) ne.focus(); break; }
        var newCapture = nv !== S.capturedEmail; // same guard as scheduleEmailCapture -> no duplicate rows
        set({ email: nv, capturedEmail: nv });
        if (newCapture) sendFunnel('newsletter-signup');
        klaviyoSubscribe(nv);
        btn.textContent = '✓ Subscribed';
        btn.disabled = true;
        break;
      }
      case 'email-fix': {
        set({ email: btn.getAttribute('data-fix') || '' });
        render();
        scheduleEmailCapture();
        break;
      }
      case 'vet-prev':
      case 'vet-next': {
        vetIdx = (vetIdx + (act === 'vet-next' ? 1 : 2)) % 3;
        var qv = VETQUOTES[vetIdx % 3];
        var qEl = root.querySelector('[data-vet-quote]');
        var nEl = root.querySelector('[data-vet-name]');
        var cEl = root.querySelector('[data-vet-counter]');
        if (qEl) qEl.textContent = '“' + qv[0] + '”';
        if (nEl) nEl.textContent = qv[1];
        if (cEl) cEl.textContent = ((vetIdx % 3) + 1) + ' / 3';
        break;
      }
      case 'back': {
        var idx = S.stepIdx - 1;
        var f = flow();
        while (idx > 0 && f[idx].t === 'calc') idx--;
        clearInterval(calcTimer);
        go(idx);
        break;
      }
      case 'restart': {
        clearInterval(calcTimer);
        S = freshState();
        persist();
        render();
        try { window.scrollTo({ top: 0 }); } catch (err) {}
        break;
      }
      case 'card': {
        var field = btn.getAttribute('data-field');
        var ci = parseInt(btn.getAttribute('data-idx'), 10);
        var patch = {};
        patch[field] = ci;
        // "Just right" (index 1) is the one body answer that does NOT ask for an ideal
        // weight — so drop any ideal typed under a previous answer. Leaving it behind
        // silently sized the plan (price, variant, cart line) to the stale number:
        // a 120 lb dog with "100" left over priced as 100 lb, and with a lone "." left
        // over parsed as NaN -> resolveVariant()'s 30 lb fallback ($8.09/day).
        if (field === 'body' && ci === 1) patch.idealWeight = '';
        updateDog(di, patch);
        render();
        break;
      }
      case 'breed-add': {
        updateDog(di, { breeds: d.breeds.concat([btn.getAttribute('data-name')]) });
        S.breedQuery = '';
        S.breedAdding = false;
        render();
        revealAddBreed();
        break;
      }
      case 'breed-remove': {
        var name = btn.getAttribute('data-name');
        updateDog(di, { breeds: d.breeds.filter(function (x) { return x !== name; }) });
        render();
        break;
      }
      case 'breed-unknown': {
        if (d.breeds.indexOf('Unknown Mix') < 0) updateDog(di, { breeds: d.breeds.concat(['Unknown Mix']) });
        S.breedQuery = '';
        S.breedAdding = false;
        render();
        revealAddBreed();
        break;
      }
      case 'add-breed': {
        S.breedAdding = true;
        render();
        var inp = root.querySelector('[data-in="breed-query"]');
        if (inp) inp.focus();
        break;
      }
      case 'issue': {
        var label = btn.getAttribute('data-name');
        var on = d.issues.indexOf(label) >= 0;
        updateDog(di, { issues: on ? d.issues.filter(function (x) { return x !== label; }) : d.issues.concat([label]) });
        render();
        break;
      }
      case 'next': {
        // A double-tap used to advance twice: the first tap re-renders synchronously and the
        // second lands on the NEXT step's Continue at the same fixed footer position. Steps
        // that validate with no input (Current food, Health) were skipped unseen — and still
        // logged a "completed" event. Debounce the ADVANCE action only; go() itself must stay
        // unguarded because the calc interstitial auto-advances through it on a timer.
        var nowTs = Date.now();
        if (nowTs - lastAdvanceAt < 500) break;
        lastAdvanceAt = nowTs;
        // out-of-area ZIP: open the waitlist once, then block — we can't ship outside FL
        if (c.t === 'contact' && zipOk() && !zipServed()) {
          if (!S.waitlistSent) { S.waitlistModal = true; S.waitlistEmail = S.waitlistEmail || S.email; renderModals(); }
          break;
        }
        // prescription-diet dogs: open the referral once, then block — never advance the funnel
        if (c.t === 'health' && d.rx === 'does') {
          if (!d.referralSent) { S.rxModal = true; S.rxEmail = S.rxEmail || S.email; renderModals(); }
          break;
        }
        if (!canNext(c, d)) break;
        // The feeding step shows pre-portioned selected when bulk can't be sold to this pack
        // (wholesale size / catalog gap). Make the state say the same, so an earlier bulk pick
        // can't silently return when a portion change makes bulk sellable again.
        if (c.t === 'feeding' && S.bulkFormat === 'bulk' && !bulkSellable(bulkOfferPlan())) set({ bulkFormat: 'pre' });
        go(S.stepIdx + 1);
        break;
      }
      case 'rx-close': S.rxModal = false; renderModals(); break;
      case 'waitlist-close': S.waitlistModal = false; renderModals(); break;
      case 'waitlist-send': {
        if (!waitlistValid()) break;
        var wlAddr = trim(waitlistEmailVal());
        // sendFunnel bails on an invalid S.email; fall back to the address they just gave
        // rather than dropping the lead (same guard as the referral send).
        if (!emailOk(trim(S.email))) set({ email: wlAddr, capturedEmail: wlAddr });
        S.waitlistModal = false;
        set({ waitlistSent: true, waitlistEmail: wlAddr }); // persist BEFORE the send so the snapshot carries it
        sendFunnel('waitlist-signup');
        render();
        break;
      }
      case 'rx-send': {
        if (!rxEmailValid()) break;
        // This used to flip a boolean in localStorage and nothing else, while the UI said
        // "referral request sent" — so every prescription-diet lead was silently lost.
        // Now it actually transmits, through the sink that every other step already uses.
        var rxAddr = rxEmailVal();
        // sendFunnel() bails on an invalid S.email. Contact (step 4) makes that impossible
        // in the normal flow, but fall back to the address they just confirmed rather than
        // drop the referral on the floor if it ever happens.
        if (!emailOk(trim(S.email))) set({ email: rxAddr, capturedEmail: rxAddr });
        S.rxModal = false;
        updateDog(di, { referralSent: true }); // persist BEFORE the send so the snapshot carries it
        sendFunnel('rx-referral');
        render();
        break;
      }
      case 'p2-portion': set({ p2Portion: btn.getAttribute('data-key') }); render(); break;
      case 'recipe-picker': S.recipePicker = true; renderModals(); break;
      case 'recipe-picker-close': if (S.recipeSel.length > 0) { S.recipePicker = false; renderModals(); } break;
      case 'p2-checkout': {
        // The add chain takes ~4 s on a slow connection with zero feedback, so people tap
        // again and fire a second full add. Guard re-entry and show progress on the button
        // itself — NOT via render(), which rebuilds root.innerHTML and would drop this node.
        if (btn.disabled) break;
        sendFunnel('checkout-click');
        var isBulk = BULK_ON && bulkActive();
        var trialItems = isBulk ? buildBulkCartItems() : buildTrialCartItems();
        if (trialItems) {
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = 'Adding…';
          postTrialCheckout(trialItems, btn, isBulk ? 'bowl_builder_bulk' : 'bowl_builder_trial');
        }
        else if (!commerceReady()) { set({ started: true }); render(); } // demo mode: commerce config not wired
        else { alert('Sorry — we couldn’t start checkout. Please try again.'); } // wired but unresolvable -> never fake success
        break;
      }
      // feeding-step cards and the plan page's switch links share this: an explicit choice of format
      case 'bulk-format': {
        var toFmt = btn.getAttribute('data-key') === 'bulk' ? 'bulk' : 'pre';
        var fmtPatch = { bulkFormat: toFmt, formatPicked: true };
        // An untouched default recipe set follows the format (pre-portioned: Turkey + Beef; bulk: the
        // cheapest mix the offer quoted). Recipes the shopper chose, or a saved bag mix, stay.
        if (!S.bulkMix && Array.isArray(S.recipeSel) && S.recipeSel.length && sameKeys(S.recipeSel, defaultRecipesFor(S.bulkFormat))) fmtPatch.recipeSel = defaultRecipesFor(toFmt);
        set(fmtPatch); sendFunnel('bulk-format'); render();
        // The two formats' bulk sections differ in height and render() keeps scrollY, so bring the
        // section back to the top of the screen instead of leaving the shopper somewhere unrelated.
        if (cur().t === 'plan') { try { var bkSec = root.querySelector('[data-bulk-block]'); if (bkSec) window.scrollTo({ top: Math.max(0, bkSec.getBoundingClientRect().top + (window.pageYOffset || 0) - 12) }); } catch (e) {} }
        break;
      }
      case 'bulk-mix-open': {
        var P0 = bulkPlan(); bulkDraft = {};
        if (P0 && !P0.wholesale) { for (var k0 in P0.trialMix) bulkDraft[k0] = P0.trialMix[k0]; }
        S.bulkMixModal = true; renderModals(); break;
      }
      case 'bulk-mix-inc': { var ki = btn.getAttribute('data-key'); bulkDraft = bulkDraft || {}; bulkDraft[ki] = (bulkDraft[ki] || 0) + 1; renderModals(); break; }
      case 'bulk-mix-dec': { var kd = btn.getAttribute('data-key'); bulkDraft = bulkDraft || {}; bulkDraft[kd] = Math.max(0, (bulkDraft[kd] || 0) - 1); renderModals(); break; }
      case 'bulk-mix-clear': bulkDraft = {}; renderModals(); break;
      case 'bulk-mix-spread': {
        var PVs = bulkPreview(bulkDraft || {}) || bulkPlan({ mix: null }), ns = PVs && !PVs.wholesale ? PVs.trialRecommended : 2;
        var ks = bulkKeysWithBags(bulkDraft || {}); if (!ks.length) ks = bulkDefaultKeys();
        ks = ks.slice(0, Math.min(3, ns)); bulkDraft = {};
        ks.forEach(function (k, i) { bulkDraft[k] = Math.floor(ns / ks.length) + (i < ns % ks.length ? 1 : 0); });
        renderModals(); break;
      }
      case 'bulk-mix-cancel': S.bulkMixModal = false; bulkDraft = null; renderModals(); break;
      case 'bulk-mix-save': {
        var tot = 0; for (var kt in (bulkDraft || {})) tot += bulkDraft[kt] || 0;
        if (!tot) break;
        var keys = bulkKeysWithBags(bulkDraft);
        set({ bulkMix: bulkSameMix(bulkDraft, bulkDefaultTrialMix()) ? null : bulkDraft, recipeSel: keys });
        S.bulkMixModal = false; bulkDraft = null;
        sendFunnel('bulk-mix');
        render(); break;
      }
      case 'p2-nutrition': S.nutritionModal = true; renderModals(); break;
      case 'portion-details': S.portionModal = true; renderModals(); break;
      case 'portion-close': S.portionModal = false; renderModals(); break;
      case 'recipe-toggle': {
        var key = btn.getAttribute('data-key');
        var has = S.recipeSel.indexOf(key) >= 0;
        if (has) set({ recipeSel: S.recipeSel.filter(function (x) { return x !== key; }), bulkMix: null });
        else if (S.recipeSel.length < 3) set({ recipeSel: S.recipeSel.concat([key]), bulkMix: null });
        render();
        break;
      }
      case 'recipe-facts': S.recipeModal = btn.getAttribute('data-key'); renderModals(); break;
      case 'recipe-close': S.recipeModal = ''; renderModals(); break;
      case 'jump-toggle': S.jumpOpen = !S.jumpOpen; render(); break;
      case 'jump-go': {
        S.jumpOpen = false;
        clearInterval(calcTimer);
        go(parseInt(btn.getAttribute('data-idx'), 10));
        break;
      }
    }
  });

  // keyboard access for role=button elements (e.g. the bowl carousel): Enter/Space = click
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest ? e.target.closest('[role="button"][data-act]') : null;
    if (!el) return;
    e.preventDefault();
    el.click();
  });

  /* ---------- boot ---------- */

  render();
  if (cur().t === 'calc') startCalc();
})();
